(function() {
    'use strict';

    angular
        .module('sprintApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.ace',
            'ngJsTree',
            'bootstrapLightbox',
            'toggle-switch',
            'ui.select',
            'ngSanitize',
            'dc.inputAddOn',
            'angularTrix',
            'pdf'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }

    function isChromeOrFirefox() {
        var is_firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
        var is_chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
        var is_edge = window.navigator.userAgent.indexOf("Edge") > -1;
        return (is_firefox || is_chrome) && !is_edge;
    }

    if(!isChromeOrFirefox())
        $('.browsehappy').show();
})();

(function () {
    'use strict';

    angular
        .module('sprintApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/flows/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('flows/api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');

                    // flag per vedere le informazioni di debug
                    $rootScope.isDevelopment = true;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('sprintApp')
        .factory('utils', Utils);

    Utils.$inject = ['$log', '$http'];

    function Utils($log, $http) {

        function isObject(value) {
            if (value === null ||
                typeof value !== 'object' ||
                Object.prototype.toString.call(value) === "[object File]" ||
                (Object.prototype.toString.call(value) === "[object Array]" && value.length > 0 && Object.prototype.toString.call(value[0]) === "[object File]"))
                return false;

            return true;
        }

        function swap(entity) {
            entity.variabili = {};
            entity.variables.forEach(function (el) {

                if (el.valueUrl)
                    entity.variabili[el.name] = el.valueUrl
                else {
                    var date = moment(el.value, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true);
                    entity.variabili[el.name] = date.isValid() ? date.toDate() : el.value;
                }
            });
            return entity;
        }

        return {
            refactoringVariables: function (input) {
                if (Array.isArray(input)) {
                    input.forEach(swap);
                    return input;
                } else {
                    return swap(input);
                }
            },

            downloadFile: function (url, filename, mimetype) {
                $log.info(url);
                $http.get(url, {
                    responseType: 'arraybuffer'
                })
                    .success(function (data) {
                        var file = new Blob([data], {
                            type: mimetype
                        });
                        $log.info(file, filename);
                        saveAs(file, filename);
                    });
            },
            //todo: viene usato SOLO in active-flows.controller.js: rimuovere la pagina o aggiornare la chiamata
            oldPopulateTaskParams: function (fields) {
                var processParams = [], //alcuni parametri delle ricerche dei task riguardano anche la ProcessInstance
                    taskParams = [];

                fields.forEach(function (field) {
                    var fieldName = field.getAttribute('id').replace('searchField-', ''),
                        appo = {};
                    if (field.value !== "") {
                        appo["key"] = fieldName;
                        appo["value"] = field.value;
                        appo["type"] = field.getAttribute("type");
                        if (field.id.includes("initiator") || field.id.includes("titolo")) {
                            processParams.push(appo);
                        } else {
                            taskParams.push(appo);
                        }
                    }
                });
                return {
                    "processParams": processParams,
                    "taskParams": taskParams
                };
            },
            populateTaskParams: function (searchParams) {
                var searchParamsToSent = [];
                if (searchParams) {
                    $.map(searchParams, function (value, key) {
                        if (value) {
                            var appo = {};
                            appo.type = (value.toString().indexOf('=') !== -1 ) ? value.substr(0, value.indexOf('=') + 1) : value;
                            appo.key = key;
                            appo.value = value.substr(value.indexOf('=') + 1);
                            //serve per in caso di cancellazione di un parametro di ricerca
                            if(appo.value !== "")
                                searchParamsToSent.push(appo);
                        }
                    });
                }
                return searchParamsToSent;
            },
            oldPopulateProcessParams: function (fields) {
                var processParams = {};

                fields.forEach(function (field) {
                    var fieldName = field.getAttribute('id').replace('searchField-', '');
                    if (field.value !== "")
                        processParams[fieldName] = field.getAttribute("type") + "=" + field.value;
                });
                return processParams;
            },
            populateProcessParams: function (fields) {
                var processParams = [],
                    taskParams = [];
                if (searchParams) {
                    $.map(searchParams, function (value, key) {
                        if (value) {
                            var appo = {};
                            appo.type = value.substr(0, value.indexOf('=') + 1);
                            appo.key = key;
                            appo.value = value.substr(value.indexOf('=') + 1);
                            processParams.push(appo);
                        }
                    });
                }
                return {
                    'processParams': processParams,
                    'taskParams': taskParams,
                };
            },
            parseAttachments: function (attachments) {
                for (var attachment in attachments) {
                    for (var metadato in attachments[attachment].metadati) {
                        attachments[attachment][metadato] = attachments[attachment][metadato] || attachments[attachment].metadati[metadato];
                    }

                    var date = moment(attachments[attachment].dataProtocollo);
                    attachments[attachment].dataProtocollo = date.isValid() ? date.toDate() : attachments[attachment].dataProtocollo;

                    delete attachments[attachment].bytes;
                    delete attachments[attachment].metadati
                }
                return attachments;
            },

            prepareForSubmit: function (data, attachments) {

                for (var attName in attachments) {
                    var att = attachments[attName];
                    if (att.aggiorna) { // non copiare allegati non aggiornati
                        for (var property in att) {
                            data[attName + "_" + property] = att[property];
                        }
                    }
                }
                if (_.has(data, 'entity')) {
                    delete data.entity;
                }
                // aggiunto (&& obj[key].constructor.name !== 'Date') per non rendere json le date
                angular.forEach(data, function (value, key, obj) {
                    if (isObject(value) && key !== 'entity' && obj[key].constructor.name !== 'Date') {
                        obj[key + "_json"] = JSON.stringify(value);
                    }
                });
            },



            loadSearchFields: function (processDefinitionKey, isTaskQuery) {
                var formUrl = undefined;
                //Al caricamento della pagina, la processDefinitionKey è 'undefined'
                //(null in caso di cancellazione della select) ==> carico la form per tutte le PD('all')
                if (processDefinitionKey === undefined || processDefinitionKey === null) {
                    processDefinitionKey = 'all';
                }
                if (isTaskQuery) {
                    formUrl = 'api/forms/' + processDefinitionKey + '/1/search-ti';
                } else {
                    formUrl = 'api/forms/' + processDefinitionKey + '/1/search-pi';
                }
                return formUrl;
            }
        };
    }
})();
(function() {
  'use strict';

  angular.module('sprintApp')
  .factory('dataServiceDeprecated', Data);


  Data.$inject = ['$http', '$location', '$rootScope', '$log', '$sessionStorage'];

  function Data ($http, $location, $rootScope, $log, $sessionStorage) {

    var development = $location.$$port === 9000; //GRUNT PORT;
    var proxy = 'proxy';
    var base = 'rest/';

    $rootScope.development = development;

    function ajax (url, settings) {
      var defaults = {
          method: 'GET',
          headers: {
            'X-CNR-Client': 'flowsApp',
            'X-alfresco-ticket': $sessionStorage.ticket
          }
      };

      var conf = _.extend({
        url: base + url
      }, defaults, settings);

      $log.debug(conf);

      return $http(conf);
    }

    return {
      urls: {
        drop: base + 'drop',
        dropupdate: base + 'drop-update',
        proxy: base + proxy + '/',
        content: base + proxy + '/service/api/node/content/workspace/SpacesStore',
        person: base + proxy + '/service/cnr/person/autocomplete-person',
        instances: base + 'instances',
        bulkinfotest: base + 'bulkinfotest',
        metadata: base + 'metadata'
      },
      descendants: function (id) {
        return ajax('descendants', {
          params: {
            id: id
          }
        });
      },
      groupMembers: function (id, format) {
        return ajax('authority/members?id='+ id +'&format='+format);
      },
      search: function (params) {

        var defaultParams = {
            maxItems: 10,
            skipCount: 0,
            fetchCmisObject: false,
            calculateTotalNumItems: false
        };

        return ajax('search', {
          params: _.extend({}, defaultParams, params)
        });
      },
      security: {
        login: function (username, password) {
          return ajax('security/login', {
            method: 'POST',
            data: {
              username: username,
              password: password
            }
          });
        },
        logout: function () {
          return ajax('security/logout', {
            method: 'DELETE'
          });
        }
      },
      common: function () {
        return ajax('common');
      },
      i18n: function () {
        return ajax('i18n');
      },
      bulkInfo: function (key, name, type) {
        return ajax('bulkInfo/view/' + key + '/' + (type || 'form') + '/' + (name || 'default'));
      },
      bulkInfoTest: function (xml) {
        return ajax('bulkInfoTest', {method: 'POST', headers: { "Content-Type": 'application/xml' }, data: xml});
      },
      processinstances: {
        myinstances: function (params) {
          return ajax('processinstances/myinstances', {
            params: params || {}
          });
        },
        startProcessInstance: function (processName, data) {
          return ajax('processinstances/start/'+ processName, {
            method: 'GET',
            data: data
          });
        },
        completeTask: function (taskId, data) {
          return ajax('taskinstances/complete/'+ taskId, {
            method: 'POST',
            data: data
          });
        },
        getTaskInstance: function (params, id) {
          return ajax('taskinstances/'+ id, {
            params: params
          });
        },
        assignTask: function (id, data) {
          return ajax('taskinstances/'+ id, {
            method: 'PUT',
            data: data
          });
        },
        claimTask: function (id) {
          return ajax('taskinstances/claim/'+ id, {
            method: 'PUT'
          });
        },
        unclaimTask: function (id) {
          return ajax('taskinstances/unclaim/'+ id, {
            method: 'PUT'
          });
        },
        processes: function (params) {
          return ajax('processinstances/processes', {
            params: params || {}
          });
        },
        workflowDefinitions: function (definitionId) {
          return ajax('workflowResource/workflowDefinitions', {
            params: {
              definitionId: definitionId
            }
          });
        },
        workflowInstancesById: function (id) {
          return ajax('processinstances/' + id, {
            params: {
              includeTasks: true
            }
          });
        },
        workflowVariableById: function (id) {
          return ajax('processinstances/variables/' + id.substring(id.indexOf('$') + 1))
        },
        taskVariableById: function (id) {
          return ajax('taskinstances/variables/' + id.substring(id.indexOf('$') + 1));
        },
        myTasks: function (params) {
          return ajax('taskinstances/mytasks', {
            params: params || {}
          });
        },
        myTasksAvailable: function (params) {
          return ajax('taskinstances/mytasksavailable', {
            params: params || {}
          });
        },
        processDefinitions: function (where) {
          return ajax('workflowResource/processDefinitions', {
            params: {
              where: where
            }
          });
        },
        deleteWorkflow: function (id) {
          return ajax('processinstances/deleteWorkflow', {
            method: 'DELETE',
            params: {
              workflowId: id.split('$')[1]
            }
          });
        }
        // missioni: {
        //   bulkInfo: function () {
        //     return ajax(proxy + '_nodes', {
        //       params: {
        //         backend: 'missioni',
        //       }
        //     });
        //   }
        // }
      },
      metadata: {
        byNodeRef: function (params) {
          return ajax('metadata', {
            params: params
          });
        },
        byId: function (qname, id) {
          return ajax('metadataById', {
            params: {
              properties: qname,
              assignedByMeWorkflowIds: id
            }
          });
        }
      },
      authority: {
        groups: {
//        todo: da testare la chiamata dall'applicazione
          myGroupsDescendant: function (userId) {
            return ajax('authority/myGroupsDescendant', {
              params: {
                userId: userId
              }
            });
          }
        },
        person: {
//        todo: da testare la chiamata dall'applicazione
          whoami: function () {
            return ajax('authority/whoami');
          }
        },
        incarichi: function() {
          return ajax('authority/incarichi');
        },
        incarica: function(groupName, userName) {
          return ajax('authority/incarica', {
            method: 'PUT',
            data: {
              groupName: groupName,
              userName: userName
            }
          });
        },
        rimuoviIncarico: function(groupName, userName) {
          return ajax('authority/incarica?groupName='+groupName+'&userName='+userName, {
            method: 'DELETE'
          });
        }
      },

      // TODO deprecated
      proxySupervisor: {
        api: {
          workflowInstances: function (definitionName, params) {
            return ajax('processinstances/workflowInstances/' + definitionName, {
              params: {
                skipCount: params["skipCount"],
                maxItems: params["maxItems"],
                where: params["where"]
              }
            });
          },
          workflowInstanceById: function (id, workflowInstanceById) {
            return ajax('processinstances/workflowInstancesById/' + workflowInstanceById + '/' + id);
          },
//        workflowVariableById: function (id, workflowInstanceById) {
//        return ajax(supervisorProxy + '/workflow-variable/' + workflowInstanceById + '/' + id.substring(id.indexOf('$') + 1));
//        nuovo da testare
          workflowVariableById: function (id) {
            return ajax('processinstances/variables/' + id);
          }
        }
      },

      user: function() {
        return ajax('user');
      }
    };
  }
})();
(function () {
    'use strict';

    angular.module('sprintApp')
        .factory('dataService', Data);


    Data.$inject = ['$http', 'Upload'];

    function Data($http, Upload) {
        return {

            avvisi: {
                getAttivi: function () {
                    return $http.get('flows/api/avvisiattivi');
                }
            },
            authentication: {
                impersonate: function (username) {
                    return $http.get('impersonate/start?impersonate_username=' + username);
                },
                cancelImpersonate: function () {
                    return $http.get('impersonate/exit');
                },
            },
            tasks: {
                myTasks: function (processDefinition, firstResult, maxResults, order, params) {
                    return $http.post('api/tasks/mytasks?processDefinition=' + (processDefinition ? processDefinition : 'all') +
                        '&firstResult=' + firstResult +
                        '&maxResults=' + maxResults +
                        '&order=' + order, params);
                },
                myTasksAvailable: function (processDefinition, firstResult, maxResults, order, params) {
                    return $http.post('api/tasks/availabletasks?processDefinition=' + (processDefinition ? processDefinition : 'all') +
                        '&firstResult=' + firstResult +
                        '&maxResults=' + maxResults +
                        '&order=' + order, params);
                },
                complete: function (data) {
                    return $http.post('api/tasks/complete', data);
                },
                claim: function (id, take) {
                    return $http({
                        url: 'api/tasks/claim/' + id,
                        method: take ? 'PUT' : 'DELETE',
                    });
                },
                reassign: function (taskId, processInstanceId, assignee) {
                    return $http({
                        url: 'api/tasks/reassign/?' +
                            'assignee=' + assignee + '&' +
                            (taskId ? 'taskId=' + taskId + '&' : '') +
                            (processInstanceId ? 'processInstanceId=' + processInstanceId : ''),
                        method: 'PUT',
                    });
                },
                getTask: function (id) {
                    return $http.get('api/tasks/' + id);
                },
                getTaskCompletedByMe: function (processDefinition, firstResult, maxResults, order, params) {
                    return $http.post('api/tasks/taskCompletedByMe?processDefinition=' + (processDefinition ? processDefinition.key : 'all') +
                        '&firstResult=' + firstResult +
                        '&maxResults=' + maxResults +
                        '&order=' + order, params);
                },
                taskAssignedInMyGroups: function (processDefinition, firstResult, maxResults, order, params) {
                    return $http.post('api/tasks/taskAssignedInMyGroups?processDefinition=' + (processDefinition ? processDefinition : 'all') +
                        '&firstResult=' + firstResult +
                        '&maxResults=' + maxResults +
                        '&order=' + order, params);
                },
                getAttachments: function (taskId) {
                    return $http.get('api/attachments/task/' + taskId);
                },
                search: function (params) {
                    return $http.post('api/tasks/search/', params);
                }
            },
            processInstances: {
                byProcessInstanceId: function (processInstanceId, detail) {
                    return $http.get('api/processInstances' +
                        '?processInstanceId=' + processInstanceId +
                        '&detail=' + ((detail !== undefined) ? true : false));
                },
                myProcessInstances: function (processDefinitionKey, active, firstResult, maxResults, order, params) {
                    return $http.post('api/processInstances/myProcessInstances?active=' + active +
                        '&processDefinitionKey=' + (processDefinitionKey ? processDefinitionKey : 'all') +
                        '&order=' + order +
                        '&firstResult=' + firstResult +
                        '&maxResults=' + maxResults, params);
                },
                getAttachments: function (processInstanceId) {
                    return $http.get('api/attachments/' + processInstanceId);
                },
                attachmentHistory: function (processInstaceId, attachmentName) {
                    return $http.get('api/attachments/history/' + processInstaceId + '/' + attachmentName);
                },
                search: function (params) {
                    return $http.post('api/search/', params);
                },
                exportSummary: function (processInstaceId) {
                    return $http.get('api/summaryPdf?processInstanceId=' + processInstaceId);
                },
                deleteProcessInstance: function (processInstaceId, deleteReason) {
                    return $http.delete('api/processInstances/deleteProcessInstance?processInstanceId=' + processInstaceId + '&deleteReason=' + deleteReason);
                },
                setVariable: function (processInstanceId, variableName, value) {
                    return $http.post('api/processInstances/variable' +
                        '?processInstanceId=' + processInstanceId +
                        '&variableName=' + variableName +
                        '&value=' + value);
                },
                getVariable: function (processInstanceId, variableName) {
                    return $http.get('api/processInstances/variable?' +
                        'processInstanceId=' + processInstanceId +
                        '&variableName=' + variableName);
                },
                getHistoryForPi: function (processInstanceId) {
                    return $http.get('api/processInstances/getHistoryForPi?' +
                        'processInstanceId=' + processInstanceId);
                },
                revoca: function (processInstanceId) {
                    return $http.post('api/processInstances/revoca?' +
                        'processInstanceId=' + processInstanceId);                }
            },
            attachments: {
                pubblicaDocumento: function (processInstanceId, attachmentName, flag) {
                    return $http.post('/api/attachments/' + processInstanceId + '/' + attachmentName + '/pubblica?pubblica=' + flag);
                },
                pubblicaDocumentoTrasparenza: function (processInstanceId, attachmentName, flag) {
                    return $http.post('/api/attachments/' + processInstanceId + '/' + attachmentName + '/pubblicaTrasparenza?pubblica=' + flag);
                },
                pubblicaDocumentoUrp: function (processInstanceId, attachmentName, flag) {
                    return $http.post('/api/attachments/' + processInstanceId + '/' + attachmentName + '/pubblicaUrp?pubblica=' + flag);
                },
            },
            definitions: {
                all: function (includeSuspended) {
                    return $http.get('api/processDefinitions/all?'+ (includeSuspended?"includeSuspended=true":"") );
                },
                activate:  function (key) {
                    return $http.post('api/processDefinitions/activate/'+ key);
                },
                suspend: function (key) {
                    return $http.post('api/processDefinitions/suspend/'+ key);
                }
            },
            dynamiclist: {
                byName: function (name) {
                    return $http.get('api/dynamiclists/byname/' + name);
                },
            },
            sigladynamiclist: {
                byName: function (name) {
                    return $http.get('api/sigladynamiclist/byname/' + name);
                },
            },
            oil: {
                byCategory: function (category) {
                    return $http.get('api/proxy/OIL/?proxyURL=catg/HDSiper/');
                }
            },
            view: function (processid, version, type) {
                return $http.get('api/views/' + processid + '/' + version + '/' + type);
            },
            search: {
                users: function (filter) {
                    return $http.get('api/users/' + filter + '/search');
                },
                flowsUsers: function (filter) {
                    return $http.get('api/flows/users/' + filter + '/search');
                },
                flowsGroups: function (filter) {
                    return $http.get('api/cnrgroups/' + filter + '/search');
                },
                uo: function (filter) {
                    return $http.get('api/users/struttura/' + filter + '/search');
                },
                dipartimentiList: function (tipo) {
                    return $http.get('api/users/dipartimenti/' + tipo + '/search');
                },
                exportCsv: function (searchParams, firstResult, maxResults) {
                    var processDefinitionKey;
                    if (searchParams.processDefinitionKey !== undefined) {
                        processDefinitionKey = searchParams.processDefinitionKey;
                    } else {
                        processDefinitionKey = 'all';
                    }
                    return $http({
                        method: 'POST',
                        url: 'api/search/exportCsv/' + processDefinitionKey,
                        data: searchParams,
                        headers: {
                            "Accept": "text/csv; charset=utf-8, text/plain; charset=utf-8"
                        }
                    });
                },
                exportCsvAndSaveInProcess: function (searchParams, firstResult, maxResults) {
                    var processDefinitionKey;
                    if (searchParams.processDefinitionKey !== undefined) {
                        processDefinitionKey = searchParams.processDefinitionKey;
                    } else {
                        processDefinitionKey = 'all';
                    }
                    var processInstanceId = searchParams.processInstanceId;
                    return $http.post('api/search/exportCsvAndSaveInProcess/' + processDefinitionKey + '/' + processInstanceId +
                        '?active=' + searchParams.active +
                        '&order=' + searchParams.order +
                        '&firstResult=' + firstResult +
                        '&maxResults=' + maxResults, searchParams);
                },
                istituti: function(searchterm) {
                    return $http.get('api/users/istituti/' + searchterm);
                }
            },
            lookup: {
                uo: function (id) {
                    return $http.get('api/lookup/ace/uo/' + id);
                },
                users: function (username) {
                    return $http.get('api/lookup/ldap/user/' + username);
                },
                mycdsuos: function () {
                    return $http.get('api/lookup/ace/user/cdsuoabilitate');
                },
                mysedifirma: function () {
                    return $http.get('api/lookup/ace/user/sedirichiedentefirma');
                },
                mysediApprovvigionamenti: function () {
                    return $http.get('api/lookup/ace/user/sediRichiedenteApprovvigionamenti');
                },
                boss: function () {
                    return $http.get('api/lookup/ace/boss');
                }
            },
            mail: {
                isActive: function () {
                    return $http.get('api/mail/active');
                },
                setActive: function (active) {
                    return $http.post('api/mail/active?active=' + active);
                },
                getUsers: function () {
                    return $http.get('api/mail/users');
                },
                setUsers: function (users) {
                    return $http.post('api/mail/users?users=' + users);
                },
            },
            userMemberships: {
                groupsForUser: function () {
                    return $http.get('api/memberships/groupsForUser');
                },
                membersByGroupName: function (groupName) {
                    return $http({
                        url: 'api/memberships/membersByGroupName',
                        method: 'GET',
                        params: {
                            groupName: groupName,
                        },
                    });
                },
                createMembership: function (groupName, userName, groupRole) {
                    return $http({
                        url: 'api/createMemberships?',
                        method: 'POST',
                        params: {
                            groupName: groupName,
                            userName: userName,
                            groupRole: groupRole,
                        }
                    });
                },
            },
            exportStatistics: {
                pdf: function (processDefinitionKey, startDateGreat, startDateLess) {
                    return $http({
                        url: 'api/makeStatisticPdf?',
                        method: 'GET',
                        params: {
                            processDefinitionKey: processDefinitionKey,
                            startDateGreat: startDateGreat,
                            startDateLess: startDateLess,
                        },
                    });
                },
                csv: function (processDefinitionKey, startDateGreat, startDateLess) {
                    return $http({
                        url: 'api/makeStatisticCsv?',
                        method: 'GET',
                        params: {
                            processDefinitionKey: processDefinitionKey,
                            startDateGreat: startDateGreat,
                            startDateLess: startDateLess,
                        },
                    });
                }
            },
            helpdesk: {
                sendWithAttachment: function (data) {
                    return Upload.upload({
                        url: 'api/helpdesk/sendWithAttachment',
                        method: 'Post',
                        data: data,
                    });
                },
                sendWithoutAttachment: function (hdDataModel) {
                    return $http.post("api/helpdesk/sendWithoutAttachment", hdDataModel)
                }
            },
            manuali: {
                getElenco: function () {
                    return $http.get("api/manual");
                },
                getManuale: function (nameDoc) {
                    return $http({
                        url: 'api/manual/doc',
                        method: 'GET',
                        params: {
                            nameDoc: nameDoc
                        },
                        responseType: 'arraybuffer'
                    });
                }
            },
            faq: {
                getReadable: function () {
                    return $http.get("api/faqs/readable");
                },
                getReadableForProcessDefinition: function (procesDefinition) {
                    return $http.get("api/faqs/readableForProcessDefinition/" + procesDefinition);
                }
            },
            draft: {
                getDraftByTaskId: function (taskId, isShared) {
                    return $http({
                        url: 'api/draft/getDraftByTaskId',
                        method: 'GET',
                        params: {
                            taskId: taskId,
                            isShared: isShared
                        },
                    });
                },
                getDraftByProcessDefinitionId: function (processDefinitionId) {
                    return $http({
                        url: 'api/draft/getDraftByProcessDefinitionId',
                        method: 'GET',
                        params: {
                            processDefinitionId: processDefinitionId
                        }
                    });
                },
                updateDraft: function (taskId, json, processDefinitionId, isShared) {
                    return $http({
                        url: 'api/drafts/updateDraft?',
                        method: 'PUT',
                        params: {
                            taskId: taskId ? taskId : '',
                            processDefinitionId: processDefinitionId ? processDefinitionId: '',
                            isShared: isShared ? isShared : false
                        },
                        data: json
                    });
                }
            },
            signMany: function (username, password, otp, ids) {
                return $http({
                    url: "api/tasks/signMany",
                    method: 'POST',
                    params: {
                        username: username,
                        password: password,
                        otp: otp,
                        taskIds: ids
                    }
                })
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sprintApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                // Il formato delle authorities è un po' diverso in sprint3, lo devo mappare a mano (mtrycz 30/06/22)
                _identity.authorities = _identity.authorities.map(function(a) {return a.authority});
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$localStorage', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $localStorage, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            $rootScope.wfDefsBootable = [];
            $rootScope.wfDefsStatistics = [];
            $localStorage.wfDefsAll = [];
            delete $localStorage.cart;

            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    /*jshint camelcase: false */
    'use strict';

    angular
        .module('sprintApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', 'Base64', 'Principal', '$translate', '$q'];

    function AuthServerProvider ($http, $localStorage, Base64, Principal, $translate, $q) {
        return {
            login: function(credentials) {
                var data = "username=" + credentials.username + "&password="
                    + credentials.password + "&grant_type=password&scope=read%20write&" +
                    "client_secret=mySecretOAuthSecret&client_id=missioniApp";
                return $http.post('oauth/token', data, {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json",
                        "Authorization": "Basic " + Base64.encode("sprintapp" + ':' + "mySecretOAuthSecret")
                    }
                }).success(function (response) {
                    var expiredAt = new Date();
                    expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                    response.expires_at = expiredAt.getTime();
                    Principal.authenticate(response);
                    return response;
                });
            },
            logout: function(){ 
                location.href = "/sso/logout";
            },
            hasValidToken: function () {
                var token = this.getToken();
                return token && token.expires_at && token.expires_at > new Date().getTime();
            },
            profileInfo: function() {
                return $http.get('api/profile/info').success(function(response) {
                    return response;
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('flows/api/current-account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        response.data.langKey = 'it';
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular
		.module('sprintApp')
		.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
			.state('user-memberships', {
				parent: 'entity',
				url: '/userMemberships?page&sort&search',
				data: {
					authorities: ['ROLE_USER'],
					pageTitle: 'sprintApp.userMemberships.home.title'
				},
				views: {
					'content@': {
						templateUrl: 'app/pages/userMemberships/userMemberships.html',
						controller: 'UserMembershipsController',
						controllerAs: 'vm'
					}
				},
				params: {
					page: {
						value: '1',
						squash: true
					},
					sort: {
						value: 'id,asc',
						squash: true
					},
					search: null
				},
				resolve: {
					pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
						return {
							page: PaginationUtil.parsePage($stateParams.page),
							sort: $stateParams.sort,
							predicate: PaginationUtil.parsePredicate($stateParams.sort),
							ascending: PaginationUtil.parseAscending($stateParams.sort),
							search: $stateParams.search
						};
					}],
					translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('userMemberships');
						$translatePartialLoader.addPart('membership');
						$translatePartialLoader.addPart('global');
						return $translate.refresh();
					}]
				}
			})
			.state('group-memberships', {
				parent: 'app',
				url: '/group-membership?page&sort&search',
				data: {
					authorities: ['ROLE_USER'],
					pageTitle: 'sprintApp.userMemberships.home.title'
				},
				views: {
					'content@': {
						templateUrl: 'app/pages/userMemberships/groupMemberships.html',
						controller: 'GroupMembershipsController',
						controllerAs: 'vm'
					}
				},
				params: {
					page: {
						value: '1',
						squash: true
					},
					sort: {
						value: 'id,asc',
						squash: true
					},
					search: null,
					groupname: null,
					displayName: null
				},
				resolve: {
					modify: [function() {
						return false;
					}],
					pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
						return {
							page: PaginationUtil.parsePage($stateParams.page),
							sort: $stateParams.sort,
							predicate: PaginationUtil.parsePredicate($stateParams.sort),
							ascending: PaginationUtil.parseAscending($stateParams.sort),
							search: $stateParams.search
						};
					}],
					translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('userMemberships');
						$translatePartialLoader.addPart('membership');
						$translatePartialLoader.addPart('global');
						return $translate.refresh();
					}],
					previousState: ["$state", function($state) {
						var currentStateData = {
							name: $state.current.name || 'userMemberships',
							params: $state.params,
							url: $state.href($state.current.name, $state.params)
						};
						return currentStateData;
					}]
				}
			})
			.state('group-memberships-edit', {
				parent: 'app',
				url: '/group-memberships-edit?page&sort&search',
				data: {
					authorities: ['ROLE_USER'],
					pageTitle: 'sprintApp.userMemberships.home.title'
				},
				views: {
					'content@': {
						templateUrl: 'app/pages/userMemberships/groupMemberships.html',
						controller: 'GroupMembershipsController',
						controllerAs: 'vm'
					}
				},
				params: {
					page: {
						value: '1',
						squash: true
					},
					sort: {
						value: 'id,asc',
						squash: true
					},
					search: null,
					groupname: null,
					displayName: null
				},
				resolve: {
					modify: [function() {
						return true;
					}],
					pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
						return {
							page: PaginationUtil.parsePage($stateParams.page),
							sort: $stateParams.sort,
							predicate: PaginationUtil.parsePredicate($stateParams.sort),
							ascending: PaginationUtil.parseAscending($stateParams.sort),
							search: $stateParams.search
						};
					}],
					translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('userMemberships');
						$translatePartialLoader.addPart('membership');
						$translatePartialLoader.addPart('global');
						return $translate.refresh();
					}],
					previousState: ["$state", function($state) {
						var currentStateData = {
							name: $state.current.name || 'userMemberships',
							params: $state.params,
							url: $state.href($state.current.name, $state.params)
						};
						return currentStateData;
					}]
				}
			})
			.state('userMembershipDelete', {
				parent: 'group-memberships',
				url: '/{id}/delete',
				data: {
					authorities: ['ROLE_USER']
				},
				onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
					$uibModal.open({
						templateUrl: 'app/pages/userMemberships/userMembership-delete-dialog.html',
						controller: 'UserMembershipDeleteController',
						controllerAs: 'vm',
						size: 'md',
						resolve: {
							entity: ['$state', 'Membership', function($state, Membership) {
								return Membership.get({
									id: $stateParams.id
								}).$promise;
							}]
						}
					}).result.then(function() {
						$state.go('group-memberships-edit', {
							groupname: $stateParams.groupname,
							displayName: $stateParams.displayName
						}, {
							reload: 'group-memberships-edit'
						});
					}, function() {
						$state.go('^');
					});
				}],
				params: {
					groupname: null,
					displayName: null
				}
			})
			.state('user-membership-new', {
				parent: 'group-memberships',
				url: '/newMembership/',
				data: {
					authorities: ['ROLE_USER']
				},
				onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
					$uibModal.open({
						templateUrl: 'app/pages/userMemberships/user-membership-new.html',
						controller: 'UserMembershipNewController',
						controllerAs: 'vm',
						backdrop: 'static',
						size: 'lg',
						resolve: {
							entity: ['$stateParams', '$state', function($stateParams, $state) {
								return {
									username: null,
									groupname: $stateParams.groupname,
									grouprole: null,
									id: null
								};
							}]
						}
					}).result.then(function() {
						$state.go('group-memberships-edit', {
							groupname: $stateParams.groupname,
						    displayName: $stateParams.displayName
						}, {
							reload: 'group-memberships-edit'
						});
					}, function() {
						$state.go('^');
					});
				}]
			});
	}
})();
(function() {
	'use strict';

	angular
		.module('sprintApp')
		.controller('UserMembershipsController', UserMembershipsController);

	UserMembershipsController.$inject = ['$scope', '$state', 'dataService', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

	function UserMembershipsController($scope, $state, dataService, ParseLinks, AlertService, pagingParams, paginationConstants) {
		var vm = this;

		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;

		loadAll();

		function loadAll() {
			dataService.userMemberships.groupsForUser({
				page: pagingParams.page - 1,
				size: vm.itemsPerPage,
				sort: sort()
			}).then(onSuccess, onError);

			function sort() {
				var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
				if (vm.predicate !== 'id') {
					result.push('id');
				}
				return result;
			}

			function onSuccess(data) {
				vm.links = ParseLinks.parse(data.headers('link'));
				vm.totalItems = data.headers('X-Total-Count');
				vm.queryCount = vm.totalItems;
				vm.memberships = data.data;
				vm.page = pagingParams.page;
			}

			function onError(error) {
				AlertService.error(error.data.message);
			}
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page: vm.page,
				sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search: vm.currentSearch
			});
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('sprintApp')
		.controller('UserMembershipDeleteController', UserMembershipDeleteController);

	UserMembershipDeleteController.$inject = ['$uibModalInstance', 'entity', 'Membership'];

	function UserMembershipDeleteController($uibModalInstance, entity, Membership) {
		var vm = this;

		vm.membership = entity;
		vm.clear = clear;
		vm.confirmDelete = confirmDelete;

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmDelete(id) {
			Membership.delete({
					id: id
				},
				function() {
					$uibModalInstance.close(true);
				});
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('sprintApp')
		.controller('UserMembershipNewController', UserMembershipNewController);

	UserMembershipNewController.$inject = ['$scope', 'dataService', '$uibModalInstance', 'entity', 'Membership'];

	function UserMembershipNewController($scope, dataService , $uibModalInstance, entity, Membership) {
		var vm = this;

		vm.membership = entity;
		vm.clear = clear;
		vm.save = save;

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			vm.isSaving = true;
			dataService.userMemberships.createMembership(vm.membership.groupname, vm.membership.username, vm.membership.grouprole)
				.then(function onSaveSuccess(result) {
					$scope.$emit('sprintApp:membershipUpdate', result);
					$uibModalInstance.close(result);
					vm.isSaving = false;
				}, function onSaveError() {
					vm.isSaving = false;
				});
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('sprintApp')
		.controller('GroupMembershipsController', GroupMembershipsController);

	GroupMembershipsController.$inject = ['$scope', '$state', '$stateParams', 'Membership', 'dataService', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'modify'];

	function GroupMembershipsController($scope, $state, $stateParams, Membership, dataService, ParseLinks, AlertService, pagingParams, paginationConstants, modify) {
		var vm = this;

		vm.modify = modify;
		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		//serve per visualizzarlo nell'html
		vm.displayName = $stateParams.displayName;
		vm.groupname = $stateParams.groupname;

		loadAll();


		function loadAll() {
			dataService.userMemberships.membersByGroupName(vm.groupname).then(onSuccess, onError);

			function onSuccess(data) {
				vm.links = ParseLinks.parse(data.headers('link'));
				vm.totalItems = data.headers('X-Total-Count');
				vm.queryCount = vm.totalItems;
				vm.memberships = data.data;
				vm.page = pagingParams.page;
			}

			function onError(error) {
				AlertService.error(error.data.message);
			}
		}


		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}


		function transition() {
			$state.transitionTo($state.$current, {
				page: vm.page,
				sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search: vm.currentSearch
			});
		}


		vm.removeUserMembership = function(id) {
			Membership.delete({
					id: id
				},
				function() {
					$uibModalInstance.close(true);
				});
		};
	}
})();
(function () {
    'use strict';

    angular
            .module('sprintApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('task-completed', {
            parent: 'app',
            url: '/task-completed',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/taskCompleted/taskCompleted.html',
                    controller: 'TaskCompletedController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('TaskCompletedController', TaskCompletedController);

    TaskCompletedController.$inject = ['$scope', '$rootScope', '$state', 'dataService', 'utils', 'paginationConstants', '$log'];

    function TaskCompletedController($scope, $rootScope, $state, dataService, utils, paginationConstants, $log) {
        var vm = this;
        //variabili usate nella paginazione
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 1;
        vm.totalItems = vm.itemsPerPage * vm.page;
        vm.order = 'ASC';

        $scope.loadTaskCompleted = function() {
            var maxResults = vm.itemsPerPage,
                firstResult = vm.itemsPerPage * (vm.page - 1);

            //carico le form di ricerca specifiche per ogni tipologia di Process Definitions
            $scope.formUrl = utils.loadSearchFields(vm.processDefinitionKey, true);

            dataService.tasks.getTaskCompletedByMe($rootScope.current, firstResult, maxResults, vm.order, utils.oldPopulateTaskParams(Array.from($("input[id^='searchField-']"))))
                .then(function(response) {
                    response.data.data.forEach(function(task) {
                        utils.refactoringVariables(task);
                    });
                    vm.taskCompletedForMe = response.data.data;
                    // variabili per la gestione della paginazione
                    vm.totalItems = response.data.total;
                    vm.queryCount = vm.totalItems;
                }, function(error) {
                    $log.error(error);
                });
        };
        //aggiornamento pagina in caso di cambio "ordinamento" o Process definition
        $scope.$watchGroup(['vm.order', 'current'], function() {
            $scope.loadTaskCompleted();
        });

        //funzione richiamata quando si chiede una nuova "pagina" dei risultati
        vm.transition = function transition() {
            $scope.loadTaskCompleted()
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('task', {
            parent: 'app',
            url: '/task?processDefinitionId&taskName&taskId',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/task/task.html',
                    controller: 'TaskController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
	'use strict';

	angular
	.module('sprintApp')
	.controller('TaskController', TaskController);

	/**
	 * Questo e' un po' il cuore di tutta l'applicazione, per questo e' un pochino piu' complicato di altri
	 * Innanzitutto c'e' una promise composta che aspetta che sia la form che le variabili siano caricate,
	 * e a quel punto valoriza i campi della form ove richiesto con 'autofill'.
	 *
	 * Al momento dell'invio della form succedono piu' cose un po' complicate per un motivo specifico:
	 * per permettere l'atomicita' delle azioni, i files sono trattati come metadati e vengono inviati
	 * insieme alla form degli altri metadati, e non in un momento separato come era nella vecchia Scrivania.
	 * Per fare questo usiamo form Multipart, e una libreria angular che gestisce l'invio dei file (wrappata nel nostro fileinput)
	 * Questo richiede alcuni accorgimenti, perche' possiamo inviare o JSON o Multipart con files
	 *
	 * Per questo, al momento dell'invio, campi complessi (subform, campi multipli) vengono serializzati in stringhe.
	 * Nel fare questo vanno copiati in una variabile nuova, senno l'UI sballa, e filtrati lato server (FlowsTaskResource.extractParameters())
	 *
	 * NB: non posso usare angular.copy() o altrimenti duplicare i dati per la submit
	 *     perche' non vengono gestiti bene gli oggetti del nuovo tipo File/Blob
	 *     Sono costretto a inviare il $scope.data originale
	 *
	 * @author mtrycz
	 */
	TaskController.$inject = ['$scope', '$rootScope', 'Principal', 'LoginService', '$state', 'dataService', 'AlertService', '$log', '$http', '$q', 'Upload', 'utils', '$localStorage', '$uibModal'];

	function TaskController($scope, $rootScope, Principal, LoginService, $state, dataService, AlertService, $log, $http, $q, Upload, utils, $localStorage, $uibModal) {
		var vm = this, deploymentId, isShared = false;

        $scope.button={};
		$scope.data = {};
		vm.taskId = $state.params.taskId;
		$scope.taskId = $state.params.taskId;
		$scope.data.processDefinitionId = $state.params.processDefinitionId;
		$scope.processDefinitionKey = $scope.data.processDefinitionId.split(":")[0];
		$scope.processVersion = $scope.data.processDefinitionId.split(":")[1];
		$scope.attachments = {};
		$scope.account = {}
		
		Principal.identity().then(function(account) {
                $scope.account = account;
        })

		// Ho bisogno di caricare piu' risorse contemporaneamente (form e data);
		// quando sono finite entrambe, autofillo la form
		var formPromise = $q.defer(),
		dataPromise = $q.defer();
		$scope.autofill = function () {
			formPromise.resolve(2);
		}; // usato nell'html


		$q.all([formPromise.promise, dataPromise.promise])
		.then(function (value) {
			angular.forEach(taskForm, function (el) {
				if (el.attributes.autofill)
					$scope.data[el.id] = vm.taskVariables[el.id];
			});
			//Autofill dei campi che, essendo caricati solo in alcuni casi specifici, non vengono valorizzati a questo punto nella form
			if ([11, 12, 13, 15, 16, 18, 21, 22, 23].includes(Number(vm.taskVariables["tipologiaAcquisizioneId"])))
				$scope.data["strumentoAcquisizione"] = vm.taskVariables["strumentoAcquisizione"];
			if ([14, 17].includes(Number(vm.taskVariables["tipologiaAcquisizioneId"])))
				$scope.data["strumentoAcquisizioneId"] = vm.taskVariables["strumentoAcquisizioneId"];
			if ([11, 12, 13].includes(Number(vm.taskVariables["strumentoAcquisizioneId"])))
				$scope.data["tipologiaAffidamentoDiretto"] = vm.taskVariables["tipologiaAffidamentoDiretto"];
			if ([21, 23].includes(Number(vm.taskVariables["strumentoAcquisizioneId"])))
				$scope.data["tipologiaProceduraSelettiva"] = vm.taskVariables["tipologiaProceduraSelettiva"];

            if($state.params.taskId){
                if($state.params.processDefinitionId.includes('short-term-mobility-domande'))
                    isShared = true;

                dataService.draft.getDraftByTaskId($state.params.taskId, isShared).then(
                        function(response){
                            //popolo i campi col contenuto del json
                            var json = JSON.parse(response.data.json);
                            Object.keys(json).forEach(function(key) {
                                $scope.data["" + key] = json[key];
                            })
                        }
                );
            } else{
                dataService.draft.getDraftByProcessDefinitionId($state.params.processDefinitionId.split(':')[0]).then(
                        function(response){
                            //popolo i campi col contenuto del json
                            var json = JSON.parse(response.data.json);
                            Object.keys(json).forEach(function(key) {
                                $scope.data["" + key] = json[key];
                            })
                        }
                );
            }
		});

		if ($state.params.taskId) {
			dataService.tasks.getTask($state.params.taskId).then(
				function (response) {
					$scope.data.taskId = $state.params.taskId;
					//visualizzazione dei metadati del task in esecuzione
					var processDefinition = response.data.task.processDefinitionId.split(":");
					vm.detailsView = 'api/views/' + processDefinition[0] + '/' + processDefinition[1] + '/detail';
					$scope.data.entity = utils.refactoringVariables([response.data.task])[0];

					vm.taskVariables = $scope.data.entity.variabili;
					$scope.attachments = utils.parseAttachments(response.data.attachments);
					//                    $scope.attachments = response.data.attachments;

					vm.diagramUrl = '/rest/diagram/taskInstance/' + $scope.data.taskId + "?" + new Date().getTime();
					vm.formUrl = 'api/forms/task/' + $scope.data.taskId;
					dataPromise.resolve();
				});
		} else {
//		    deploymentId = $localStorage.wfDefsAll.filter(function(el){return el.id == $state.params.processDefinitionId})[0].deploymentId;
//		    autofill draft (deploymentId(negativo))
		    dataService.draft.getDraftByProcessDefinitionId($state.params.processDefinitionId.split(':')[0]).then(
				function(response){
					//popolo i campi col contenuto del json
					var json = JSON.parse(response.data.json);
					Object.keys(json).forEach(function(key) {
						$scope.data["" + key] = json[key];
					})
				}
            );

			dataPromise.reject("");

			vm.diagramUrl = "/rest/diagram/processDefinition/" + $state.params.processDefinitionId + "?" + new Date().getTime();
			vm.formUrl = 'api/forms/' + $scope.processDefinitionKey + "/" + $scope.processVersion + "/" + $state.params.taskName
		}

		$scope.preSubmitTask = function (file) {
		
		    if ($scope.taskForm.$invalid) {
                angular.forEach($scope.taskForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    });
                });
                $("#confirmModal").hide() //rimuovo la modale di conferma
                AlertService.warning("Inserire tutti i valori obbligatori.");
                //$scope.button.disabled = false;

            } else {
                if($rootScope.inDevelopment){
                    $scope.submitTask(file);
                } else {
                    $uibModal.open({
                        templateUrl: 'confirmModal.html',
                        scope: $scope
                    });
                }
            }
		};

		$scope.submitTask = function (file) {
		    $scope.button.disabled = true;

			if ($scope.taskForm.$invalid) {
				angular.forEach($scope.taskForm.$error, function (field) {
					angular.forEach(field, function (errorField) {
						errorField.$setTouched();
					});
				});
				$("#confirmModal").hide() //rimuovo la modale di conferma
				AlertService.warning("Inserire tutti i valori obbligatori.");
				//$scope.button.disabled = false;

			} else {
			    $("#confirmModal").hide() //rimuovo la modale di conferma
				// Serializzo gli oggetti complessi in stringhe
				// E' necessario copiarli in un nuovo campo, senno' angular si incasina
				// Non posso usare angular.copy() perche' ho degli oggetti File non gestiti bene
				utils.prepareForSubmit($scope.data, $scope.attachments);

				Upload.upload({
					url: 'api/tasks/complete',
					data: $scope.data,
				}).then(function (response) {

					$log.info(response);
					AlertService.success("Richiesta completata con successo");
					removeFromCart($state.params.taskId)
					$state.go('availableTasks');

        		    $scope.button.disabled = false;
				}, function (err) {
					$log.error(err);
					if (err.status == 412) {
						AlertService.warning("AVVISO<br>" + err.data.message);
					} else if (err.status == -1) {
						AlertService.error("Richiesta non riuscita<br>" + "E' possibile che la richiesta superi il limite massimo di grandezza (50MB)");
					} else {
						AlertService.error("Richiesta non riuscita<br>" + err.data.message);
					}
				    $scope.button.disabled = false;
				});
			}
		}

		$scope.downloadFile = function (url, filename, mimetype) {
			utils.downloadFile(url, filename, mimetype);
		}

		$scope.createDraft = function (taskId) {
			//copio scope.data e tolgo i campi che non voglio salvare nel Draft
			var json = Object.assign({}, $scope.data);
			delete json.entity;
			delete json.processDefinitionId;
//			delete json.sceltaUtente;
			delete json.taskId;
			//salvo il draft
			//todo: da testare
			if($state.params.processDefinitionId.includes('short-term-mobility-domande'))
			    isShared = true;

			if($state.params.taskId){
			    dataService.draft.updateDraft($state.params.taskId , json, null, isShared);
			} else{
			    dataService.draft.updateDraft(null, json, $state.params.processDefinitionId.split(':')[0], isShared);
			}
		}

		function removeFromCart(taskId) {
			if (taskId && $localStorage.cart) {
				delete $localStorage.cart[taskId];
				if (Object.keys($localStorage.cart).length == 0) {
					delete $localStorage.cart;
				}
			}
		}
	}
})();

(function() {
    'use strict';

    angular
            .module('sprintApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('statistics', {
            parent: 'app',
            url: '/statistics?processDefinition',
            data: {
                authorities: ['ROLE_USER'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/statistics/statistics.html',
                    controller: 'StatisticsController',
                    controllerAs: 'vm',
                },
            },
            params: {
                processDefinition: null,
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('statistics');
                        return $translate.refresh();
                    }],
            },
        });
    }
})();

(function() {
	'use strict';

	angular
	.module('sprintApp')
	.controller('StatisticsController', StatisticsController);

	StatisticsController.$inject = ['$rootScope', '$scope', '$filter', '$stateParams', 'dataService', 'Principal', 'ProfileService', 'LoginService', 'utils'];


	function StatisticsController($rootScope, $scope, $filter, $stateParams, dataService, Principal, ProfileService, LoginService, utils) {
		//var vm = this;


		var vm = this,
		dateFormat = 'yyyy-MM-dd';
		vm.processDefinition = $stateParams.processDefinition.split(":")[0];
		vm.isNavbarCollapsed = true;
		vm.isAuthenticated = Principal.isAuthenticated;

		$scope.exportFile = function(isPdf, processDefinitionKey, idStruttura, startDateGreat, startDateLess, filename) {
			var url = (isPdf ? '/api/makeStatisticPdf?' : '/api/makeStatisticCsv?') +
			'processDefinitionKey=' + vm.processDefinition +
			'&idStruttura=' + vm.exportParams.struttura +
			'&startDateGreat=' + $filter('date')(vm.exportParams.startDateGreat, dateFormat) +
			'&startDateLess=' + $filter('date')(vm.exportParams.startDateLess, dateFormat);
			utils.downloadFile(url, filename, isPdf ? 'application/pdf' : 'application/vnd.ms-excel');
		};

		// $scope.strutture = [{id:1,label:"pippo"},{id:2,label:"pluto"}];
		$scope.strutture = [];
		var appoStruttura = [];
		function elencaStrutture() {
			for (var i = 0; i < Principal.identity().$$state.value.authorities.length; i++){
				var authority = Principal.identity().$$state.value.authorities[i];
				if(authority.includes('responsabile#' + vm.processDefinition) || authority.includes('supervisore#' + vm.processDefinition)){
					var newStruttura = authority.split(/[#@]/)[2];
					if(newStruttura != null){
						if(newStruttura == "0000"){
							appoStruttura.push({
								value: newStruttura,
								label: "CNR"
							})
							$scope.strutture.push({
								value: newStruttura,
								label: "CNR"
							})
						} else {
							if(appoStruttura.indexOf(newStruttura) == -1) {
								appoStruttura.push(newStruttura);
								dataService.lookup.uo(newStruttura).then(function(response){
									$scope.strutture.push(response.data)
								})
							}
						}
					}
				}
			}
		};

		elencaStrutture();
	}
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('search', {
            parent: 'app',
            url: '/search?',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/search/search.html',
                    controller: 'SearchController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module("sprintApp")
        .controller("SearchController", SearchController);

    SearchController.$inject = ["$scope", "dataService", "utils", "$log", "$location", "paginationConstants"];

    function SearchController($scope, dataService, utils, $log, $location, paginationConstants) {
        var vm = this,
            oldUrl = $scope.formUrl;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        $scope.reload = false;
        // "conservo" i parametri della ricerca  ...
        vm.searchParams = $location.search();
        //parso bene i searchParams che sono date
        if (vm.searchParams.hasOwnProperty('startDateLess')) {
            vm.searchParams.startDateLess = new Date(vm.searchParams.startDateLess);
        }
        if (vm.searchParams.hasOwnProperty('startDateGreat')) {
            vm.searchParams.startDateGreat = new Date(vm.searchParams.startDateGreat);
        }

        vm.searchParams.active = $location.search().active || true;
        vm.searchParams.order = $location.search().order || "ASC";
        if (!vm.searchParams.page) {
            vm.page = $location.search().page || 1;
            vm.searchParams.page = $location.search().page || 1;
        }
        vm.searchParams.processDefinitionKey = $location.search().processDefinitionKey || "all";

        $scope.search = function () {
            //serve per evitare di ricaricare le form di ricerca associate alla Process Definition ad ogni nuova ricerca
            $scope.reload = $scope.formUrl !== oldUrl;
            vm.results = [];
            vm.loading = true;

            if (vm.searchParams.processDefinitionKey === null) {
                vm.searchParams.processDefinitionKey = undefined;
            }
            $log.info(vm.searchParams);
            $location.search(vm.searchParams);

            //ripulisco i valori con null(tipo quando annullo la data selezionata)
            Object.keys(vm.searchParams).forEach(function (key) {
                if (vm.searchParams[key] === null) {
                    delete vm.searchParams[key];
                }
            });
            dataService.processInstances.search(vm.searchParams).then(
                function (response) {
                    vm.results = utils.refactoringVariables(response.data.data);
                    vm.totalItems = response.data.total;
                    vm.loading = false;
                },
                function (response) {
                    $log.error(response);
                    vm.loading = false;
                }
            );
        };

        $scope.exportCsv = function () {
            dataService.search.exportCsv(vm.searchParams, -1, -1)
                .success(function (response) {
                    var filename = new Date().toISOString().slice(0, 10) + ".csv",
                        file = new Blob([response], {
                            type: "text/plain;charset=utf-8"
                        });
                    $log.info(file, filename);
                    saveAs(file, filename);
                });
        };

        $scope.$watchGroup(["vm.searchParams.processDefinitionKey"], function () {
            if (vm.searchParams.processDefinitionKey) {
                $scope.formUrl = "api/forms/" + vm.searchParams.processDefinitionKey + "/1/search-pi";
            } else {
                $scope.formUrl = "api/forms/all/1/search-pi";
            }
        });

        $scope.search();
    }
})();
(function () {
    'use strict';

    angular
            .module('sprintApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('myProcessInstances', {
            parent: 'app',
            url: '/my-process-instances',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                     templateUrl: 'app/pages/myProcessInstances/myProcessInstances.html',
                    controller: 'MyPIController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
            }
        });
    }
})();

(function() {
  'use strict';

  angular.module("sprintApp").controller("MyPIController", MyPIController);

  MyPIController.$inject = ["$scope", "paginationConstants", "dataService", "utils", "$log"];

  function MyPIController($scope, paginationConstants, dataService, utils, $log) {
    var vm = this;
    vm.order = "ASC";

    //variabili usate nella paginazione
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.pageActive = 1;
    vm.pageTerminated = 1;
    vm.totalItemsActive = vm.itemsPerPage * vm.pageActive;
    vm.totalItemsTerminated = vm.itemsPerPage * vm.pageTerminated;
    vm.searchParams = {};

    vm.myTasks = { total: 0 };
    vm.pooledTasks = { total: 0 };

    $scope.$watchGroup(["vm.order", "current"], function() {
      $scope.loadMyProcessInstances();
    });

    $scope.loadMyProcessInstances = function() {
      var searchParamsActive = {},
        searchParamsTerminated = {};

      //carico le form di ricerca specifiche per ogni tipologia di Process Definitions
      $scope.formUrl = utils.loadSearchFields(
        vm.searchParams.processDefinitionKey,
        false
      );
      //setto i searchParams per la query sui flussi attivi
      searchParamsActive = $.extend({}, vm.searchParams);
      dataService.processInstances
        .myProcessInstances(
          vm.processDefinitionKey,
          true,
          10 * (vm.pageActive - 1 || 0),
          10,
          vm.order,
          searchParamsActive
        )
        .then(
          function(response) {
            vm.myProcessInstancesActive = response.data.data;
            vm.totalItemsActive = response.data.total;
            vm.queryCountActive = vm.totalItemsActive;
          },
          function(error) {
            $log.error(error);
          }
        );

      //setto i searchParams per la query sui flussi terminati
      searchParamsTerminated = $.extend({}, vm.searchParams);
      searchParamsTerminated.page = vm.TAIMGPage || 1;
      dataService.processInstances
        .myProcessInstances(
          vm.processDefinitionKey,
          false,
          10 * (vm.pageActive - 1 || 0),
          10,
          vm.order,
          searchParamsTerminated
        )
        .then(
          function(response) {
            vm.myProcessInstancesTerminated = response.data.data;
            vm.totalItemsTerminated = response.data.total;
            vm.queryCountTerminated = vm.totalItemsTerminated;
          },
          function(response) {
            $log.error(response);
          }
        );
    };

    //rimuove la div con lo user perchè questa è la pagina dei "MIEI" flussi
    $scope.removeUserDiv = function() {
      $("div").remove("#userDiv");
    };

    $scope.setActiveContent = function(choice) {
      $scope.activeContent = choice;
    };

    //funzione richiamata quando si chiede una nuova "pagina" dei risultati
    vm.transition = function transition() {
      $scope.loadMyProcessInstances();
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('manualistica', {
            parent: 'app',
            url: '/manualistica',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/manualistica/manualistica.html',
                    controller: 'ManualisticaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
//                    $translatePartialLoader.addPart('details');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ManualisticaController', ManualisticaController);

    ManualisticaController.$inject = ['$scope', '$state', 'dataService', 'utils'];

    function ManualisticaController($scope, $state, dataService, utils) {
        var vm = this;
        //Recupero i Manuali
        dataService.manuali.getElenco().then(function(response) {
            vm.manuali = response.data;
        });
        //Recupero le Faq readable (generiche)
        dataService.faq.getReadableForProcessDefinition('generiche').then(function (faqs) {
            vm.faqs = removePrefix(faqs.data);
        });

        $scope.downloadManuale = function (manuale) {
            dataService.manuali.getManuale(manuale).then(
                function (response) {
                    var file = new Blob([response.data], {
                        type: "application/pdf"
                    });
                    saveAs(file, manuale + ".pdf");
                }
            )
        }
        //Recupero le Faq readable (specifiche)
        $scope.searchFaq = function() {
            if (vm.processDefinitionKey) {
                dataService.faq.getReadableForProcessDefinition(vm.processDefinitionKey).then(function (specificFaqs) {
                    var splitStr = vm.processDefinitionKey.replace(/\-/g, " ").split(' ');
                    //rimpiazzo "-" con spazi e le prime lettere delle parose maiuscole
                    for (var i = 0; i < splitStr.length; i++) {
                       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                    }
                    //riassemblo myProcessDefinitionKey (con le prime lettere maiuscole e senza -)
                    vm.myProcessDefinitionKey = splitStr.join(' ');

                    //rimuovo il prefisso delle domande delle Faq
                    vm.specificFaqs = removePrefix(specificFaqs.data);
                });
            }
        };
        // setto vm.specificFaqs vuoto
        $scope.$watchGroup(["vm.processDefinitionKey"], function () {
            if(!vm.processDefinitionKey)
                vm.specificFaqs = {};
        });
        // rimuovo il prefisso (la process definition) presente nele domande delle faq
        function removePrefix(faqs) {
            var faqsWithoutPrefix = $.extend({}, faqs), key;
            for (key in faqs) {
                faqsWithoutPrefix[key].domanda = faqs[key].domanda.substring(faqs[key].domanda.indexOf(' - ') + 2);
            }
            return faqsWithoutPrefix;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('helpdesk', {
            parent: 'app',
            url: '/helpdesk',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/helpdesk/helpdesk.html',
                    controller: 'HelpdeskController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('helpdesk');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
  'use strict';

  angular
    .module("sprintApp")
    .controller("HelpdeskController", HelpdeskController);

  HelpdeskController.$inject = ["$scope", "dataService", "$log", "$state", "AlertService", "utils"];

  function HelpdeskController($scope, dataService, $log, $state, AlertService, utils) {
    var vm = this, data;
    vm.hdDataModel = {};
    $scope.data = {};

    $scope.submitHelpdesk = function () {
      if ($scope.helpdeskForm.$invalid) {
        angular.forEach($scope.helpdeskForm.$error, function (field) {
          angular.forEach(field, function (errorField) {
            errorField.$setTouched();
          });
        });
        AlertService.warning("Inserire tutti i valori obbligatori.");
      } else {
        vm.hdDataModel.titolo = $scope.helpdeskModel.titolo;
        vm.hdDataModel.descrizione = $scope.helpdeskModel.descrizione;
        vm.hdDataModel.categoria = $scope.id;
        vm.hdDataModel.categoriaDescrizione = $scope.$parent.vm.hdDataModel;
        var request;
        if ($scope.attachments.allegato.data) {
          utils.prepareForSubmit($scope.data, $scope.attachments);
          data = $.extend($scope.data, vm.hdDataModel);
          request = dataService.helpdesk.sendWithAttachment(data);
        } else {
          request = dataService.helpdesk.sendWithoutAttachment(vm.hdDataModel);
        }
        request.then(function (response) {
          if (response.data.segnalazioneId) {
            AlertService.success("Segnalazione Helpdesk inviata con successo");
            $state.go('home');
          }
        },
          function (error) {
            $log.error(error);
            AlertService.error("Segnalazione NON inviata per problemi tecnici: riprovare in seguito");
          }
        );
      }
      $scope.fatto = function () {
        $state.go("home");
      };
    };
  }
})();

(function() {
    'use strict';

    angular.module('sprintApp')
        .controller('RevocaModalController', RevocaModalController);


    RevocaModalController.$inject = ['$uibModalInstance', 'dataService', 'processInstanceId', 'AlertService', '$state'];

    function RevocaModalController ($uibModalInstance, dataService, processInstanceId, AlertService, $state) {

      var vm = this;

      vm.processInstanceId = processInstanceId;

      vm.revoca = function() {
        dataService.processInstances.revoca(vm.processInstanceId)
        .then(function() {
          $uibModalInstance.dismiss('ok');
          AlertService.success("Richiesta completata con successo");
          $state.go('availableTasks');
        }, function(err) {
          console.log(err);
          AlertService.error("Richiesta non riuscita<br>" + err.data.message);
        })
      }

    }
})();
(function() {
  'use strict';

  angular
    .module("sprintApp")
    .controller("ReassignModalController", ReassignModalController);

  ReassignModalController.$inject = ["$uibModalInstance", "$scope", "dataService", "taskId", "processInstanceId", "$state"];

  function ReassignModalController($uibModalInstance, $scope, dataService, taskId, processInstanceId, $state) {
    var vm = this;

    vm.taskId = taskId;
    vm.processInstanceId = processInstanceId;

    $scope.reassignTask = function(user) {
      dataService.tasks.reassign(vm.taskId, vm.processInstanceId, vm.user)
        .then(function(response) {
          if (response) {
            $uibModalInstance.dismiss("cancel");
            $state.reload();
          }
        });
    };
  }
})();

(function() {
    'use strict';

    angular.module('sprintApp')
        .controller('HistoryModalController', HistoryModalController);

    HistoryModalController.$inject = ['processInstanceId', 'startTask', 'initiator', 'dataService', 'utils'];

    function HistoryModalController(processInstanceId, startTask, initiator, dataService, utils) {
        var vm = this;
        vm.data = {};

        vm.startTask = startTask;
        vm.initiator = initiator;

        dataService.processInstances.getHistoryForPi(processInstanceId).then(
            function (response) {
                vm.tasks = response.data;
                //refactoring dopo la chiamata
                vm.tasks.forEach(function (el) {
                    //recupero l'ultimo task (quello ancora da eseguire)
                    if (el.historyTask.endTime === null) {
                        //recupero la fase
                        vm.activeTask = el.historyTask;
                        utils.refactoringVariables(vm.activeTask);

                        vm.data.fase = el.historyTask.name;
                        //recupero il ruolo/l'utente assegnatario del task
                        el.historyIdentityLink.forEach(function (il) {
                            if (il.type === "candidate") {
                                if (il.groupId !== null) {
                                    vm.data.groupCandidate = il.groupId;
                                } else {
                                    vm.data.userCandidate = il.userId;
                                }
                            }
                        });
                    }
                });
            }
        );
    }
})();
(function() {
    'use strict';

    angular.module('sprintApp')
        .controller('EditVariableModalController', EditVariableModalController);


    EditVariableModalController.$inject = ['$uibModalInstance', 'dataService', 'processInstanceId', 'variableName', 'currentValue'];

    function EditVariableModalController ($uibModalInstance, dataService, processInstanceId, variableName, currentValue) {

      var vm = this;

      vm.processInstanceId = processInstanceId;
      vm.variableName = variableName;
      vm.currentValue = currentValue;

      vm.setVariable = function() {
        dataService.processInstances.setVariable(vm.processInstanceId, vm.variableName, vm.currentValue)
        .then(function() {
          $uibModalInstance.dismiss('ok');
        }, function() {
          vm.error = true;
        })
      }

    }
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('details', {
            parent: 'app',
            url: '/details?processInstanceId&taskId',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/details/details.html',
                    controller: 'DetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
//                TODO: da risolvere (internazionalizzazione?)
//                    $translatePartialLoader.addPart('details');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
	'use strict';

	angular.module('sprintApp').controller('DetailsController', DetailsController);

	DetailsController.$inject = ['$scope', '$rootScope', 'Principal', '$state', '$localStorage', 'dataService', 'AlertService', '$log', 'utils', '$uibModal'];

	function DetailsController($scope, $rootScope, Principal, $state, $localStorage, dataService, AlertService, $log, utils, $uibModal) {
		$scope.button={};
		$scope.button.disabled = true;
		var vm = this, activeTaskVariables;
		vm.searchParams = {};
		vm.data = {};
		vm.taskId = $state.params.taskId;
		//vm.searchParams.statoFinaleDomanda = {};
		vm.showGerarchia = false;
		vm.searchParams.active = true;
		vm.searchParams.order = "ASC";
		vm.searchParams.page = 1;
		vm.searchParams.processDefinitionKey = "short-term-mobility-domande";
		vm.searchParams.processInstanceId = "0";
		vm.searchParams.statoFinaleDomanda = "text=VALUTATA_SCIENTIFICAMENTE";


		$scope.processInstanceId = $state.params.processInstanceId; // mi torna comodo per gli attachments -martin

		Principal.identity().then(function(account) {
			vm.username    = account.login;
			vm.authorities = account.authorities;
		});

		if ($state.params.processInstanceId) {
			dataService.processInstances.byProcessInstanceId($state.params.processInstanceId, true).then(
					function(response) {
						vm.data.entity = utils.refactoringVariables([response.data.entity])[0];
						vm.initiator = JSON.parse(vm.data.entity.name).initiator; //serve per richiamare la "cronologia"
						vm.data.linkedProcesses = response.data.linkedProcesses;
//						vm.data.history = response.data.history;
						//in response.data.entity.variables ci sono anche le properties della Process Instance (initiator, startdate, ecc.)
						vm.data.startEvent = response.data.entity.variables;
						vm.data.attachments = utils.parseAttachments(response.data.attachments);
						vm.data.identityLinks = response.data.identityLinks;
						vm.diagramUrl = '/rest/diagram/processInstance/' + vm.data.entity.id + "?" + new Date().getTime();
						vm.data.businessKey = response.data.entity.businessKey;

						vm.data.history = response.data.history;
						//aggiungo le variabili del task (servono quando si aggiunge il task al carrello firma)
						activeTaskVariables = response.data.entity.variabili;
						vm.data.history.forEach(function(el) {
							//recupero l'ultimo task (quello ancora da eseguire)...
							if (el.historyTask.endTime === null) {
								vm.activeTask = el.historyTask;
								//...e gli metto le variabili
								vm.activeTask.variabili = activeTaskVariables;
							}
						})

						var processDefinition = response.data.entity.processDefinitionId.split(":");
//						var stato = response.data.history[0].historyTask.name;
						var stato = JSON.parse(response.data.entity.name).stato;

						vm.detailsView = 'api/views/' + processDefinition[0] + '/' + processDefinition[1] + '/detail';

						if(vm.data.entity.variabili.valutazioneEsperienze_json){
							vm.experiences = jQuery.parseJSON(vm.data.entity.variabili.valutazioneEsperienze_json);
						}
						if(processDefinition[0] != null
								& 
								((processDefinition[0] == "short-term-mobility-bando-dipartimento" & stato == "PROVVEDIMENTO GRADUATORIA")
										||
										(processDefinition[0] == "laboratori-congiunti-bando-dipartimento" & stato == "PROVVEDIMENTO GRADUATORIA"))
						) {
							if(processDefinition[0] == "laboratori-congiunti-bando-dipartimento"){
								vm.searchParams.processDefinitionKey = "laboratori-congiunti-domande";
							}
							vm.showGerarchia = true;
						}

						if(response.data.variabili.idBando){
							vm.searchParams.idBando = "text="+response.data.variabili.idBando.value;
						}
						if(response.data.variabili.dipartimentoId){
							vm.searchParams.dipartimentoId = "text="+response.data.variabili.dipartimentoId.value;
						}
						vm.searchParams.processInstanceId = response.data.variabili.processInstanceId.value;

						$scope.canPublish = response.data.canPublish;
						$scope.canUpdateAttachments = response.data.canUpdateAttachments;
						$scope.canSign = false;

						$scope.isResponsabile = (vm.authorities.includes("ROLE_responsabile#flussi") ||
								vm.authorities.includes("ROLE_responsabile#" + vm.data.entity.processDefinitionId.split(':')[0] + "@0000") ||
								vm.authorities.includes("ROLE_responsabile#" + vm.data.entity.processDefinitionId.split(':')[0] + "@" + vm.data.entity.variabili.idStruttura) ||
								vm.authorities.includes("ROLE_ADMIN"));

						$scope.isRevocabile = response.data.isRevocabile;

						//riattivo il bottone delle "azioni"
						$scope.button.disabled = false;
					}
			);
		}


		$scope.exportSummary = function(url, filename) {
			utils.downloadFile(url, filename, 'application/pdf');
		};

		$scope.avviaFlussoRevoca = function() {
			$uibModal.open({
				templateUrl: 'app/pages/details/revoca.modal.html',
				controller: 'RevocaModalController',
				controllerAs: 'vm',
				size: 'md',
				resolve: {
					processInstanceId: function() {
						return $scope.processInstanceId;
					}
				}
			})
		};

		$scope.editVariable = function(variableName, currentValue) {
			$uibModal.open({
				templateUrl: 'app/pages/details/editvariable.modal.html',
				controller: 'EditVariableModalController',
				controllerAs: 'vm',
				size: 'md',
				resolve: {
					processInstanceId: function() {
						return $scope.processInstanceId;
					},
					variableName: function() {
						return variableName;
					},
					currentValue: function() {
						return currentValue;
					}

				}
			})
		};


		$scope.history = function(processInstanceId, startTask, initiator) {
			$uibModal.open({
				templateUrl: 'app/pages/details/history.modal.html',
				controller: 'HistoryModalController',
				controllerAs: 'vm',
				size: 'md',
				resolve: {
					processInstanceId: function() {
						return $scope.processInstanceId;
					},
					initiator: function() {
						return initiator;
					},
					startTask: function() {
						return startTask;
					}
				}
			})
		};



		$scope.reassign = function(taskId, processInstanceId) {
			$uibModal.open({
				templateUrl: 'app/pages/details/reassign.modal.html',
				controller: 'ReassignModalController',
				controllerAs: 'vm',
				size: 'md',
				resolve: {
					taskId: function() {
						return taskId;
					},
					processInstanceId: function() {
						return processInstanceId;
					}
				}
			})
		};

		$scope.deleteProcessInstance = function(processInstanceId) {
			$uibModal.open({
				templateUrl: 'app/pages/details/deleteProcess.modal.html',
				controller: 'DeleteProcessModalController',
				controllerAs: 'vm',
				size: 'md',
				resolve: {
					processInstanceId: function() {
						return processInstanceId;
					}
				}
			})
		};

		$scope.inCart = function (id) {
			return $localStorage.cart && $localStorage.cart.hasOwnProperty(id);
		}

		$scope.addToCart = function(task) {
			$localStorage.cart = $localStorage.cart || {};
			$localStorage.cart[task.id] =  task;
		}

		$scope.removeFromCart = function(task) {
			delete $localStorage.cart[task.id];
			if (Object.keys($localStorage.cart).length == 0) {
				delete $localStorage.cart;
			}
		}

		$scope.exportCsv = function() {
			dataService.search
			.exportCsvAndSaveInProcess(vm.searchParams, -1, -1)
			.success(function(response) {
				AlertService.success("File Graduatoria Inserito correttamente nel fascicolo del Flusso");
			});
		};

	}
})();
(function() {
  'use strict';

  angular
    .module("sprintApp")
    .controller("DeleteProcessModalController", DeleteProcessModalController);

  DeleteProcessModalController.$inject = ['$uibModalInstance', '$scope', 'dataService', 'processInstanceId', '$state'];

  function DeleteProcessModalController($uibModalInstance, $scope, dataService, processInstanceId, $state) {
    var vm = this;

    vm.processInstanceId = processInstanceId;

    $scope.deleteProcess = function(deleteReason) {
      dataService.processInstances.deleteProcessInstance(vm.processInstanceId, vm.deleteReason)
        .then(function(response) {
          if (response) {
            $uibModalInstance.dismiss("cancel");
            $state.reload();
          }
        });
    };
  }
})();

(function() {
  'use strict';

  angular
  .module('sprintApp')
  .controller('SignManyModalController', SignManyModalController);

  SignManyModalController.$inject = ['$uibModalInstance','$scope', 'dataService', '$localStorage', '$state', 'AlertService'];

  function SignManyModalController($uibModalInstance, $scope, dataService, $localStorage, $state, AlertService) {
    var vm = this;


    vm.signMany = function() {
      vm.message = undefined;
      vm.submitDisabled = true;

      dataService.signMany(vm.username, vm.password, vm.otp, Object.keys($localStorage.cart)).then(
          function(response) {
            if (response.data.failure.length > 0) {
              var errors = response.data.failure.map(function (el) {return "<br>" +el.split(":")[1];});
              response.data.success.forEach(function (el) {
                delete $localStorage.cart[el];
              })

              vm.message      = "La firma di alcuni dei documenti non è andata a buon fine"+ errors;
              vm.messageClass = "alert-warning";
            } else {
              delete $localStorage.cart;
              $uibModalInstance.close();
              $state.go('availableTasks')
              AlertService.success("La firma di tutti i documenti è stata eseguita con successo");
            }
          },
          function(response) {
            vm.message = response.data.message;
            vm.messageClass = "alert-danger";
          }).finally(function () {
            vm.submitDisabled = false;
          });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('cart', {
            parent: 'app',
            url: '/cart',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/cart/cart.html',
                    controller: 'CartController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
//                    $translatePartialLoader.addPart('details');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('CartController', CartController);

    CartController.$inject = ['$scope', '$state', '$localStorage', 'dataService', '$uibModal'];

    function CartController($scope, $state, $localStorage, dataService, $uibModal) {
        var vm = this;
        $scope.$localStorage = $localStorage;

        $scope.removeAll = function() {
            delete $localStorage.cart;
            $state.go('availableTasks')
        }

        $scope.signAll = function() {
            dataService.signMany(Object.keys($localStorage.cart));
        }

        $scope.openSignModal = function() {
            $uibModal.open({
                templateUrl: 'app/pages/cart/signmany.modal.html',
                controller: 'SignManyModalController',
                controllerAs: 'vm',
                size: 'md'
            })
        };
    }

})();
(function() {
    'use strict';

    angular
            .module('sprintApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('availableTasks', {
            parent: 'app',
            url: '/available-tasks',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/availableTasks/availableTasks.html',
                    controller: 'AvailableTasksController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module("sprintApp")
        .controller("AvailableTasksController", AvailableTasksController);

    AvailableTasksController.$inject = ["$scope", "$rootScope", "paginationConstants", "dataService", "utils", "$log", "$location", '$localStorage'];

    function AvailableTasksController($scope, $rootScope, paginationConstants, dataService, utils, $log, $location, $localStorage) {
        var vm = this;
        vm.searchParams = {};
        $scope.indextab = 1;

        if ($rootScope.fromState.url.includes("details?")) {
            //Carico i parametri di ricerca "salvati" se torno dalla pagine dei "details"
            vm.searchParams = $location.search();
            vm.active = $location.active;
            vm.activeContent = $location.activeContent;
            vm.order = $location.order;
            switch ($location.activeContent) {
            case "myTasks":
                vm.myPage = $location.page;
                vm.availablePage = 1;
                vm.TAIMGPage = 1;
                $scope.indextab = 0;
                break;
            case "availables":
                vm.availablePage = $location.page;
                vm.myPage = 1;
                vm.TAIMGPage = 1;
                $scope.indextab = 1;
                break;
            case "taskAssignedInMyGroups":
                vm.TAIMGPage = $location.page;
                vm.availablePage = 1;
                vm.myPage = 1;
                $scope.indextab = 2;
                break;
            }

            //carico la form url
            $scope.formUrl = $location.formUrl || null;
            vm.processDefinitionKey = $location.processDefinitionKey;
        } else {
            //nella ricerca di default (quando carico la pagina) NON devo settare i searchParams
            vm.active = true;
            vm.order = "ASC";
            $scope.formUrl = utils.loadSearchFields(vm.processDefinitionKey, true);
        }

        //se le variabili usate per la paginazione no/*  */n sono inizializzate le inizializzo,
        //altrimenti se sto tornando dalla pagina dei dettagli una di loro sarà già inizializzata
        if (!(vm.myPage || vm.availablePage || vm.TAIMGPage)) {
            $location.page = 1;
            vm.myPage = 1;
            vm.availablePage = 1;
            vm.TAIMGPage = 1;
        }

        // JSON che conterrà i risultati delle due query
        vm.myTasks = {
            total: 0
        };
        vm.availableTasks = {
            total: 0
        };
        vm.taskAssignedInMyGroups = {
            total: 0
        };

        $scope.loadMyTasks = function () {
            // variabili usate nella paginazione
            var myFirstResult, myMaxResults;

            // carico le form di ricerca specifiche per ogni tipologia di Process Definitions e le salvo in $location
            $scope.formUrl = utils.loadSearchFields(
                vm.processDefinitionKey,
                true
            );
            $location.formUrl = $scope.formUrl;

            vm.itemsPerPage = paginationConstants.itemsPerPage;
            vm.myTotalItems = vm.itemsPerPage * vm.myPage;
            myFirstResult = vm.itemsPerPage * (vm.myPage - 1);
            myMaxResults = vm.itemsPerPage;

            dataService.tasks.myTasks(vm.processDefinitionKey, myFirstResult,
                    myMaxResults, vm.order, utils.populateTaskParams(vm.searchParams))
                .then(
                    function (response) {
                        utils.refactoringVariables(response.data.data);
                        vm.myTasks = response.data;
                        // variabili per la gestione della paginazione
                        vm.myTotalItems = response.data.total;
                        vm.myQueryCount = vm.myTotalItems;
                    },
                    function (response) {
                        $log.error(response);
                    }
                );
        };

        $scope.loadAvailableTasks = function () {
            // variabili usate nella paginazione
            var firstResultAvailable, maxResultsAvailable;
            vm.itemsPerPage = paginationConstants.itemsPerPage;
            vm.availableTotalItems = vm.itemsPerPage * vm.availablePage;
            firstResultAvailable = vm.itemsPerPage * (vm.availablePage - 1);
            maxResultsAvailable = vm.itemsPerPage;

            dataService.tasks.myTasksAvailable(vm.processDefinitionKey, firstResultAvailable,
                    maxResultsAvailable, vm.order, utils.populateTaskParams(vm.searchParams))
                .then(
                    function (response) {
                        utils.refactoringVariables(response.data.data);
                        vm.availableTasks = response.data;
                        // variabili per la gestione della paginazione
                        vm.availableTotalItems = response.data.total;
                        vm.availableQueryCount = vm.availableTotalItems;
                    },
                    function (response) {
                        $log.error(response);
                    }
                );
        };

        $scope.loadTaskAssignedInMyGroups = function () {
            // variabili usate nella paginazione
            var firstResultTAIMG, maxResultsTAIMG;
            vm.itemsPerPage = paginationConstants.itemsPerPage;
            vm.TAIMGTotalItems = vm.itemsPerPage * vm.availablePage;
            firstResultTAIMG = vm.itemsPerPage * (vm.availablePage - 1);
            maxResultsTAIMG = vm.itemsPerPage;

            dataService.tasks.taskAssignedInMyGroups(vm.processDefinitionKey, firstResultTAIMG,
                    maxResultsTAIMG, vm.order, utils.populateTaskParams(vm.searchParams))
                .then(
                    function (response) {
                        utils.refactoringVariables(response.data.data);
                        vm.taskAssignedInMyGroups = response.data;
                        // variabili per la gestione della paginazione
                        vm.TAIMGTotalItems = response.data.total;
                        vm.TAIMGQueryCount = vm.TAIMGTotalItems;
                    },
                    function (response) {
                        $log.error(response);
                    }
                );
        };

        $scope.showProcessInstances = function () {
            //"salvo" i parametri di ricerca
            $location.search(vm.searchParams);
            $location.processDefinitionKey = vm.processDefinitionKey;
            $location.order = vm.order;
            $location.active = vm.active;
            // Se RICARICO la pagina aggiorno TUTTE le "viste" (i miei compiti, compiti di ruolo,
            // compiti dei miei gruppi assegnati ad altri) e cancello i searchParams
            if (performance.navigation.type == performance.navigation.TYPE_RELOAD || performance.navigation.type == performance.navigation.TYPE_NAVIGATE) {
                $scope.loadAllTasks();
            } else {
                switch (vm.activeContent) {
                case "myTasks":
                    $scope.loadMyTasks();
                    vm.availablePage = 1;
                    vm.TAIMGPage = 1;
                    break;
                case "availables":
                    $scope.loadAvailableTasks();
                    vm.myPage = 1;
                    vm.TAIMGPage = 1;
                    break;
                case "taskAssignSedInMyGroups":
                    $scope.loadTaskAssignedInMyGroups();
                    vm.availablePage = 1;
                    vm.myPage = 1;
                    break;
                }
            }
        };

        $scope.loadAllTasks = function () {
            $scope.loadMyTasks();
            $scope.loadAvailableTasks();
            $scope.loadTaskAssignedInMyGroups();
        };

        $scope.setActiveContent = function (choice) {
            vm.activeContent = choice;
            $location.activeContent = choice;
        };

        $scope.resetSearcParams = function () {
            vm.searchParams = {};
            vm.processDefinitionKey = "";
            vm.order = "ASC";
            vm.active = true;
            $scope.showProcessInstances();
        };
        
        $scope.addAllToCart = function(type) {

            if (type === 'available') {
                dataService.tasks.myTasksAvailable(vm.processDefinitionKey, 0,
                        9999, vm.order, utils.populateTaskParams(vm.searchParams))
                    .then(
                        function (response) {
                            utils.refactoringVariables(response.data.data);
                            
                            response.data.data.forEach(function (task) {
                                if (task.category == 'firma' && !$scope.inCart(task.id)) {
                                    $localStorage.cart = $localStorage.cart || {};
                                    $localStorage.cart[task.id] = task;
                                }
                            });
                        },
                        function (response) {
                            $log.error(response);
                        }
                    );
            } else if (type === 'mine') {
                dataService.tasks.myTasks(vm.processDefinitionKey, 0,
                        9999, vm.order, utils.populateTaskParams(vm.searchParams))
                    .then(
                        function (response) {
                            utils.refactoringVariables(response.data.data);
                            
                            response.data.data.forEach(function (task) {
                                if (task.category == 'firma' && !$scope.inCart(task.id)) {
                                    $localStorage.cart = $localStorage.cart || {};
                                    $localStorage.cart[task.id] = task;
                                }
                            });
                        },
                        function (response) {
                            $log.error(response);
                        }
                    );
            }
        }

        $scope.inCart = function (id) {
            return $localStorage.cart && $localStorage.cart.hasOwnProperty(id);
        }
        
        // aggiornamento pagina in caso di cambio "ordinamento" o Process definition
        $scope.$watchGroup(["vm.order"], function () {
            $scope.showProcessInstances();
        });

        // funzione richiamata quando si chiede una nuova "pagina" dei risultati
        vm.transition = function transition(page) {
            $scope.showProcessInstances();
            $location.page = page;
        };
    }
})();
(function() {
    'use strict';

    angular
    .module('sprintApp')
    .config(lightboxConfig);

    lightboxConfig.$inject = ['LightboxProvider']

    function lightboxConfig(LightboxProvider) {
        LightboxProvider.calculateImageDimensionLimits = function (dimensions) {
            return {
                'maxWidth': dimensions.windowWidth >= 768 ? // default
                        dimensions.windowWidth - 92 :
                        dimensions.windowWidth - 52,
                 'maxHeight': 1600                           // custom
            };
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$rootScope', '$localStorage', '$scope', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'SwitchUserService', 'dataService', '$log', 'AuthServerProvider'];

    function NavbarController($rootScope, $localStorage, $scope, $state, Auth, Principal, ProfileService, LoginService, SwitchUserService, dataService, $log, AuthServerProvider) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.$localStorage = $localStorage;

        vm.login = login;
        vm.logout = logout;
        vm.switchUser = switchUser;
        vm.cancelSwitchUser = cancelSwitchUser;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        $rootScope.wfDefsStatistics = [];

        function isResponsabileStruttura(element) {
            return element.startsWith("responsabile-struttura");
        };

        //in ogni caso questa chiamata viene cachata e non viene richiamata ad ogni caricamento della navbar
        ProfileService.getProfileInfo().then(function(response) {

            $rootScope.inDevelopment = (response.activeProfiles.includes('dev') ? true : false);
            //verifico qual è il profilo spring con cui è stata avviata l'app per caricare il corrispondente banner
            if (response.activeProfiles.includes('cnr'))
                $rootScope.app = 'cnr';
            else if (response.activeProfiles.includes('oiv'))
                $rootScope.app = 'oiv';
            else if (response.activeProfiles.includes('showcase'))
                $rootScope.app = 'showcase';
            else
                $rootScope.app = 'none';

            vm.swaggerEnabled = response.swaggerEnabled;
        });


        function switchUser() {
            collapseNavbar();
            SwitchUserService.open();
        }

        function cancelSwitchUser() {
            collapseNavbar();
            dataService.authentication.cancelImpersonate().then(function() {
                Principal.authenticate(null);
                Principal.identity(true).then(function(account) {
                    $state.reload();
                });
            })
        }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function loadAvailableDefinitions() {
            dataService.definitions.all()
                .then(function(response) {
                    //lista delle Process Definition che l'utente può avviare
                    $rootScope.wfDefsBootable = response.data.bootable;
                    $rootScope.wfDefsBootable.push({
                        key: "all",
                        name: "ALL"
                    });
                    //lista di TUTTE le Process Definition
                    $rootScope.wfDefsAll = response.data.all;
                    $localStorage.wfDefsAll = response.data.all;

                    //popolo l'array delle process Definitions di cui l'utente loggato può vedere le statistiche
                    $rootScope.wfDefsStatistics = $localStorage.wfDefsAll.filter(function(processDefinition) {
                        for (var i = 0; i < vm.account.authorities.length; i++) {
                            var authority = vm.account.authorities[i];
                            if (authority.includes('responsabile#') || authority.includes('supervisore#')) {
                                if (authority.split(/[#@]/)[1] == processDefinition.key) {
                                    return true;
                                }
                            }
                        }
                    })
                }, function(response) {
                    $log.error(response);
                });
        }

        loadAvailableDefinitions();
        $scope.$on('authenticationSuccess', function(event, args) {
            $log.info(event);
            $log.info(args);
            loadAvailableDefinitions();
        });

        $scope.$watch(function() {
            return Principal.isAuthenticated();
        }, function() {
            Principal.identity().then(function(account) {
                account.login = account.username;
                vm.account = account;
                $scope.isResponsabileStruttura = account.authorities.some(isResponsabileStruttura);
                CreateSsoCnrMenu.createUserMenu('#menu-user', {
                    'placement': 'right',
                    'login': account.username,
                    'name': account.firstName + " " + account.lastName,
                    'logoutCallback': function(e) { AuthServerProvider.logout() }
                });
            })
        });

        CreateSsoCnrMenu.createAppsMenu('#menu-apps', { 'placement': 'right' });
    }
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular.module('sprintApp')
        .directive('wysiwyg', wysiwyg);

    wysiwyg.$inject = ['dataService', '$log'];

    /**
     * Questa direttiva e' un semplicissimo typeahead con dei parametri preimpostati
     * L'API e' semplicissima: ng-model e ng-required
     */
    function wysiwyg(dataService, $log) {
        return {
            restrict: 'E',
            require: 'ngModel',
            templateUrl: 'app/inputs/wysiwyg/wysiwyg.html',
            scope: {
                ngModel: '=',
                ngRequired: '@',
                placeholder: '@'
            },
            link: function($scope, element, attrs, ngModel) {
            	
            	var editorElement = element[0].children[1];
            	var editor = editorElement.editor;
            	
                ngModel.$render = function() {
                    if (editor) {
                    	editor.loadHTML(ngModel.$modelValue);
                    }
                    
                    editorElement.addEventListener('trix-change', function() {
                    	ngModel.$setViewValue(editorElement.innerHTML)
                    });
                    
                    editorElement.addEventListener('trix-blur', function() {
                    	if (!editorElement.innerHTML)
                    		element[0].classList.add('ng-touched')
                    });
                };
            	
                if ('autofill' in attrs) {
                    var nomeModelId = attrs.ngModel.split('.').pop();
                    $scope.ngModel = $scope.$parent.data.entity.variabili[nomeModelId];
                }
                if ('placeholder' in attrs) {
                	$(editorElement).attr('placeholder',$scope.placeholder);
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('sprintApp')
        .directive('typeaheadinput', typeaheadinput);

    typeaheadinput.$inject = ['dataService', '$log'];

    /**
     * Questa direttiva e' un semplicissimo typeahead con dei parametri preimpostati
     * L'API e' semplicissima: ng-model e ng-required
     */
    function typeaheadinput(dataService, $log) {
        return {
            restrict: 'E',
            templateUrl: 'app/inputs/typeaheadinput/typeaheadinput.html',
            scope: {
                ngModel: '=',
                labelModel: '=',
                type: '@',
                ngRequired: '@',
            },
            link: function($scope, element, attrs) {
                $scope.localModel = undefined;

                $scope.$watch('localModel', function(newVal) {
                    if (newVal) {
                        $scope.ngModel = newVal.value;
                        $scope.labelModel = newVal.label;
                    }
                });

                init();

                $scope.loadRecords = function(filter) {
                    return dataService.search[$scope.type](filter)
                       .then(function(response) {
                           $scope.hasMore = response.data.more;
                           return response.data.results;
                       });
                };

                function init() {

                    if ('autofill' in attrs) {
                        var nomeModelId = attrs.ngModel.split('.').pop();
                        $scope.ngModel = $scope.$parent.data.entity.variabili[nomeModelId];
                    }

                    if ($scope.ngModel) {

                        dataService.lookup[$scope.type]($scope.ngModel)
                            .then(function (response) {
                                $scope.localModel = response.data;
                            });
                    }
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('sprintApp')
    .directive('textlookup', textlookup);

    textlookup.$inject = ['dataService', '$log', 'utils'];

    function textlookup(dataService, $log, utils) {

        return {
            restrict: 'E',
            templateUrl: 'app/inputs/textlookup/textlookup.html',
            scope: {
                ngModel: '=',
                type: '@',
                id: '@',
                ngReadonly: '@'
            },
            link: function ($scope, element, attrs) {

                dataService.lookup[$scope.type]().then(function(response) {
                    $scope.value = response.data.value;
                })

            }
        }
    }
})();
(function() {
    'use strict';

    angular.module('sprintApp')
    .directive('selectlookup', selectlookup);

    selectlookup.$inject = ['dataService', '$log', 'utils'];

    function selectlookup(dataService, $log, utils) {

        return {
            restrict: 'E',
            templateUrl: 'app/inputs/selectlookup/selectlookup.html',
            scope: {
                ngModel: '=',
                type: '@',
                id: '@'
            },
            link: function ($scope, element, attrs) {

                dataService.lookup[$scope.type]().then(function(response) {
                    $scope.records = response.data;
                })

            }
        }
    }
})();
(function() {
    'use strict';

    angular.module('sprintApp')
    .directive('fileinput', fileinput);

    fileinput.$inject = ['dataService', '$log', 'utils'];

    /**
     *  Questa direttiva collabora in stretto contatto con FlowsAttachmentService
     *  in particolare per quel che riguarda allegati multiple.
     *  Se multiple e' true, verra' renderizzato l'intero insieme degli allegati
     *  Ognuno puo' essere sovrascritto
     *  Inoltre se ne possono aggiungere ulteriori (sempre multiple), che andranno a finire in coda all'array (es. allegati[5])
     *
     *  Per fare sto widget ho fatto una serie di hack non bruttissimi, ma poco manutenibili, cerchiamo di lasciarlo cosi' ~Martin
     */
    function fileinput(dataService, $log, utils) {

        return {
            restrict: 'E',
            templateUrl: 'app/inputs/fileinput/fileinput.html',
            scope: {
                name: '@',                          // diventera' il nome della variabile nel processo (es. decisioneContrattare o allegati)
                label: '@?',                        // la label di un documento predefinito (quella visualizzata, es. Decisione a Contrattare)
                legend: '@?',                       // la legend in caso di allegati multipli (es. Altri Allegati)
                nota: '@?',                         // TODO non ancora implementato
                accept: '@?',                       // tipi di file da prendere come allegati
                multiple: '=?',                     // se ci saranno piu' file
                min: '@?',
                max: '@?',
                cnrRequired: '=?',                  // tendenzialmente true
                metadatiPubblicazione: '=?',        // se visualizzare gli slider per Urp e Trasparenza
                metadatiPubblicazioneUrp: '=?',
                metadatiPubblicazioneTrasparenza: '=?',
                metadatiProtocollo: '=?',           // se visualizzare lo slider per il Protocollo
                pubblicazioneUrp: '=?',             // impostare manualmente il valore, lo slider sara' disabilitato
                pubblicazioneTrasparenza: '=?',     // impostare manualmente il valore, lo slider sara' disabilitato
                protocollo: '=?',                   // impostare manualmente il valore, lo slider sara' disabilitato
                pubblicazioneDisabilitato: '=?',    // disabilitare gli slider di pubblicazione senza impostare i valori
                pubblicazioneUrpDisabilitato: '=?',    // disabilitare gli slider di pubblicazione senza impostare i valori
                pubblicazioneTrasparenzaDisabilitato: '=?',    // disabilitare gli slider di pubblicazione senza impostare i valori
                protocolloDisabilitato: '=?',        // disabilitare gli slider di protocollo senza impostare i valori
                sliderProtocolloDisabilitato: '=?',
                mostraModifica: '=?',                // visualizzare la versione breve (espandibile) in modifica?
                soloMetadati: '=?',
                modificaLabel: '=?'
            },
            link: function ($scope, element, attrs) {

                $scope.addRow = function() {
                    if ($scope.rows.length < $scope.max)
                        $scope.rows.push({});
                    $scope.$parent.attachments[$scope.name+($scope.rows.length-1)] = {};
                    $scope.$parent.attachments[$scope.name+($scope.rows.length-1)].aggiorna = true;
                    return false;
                };
                $scope.removeRow = function() {
                    if ($scope.rows.length > $scope.min) {
                        $scope.rows.pop();
                        delete $scope.$parent.attachments[$scope.name+($scope.rows.length)];
                    }
                };

                function init() {
                    $scope.attrs = attrs;
                    $scope.popupOpen = false;

                    if ($scope.$parent.attachments === undefined)
                        $scope.$parent.attachments = {};

                    $scope.attachments = $scope.$parent.attachments;
                    $scope.taskId      = $scope.$parent.taskId;

                    // se sono in modifica, reimposto i dati
                    if ($scope.multiple) {
                        $scope.rows = [];
                        for (var el in $scope.$parent.attachments) {
                            if (el.startsWith($scope.name))
                                $scope.rows.push({});
                        }
                        $scope.min = $scope.min || $scope.rows.length || 0;
                        $scope.max = $scope.max || 999;
                        while ($scope.rows.length < $scope.min)
                            $scope.addRow();

                    } else {
                        $scope.rows = [{}];
                        if (!$scope.$parent.attachments[$scope.name]) {
                            $scope.$parent.attachments[$scope.name] = {};
                            $scope.$parent.attachments[$scope.name].aggiorna = true;
                        }
                    }

                    if ($scope.mostraModifica === undefined)
                        $scope.mostraModifica = true;

                }

                init();

                $scope.downloadFile = function(url, filename, mimetype) {
                    utils.downloadFile(url, filename, mimetype);
                };

                $scope.initRow = function (row, index) {
                    row.rowname = $scope.multiple ? $scope.name+index : $scope.name;
                    $scope.$parent.attachments[row.rowname] = $scope.$parent.attachments[row.rowname] || {};
                    $scope.$parent.attachments[row.rowname].name = row.rowname;
                    row.modifica = $scope.$parent.attachments[row.rowname].time !== undefined;

                    if (!row.modifica)  {
                        $scope.$parent.attachments[row.rowname].pubblicazioneUrp = $scope.pubblicazioneUrp;
                        $scope.$parent.attachments[row.rowname].pubblicazioneTrasparenza = $scope.pubblicazioneTrasparenza;
                        $scope.$parent.attachments[row.rowname].protocollo = $scope.protocollo;
                    }
                    
                    if ($scope.soloMetadati) 
                        $scope.$parent.attachments[row.rowname].aggiorna = true
                }

                $scope.onClickProtocollo = function(row) {
                    if (!$scope.$parent.attachments[row.rowname].protocollo) {
                        $scope.$parent.attachments[row.rowname].dataprotocollo = undefined;
                        $scope.$parent.attachments[row.rowname].numeroprotocollo = undefined;
                    }
                }

                $scope.open = function() {
                    $scope.popupOpen = true;
                };
            }
        }
    }
})();
(function() {
	'use strict';

	angular.module('sprintApp')
	.directive('date', date);

	date.$inject = ['dataService', '$log'];

	function date(dataService, $log) {
		return {
			restrict: 'E',
			templateUrl: 'app/inputs/date/date.html',
			scope: {
				ngModel: '=',
				ngRequired: '='
			},
			link: function($scope, element, attrs) {

				$scope.isOpen = false;
				$scope.open = function() {
					$scope.isOpen = true;
				}
				
				// l'autofill non funziona automaticamente per componenti custom
				if ('autofill' in attrs) {
					var nomeModelId = attrs.ngModel.split('.').pop();
					$scope.ngModel = $scope.$parent.data.entity.variabili[nomeModelId];
				}
			}
		};
	}
})();

(function() {
    'use strict';

    angular.module('sprintApp')
    .run(initialize);


    initialize.$inject = ['$rootScope', 'Lightbox', '$location'];

    function initialize ($rootScope, Lightbox, $location) {
        $rootScope.openDiagramModal = function(url) {
            Lightbox.openModal([url], 0);
        };

        var development = $location.$$host === 'localhost';
        $rootScope.development = development;
    }
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('login'); //serve per caricare il json con il messaggio di errore in caso di login non riuscito
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', 'ProfileService', '$q', '$state', 'dataService', 'AuthServerProvider', '$rootScope'];

    function HomeController ($scope, Principal, LoginService, ProfileService, $q, $state, dataService, AuthServerProvider, $rootScope) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        dataService.avvisi.getAttivi().then(function(response) {
            vm.avvisi = response.data;
        })

        // Duplicato da login.controller.js per l'emergenza Covid19 
        // TODO non duplicare codice, spostare in un service
        // TODO: prima passava da auth.service.js(login()) che poi richiamava auth.oauth2.service.js
        vm.signin = function(event) {
            event.preventDefault();
            vm.authenticationError = false;
            AuthServerProvider.login({
                username: vm.username.toLowerCase(),
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                $state.go('availableTasks');
                $rootScope.$broadcast('authenticationSuccess');
            }).catch(function () {
                vm.authenticationError = true;
            });
        }
        
        /* --- */

        function getAccount() {
            var principalPromise = Principal.identity()
            var profilePromise   = ProfileService.getProfileInfo();

            $q.all([principalPromise, profilePromise]).then(function(data) {
                vm.account = data[0];
                vm.profiles = data[1].activeProfiles;
                vm.isAuthenticated = Principal.isAuthenticated;
                if ( vm.isAuthenticated && vm.profiles.includes('cnr') )
                    getTasksCount();
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
  'use strict';

  angular.module('sprintApp')
  .filter('data', function () {
    return function(d) {
        return d ? moment(d).format('DD/MM/YYYY') : null;
    };
  })
      .filter('get', function () {
          return function (json, field) {
              return json ? JSON.parse(json)[field] : null;
          };
      })
  .filter('dataora', function () {
    return function(d) {
        return d ? moment(d).format('DD/MM/YYYY HH:mm') : null;
    };
  })
  .filter('dueDate', function () {
    return function (dueDate) {
      var s = null;
      if (dueDate) {
        var expired = new Date(dueDate).getTime() < new Date().getTime();
        var stringDate = moment(dueDate).format('DD/MM/YYYY');
        if (expired) {
          s = '<span class="label label-danger">scaduto il ' + stringDate + '</span>';
        } else {
          s = '<span>con scadenza: ' + stringDate + '</span>';
        }
      }
      return s;
    };
  })
  .filter('priority', function () {
    return function (priority) {
      var m = {
          'priority-1': {
            label: 'media',
            cssClass: 'label label-success'
          },
          'priority-3': {
            label: 'importante',
            cssClass: 'label label-warning'
          },
          'priority-5': {
            label: 'critica',
            cssClass: 'label label-danger'
          }
      };

      var p = m['priority-' + priority];

      return p ? '<span class="label ' + p.cssClass + '">' + p.label + '</b>' : '';
    };
  })
  .filter('inTable', function() {
    return function(columns){
        return columns.filter(function (el) {
                return el.inTable
            });
    };
  })
  .filter('numkeys', function() {
    return function(object) {
      return Object.keys(object).length;
    }
  });

})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ViewDialogController', ViewDialogController);

    ViewDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'View'];

    function ViewDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, View) {
        var vm = this;

        vm.view = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.view.id !== null) {
                View.update(vm.view, onSaveSuccess, onSaveError);
            } else {
                View.save(vm.view, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sprintApp:viewUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ViewDetailController', ViewDetailController);

    ViewDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'View'];

    function ViewDetailController($scope, $rootScope, $stateParams, previousState, entity, View) {
        var vm = this;

        vm.view = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sprintApp:viewUpdate', function(event, result) {
            vm.view = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ViewDeleteController',ViewDeleteController);

    ViewDeleteController.$inject = ['$uibModalInstance', 'entity', 'View'];

    function ViewDeleteController($uibModalInstance, entity, View) {
        var vm = this;

        vm.view = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            View.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('view', {
            parent: 'entity',
            url: '/view?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.view.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/view/views.html',
                    controller: 'ViewController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('view');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('view-detail', {
            parent: 'entity',
            url: '/view/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.view.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/view/view-detail.html',
                    controller: 'ViewDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('view');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'View', function($stateParams, View) {
                    return View.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'view',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('view-detail.edit', {
            parent: 'view-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/view/view-dialog.html',
                    controller: 'ViewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['View', function(View) {
                            return View.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('view.new', {
            parent: 'view',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/view/view-dialog.html',
                    controller: 'ViewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                processId: null,
                                type: null,
                                view: null,
                                version: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('view', null, { reload: 'view' });
                }, function() {
                    $state.go('view');
                });
            }]
        })
        .state('view.edit', {
            parent: 'view',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/view/view-dialog.html',
                    controller: 'ViewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['View', function(View) {
                            return View.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('view', null, { reload: 'view' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('view.delete', {
            parent: 'view',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/view/view-delete-dialog.html',
                    controller: 'ViewDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['View', function(View) {
                            return View.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('view', null, { reload: 'view' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sprintApp')
        .factory('View', View);

    View.$inject = ['$resource'];

    function View ($resource) {
        var resourceUrl =  'api/views/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ViewController', ViewController);

    ViewController.$inject = ['$scope', '$state', 'View', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ViewController ($scope, $state, View, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
//        todo: la paginazione non funziona con la ricerca JS(la lascio commentata per riprenderla eventualmente)
//        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPage = 1000;

        loadAll();

        function loadAll () {
            View.query({
//                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.views = data;
//                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('RelationshipDialogController', RelationshipDialogController);

    RelationshipDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Relationship'];

    function RelationshipDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Relationship) {
        var vm = this;

        vm.relationship = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.relationship.id !== null) {
                Relationship.update(vm.relationship, onSaveSuccess, onSaveError);
            } else {
                Relationship.save(vm.relationship, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sprintApp:relationshipUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('RelationshipDetailController', RelationshipDetailController);

    RelationshipDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Relationship'];

    function RelationshipDetailController($scope, $rootScope, $stateParams, previousState, entity, Relationship) {
        var vm = this;

        vm.relationship = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sprintApp:relationshipUpdate', function(event, result) {
            vm.relationship = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('RelationshipDeleteController',RelationshipDeleteController);

    RelationshipDeleteController.$inject = ['$uibModalInstance', 'entity', 'Relationship'];

    function RelationshipDeleteController($uibModalInstance, entity, Relationship) {
        var vm = this;

        vm.relationship = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Relationship.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('relationship', {
            parent: 'entity',
            url: '/relationship?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.relationship.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relationship/relationships.html',
                    controller: 'RelationshipController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relationship');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('relationship-detail', {
            parent: 'entity',
            url: '/relationship/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.relationship.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relationship/relationship-detail.html',
                    controller: 'RelationshipDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relationship');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Relationship', function($stateParams, Relationship) {
                    return Relationship.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'relationship',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('relationship-detail.edit', {
            parent: 'relationship-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relationship/relationship-dialog.html',
                    controller: 'RelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Relationship', function(Relationship) {
                            return Relationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('relationship.new', {
            parent: 'relationship',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relationship/relationship-dialog.html',
                    controller: 'RelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                groupName: null,
                                groupRelationship: null,
                                groupRole: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('relationship', null, { reload: 'relationship' });
                }, function() {
                    $state.go('relationship');
                });
            }]
        })
        .state('relationship.edit', {
            parent: 'relationship',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relationship/relationship-dialog.html',
                    controller: 'RelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Relationship', function(Relationship) {
                            return Relationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('relationship', null, { reload: 'relationship' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('relationship.delete', {
            parent: 'relationship',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relationship/relationship-delete-dialog.html',
                    controller: 'RelationshipDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Relationship', function(Relationship) {
                            return Relationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('relationship', null, { reload: 'relationship' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sprintApp')
        .factory('Relationship', Relationship);

    Relationship.$inject = ['$resource'];

    function Relationship ($resource) {
        var resourceUrl =  'api/relationships/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('RelationshipController', RelationshipController);

    RelationshipController.$inject = ['$scope', '$state', 'Relationship', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RelationshipController ($scope, $state, Relationship, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Relationship.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.relationships = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('NotificationRuleDialogController', NotificationRuleDialogController);

    NotificationRuleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NotificationRule'];

    function NotificationRuleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NotificationRule) {
        var vm = this;

        vm.notificationRule = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.notificationRule.id !== null) {
                NotificationRule.update(vm.notificationRule, onSaveSuccess, onSaveError);
            } else {
                NotificationRule.save(vm.notificationRule, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sprintApp:notificationRuleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('NotificationRuleDetailController', NotificationRuleDetailController);

    NotificationRuleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'NotificationRule'];

    function NotificationRuleDetailController($scope, $rootScope, $stateParams, previousState, entity, NotificationRule) {
        var vm = this;

        vm.notificationRule = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sprintApp:notificationRuleUpdate', function(event, result) {
            vm.notificationRule = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('NotificationRuleDeleteController',NotificationRuleDeleteController);

    NotificationRuleDeleteController.$inject = ['$uibModalInstance', 'entity', 'NotificationRule'];

    function NotificationRuleDeleteController($uibModalInstance, entity, NotificationRule) {
        var vm = this;

        vm.notificationRule = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NotificationRule.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notification-rule', {
            parent: 'entity',
            url: '/notification-rule?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.notificationRule.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notification-rule/notification-rules.html',
                    controller: 'NotificationRuleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('notificationRule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('notification-rule-detail', {
            parent: 'entity',
            url: '/notification-rule/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.notificationRule.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notification-rule/notification-rule-detail.html',
                    controller: 'NotificationRuleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('notificationRule');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NotificationRule', function($stateParams, NotificationRule) {
                    return NotificationRule.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'notification-rule',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('notification-rule-detail.edit', {
            parent: 'notification-rule-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification-rule/notification-rule-dialog.html',
                    controller: 'NotificationRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NotificationRule', function(NotificationRule) {
                            return NotificationRule.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('notification-rule.new', {
            parent: 'notification-rule',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification-rule/notification-rule-dialog.html',
                    controller: 'NotificationRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                processId: null,
                                taskName: null,
                                recipients: null,
                                eventType: null,
                                persona: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('notification-rule', null, { reload: 'notification-rule' });
                }, function() {
                    $state.go('notification-rule');
                });
            }]
        })
        .state('notification-rule.edit', {
            parent: 'notification-rule',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification-rule/notification-rule-dialog.html',
                    controller: 'NotificationRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NotificationRule', function(NotificationRule) {
                            return NotificationRule.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('notification-rule', null, { reload: 'notification-rule' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('notification-rule.delete', {
            parent: 'notification-rule',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification-rule/notification-rule-delete-dialog.html',
                    controller: 'NotificationRuleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NotificationRule', function(NotificationRule) {
                            return NotificationRule.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('notification-rule', null, { reload: 'notification-rule' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sprintApp')
        .factory('NotificationRule', NotificationRule);

    NotificationRule.$inject = ['$resource'];

    function NotificationRule ($resource) {
        var resourceUrl =  'api/notification-rules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('NotificationRuleController', NotificationRuleController);

    NotificationRuleController.$inject = ['$scope', '$state', 'NotificationRule', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function NotificationRuleController ($scope, $state, NotificationRule, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            NotificationRule.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.notificationRules = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('MembershipDialogController', MembershipDialogController);

    MembershipDialogController.$inject = ['$scope', 'dataService', '$uibModalInstance'];

    function MembershipDialogController($scope, dataService, $uibModalInstance) {
        $scope.save = function() {
            $scope.isSaving = true;

            dataService.userMemberships.createMembership($scope.membership.cnrgroup, $scope.membership.username, $scope.membership.grouprole)
                .then(function onSaveSuccess(result) {
                    $scope.$emit('sprintApp:membershipUpdate', result);
                    $uibModalInstance.close(result);
                    vm.isSaving = false;
                }, function onSaveError() {
                    vm.isSaving = false;
                });
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

(function() {
	'use strict';

	angular
		.module('sprintApp')
		.controller('MembershipDetailController', MembershipDetailController);

	MembershipDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Membership'];

	function MembershipDetailController($scope, $rootScope, $stateParams, entity, Membership) {
		$scope.membership = entity;
		$scope.load = function(id) {
			Membership.get({
				id: id
			}, function(result) {
				$scope.membership = result;
			});
		};
		var unsubscribe = $rootScope.$on('sprintApp:membershipUpdate', function(event, result) {
			$scope.membership = result;
		});
		$scope.$on('$destroy', unsubscribe);
	}
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('MembershipDeleteController', MembershipDeleteController);

    MembershipDeleteController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Membership'];

    function MembershipDeleteController($timeout, $scope, $uibModalInstance, entity, Membership) {
        $scope.membership = entity;
        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.confirmDelete = function(id) {
            Membership.delete({
                    id: id,
                },
                function() {
                    $uibModalInstance.close(true);
                });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('membership', {
                parent: 'entity',
                url: '/memberships',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'sprintApp.membership.home.title',
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/membership/memberships.html',
                        controller: 'MembershipController',
                    },
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('membership');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                },
            })
            .state('membership.detail', {
                parent: 'entity',
                url: '/membership/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'sprintApp.membership.detail.title',
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/membership/membership-detail.html',
                        controller: 'MembershipDetailController',
                    },
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('membership');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Membership', function($stateParams, Membership) {
                        return Membership.get({
                            id: $stateParams.id,
                        });
                    }],
                },
            })
            .state('membership.new', {
                parent: 'membership',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/membership/membership-dialog.html',
                        controller: 'MembershipDialogController',
                        size: 'lg',
                    }).result.then(function(result) {
                        $state.go('membership', null, {
                            reload: true,
                        });
                    }, function() {
                        $state.go('membership');
                    });
                }],
            })
            .state('membership.delete', {
                parent: 'membership',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/membership/membership-delete-dialog.html',
                        controller: 'MembershipDeleteController',
                        size: 'md',
                        resolve: {
                            entity: ['Membership', function(Membership) {
                                return Membership.get({
                                    id: $stateParams.id,
                                });
                            }],
                        },
                    }).result.then(function(result) {
                        $state.go('membership', null, {
                            reload: true,
                        });
                    }, function() {
                        $state.go('^');
                    });
                }],
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('sprintApp')
        .factory('Membership', Membership);

    Membership.$inject = ['$resource'];

    function Membership($resource) {
        var resourceUrl = 'api/memberships/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
            },
        });
    }
})();

(function() {
	'use strict';

	angular
		.module('sprintApp')
		.controller('MembershipController', MembershipController);

	MembershipController.$inject = ['$scope', '$state', 'Membership', 'ParseLinks', 'AlertService'];

	function MembershipController($scope, $state, Membership, ParseLinks, AlertService) {

		$scope.memberships = [];
		$scope.predicate = 'id';
		$scope.reverse = true;
		$scope.page = 1;
		$scope.loadAll = function() {
			Membership.query({
				page: $scope.page - 1,
				size: 20,
				sort: [$scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id']
			}, function(result, headers) {
				$scope.links = ParseLinks.parse(headers('link'));
				$scope.totalItems = headers('X-Total-Count');
				$scope.memberships = result;
			});
		};
		$scope.loadPage = function(page) {
			$scope.page = page;
			$scope.loadAll();
		};
		$scope.loadAll();


		$scope.refresh = function() {
			$scope.loadAll();
			$scope.clear();
		};

		$scope.clear = function() {
			$scope.membership = {
				grouprole: null,
				id: null
			};
		};
	}
})();
(function() {
    'use strict';

    angular
    .module('sprintApp')
    .controller('FormDialogController', FormDialogController);

    FormDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Form', '$sce', '$compile'];

    function FormDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Form, $sce, $compile) {
        var vm = this;

        vm.form = entity;
        vm.clear = clear;
        vm.save = save;
        vm.aceOpts = {  useWrapMode : false,
                showGutter: true,
                theme:'monokai',
                mode: 'html'
        };
        var tidyOpts = {
//            "doctype": "omit",
//            "omit-optional-tags": true,
            "indent": "auto",
            "indent-spaces": 2,
            "quiet": true,
            "tidy-mark": false,
//            "markup": true,
//            "output-xml": false,
//            "output-html": false,
//            "numeric-entities": true,
//            "quote-marks": true,
//            "quote-nbsp": false,
            "show-body-only": "auto",
//            "quote-ampersand": false,
//            "break-before-br": true,
//            "uppercase-tags": false,
//            "uppercase-attributes": false,
//            "drop-font-tags": true,
//            "tidy-mark": false,
//            "wrap": 100
          }
        vm.preview = "";
        vm.attachments = {};
        $scope.processVersion = vm.form.version;
        $scope.processDefinitionKey = vm.form.processDefinitionKey;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.form.id !== null) {
                Form.update(vm.form, onSaveSuccess, onSaveError);
            } else {
                Form.save(vm.form, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sprintApp:formUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.runTidy = function() {
            vm.form.form = html_beautify(vm.form.form);
            vm.reloadHtml();
        }
        vm.reloadHtml = function() {
            vm.preview = vm.form.form;
        }
    }

    angular
    .module('sprintApp').directive('compile', ['$compile', function ($compile) {
    return function(scope, element, attrs) {
      scope.$watch(
        function(scope) {
          // watch the 'compile' expression for changes
          return scope.$eval(attrs.compile);
        },
        function(value) {
          // when the 'compile' expression changes
          // assign it into the current DOM
          element.html(value);

          // compile the new DOM and link it to the current
          // scope.
          // NOTE: we only compile .childNodes so that
          // we don't get into infinite loop compiling ourselves
          $compile(element.contents())(scope);
        }
    );
  };
}]);
})();


(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('FormDetailController', FormDetailController);

    FormDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Form'];

    function FormDetailController($scope, $rootScope, $stateParams, previousState, entity, Form) {
        var vm = this;

        vm.form = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sprintApp:formUpdate', function(event, result) {
            vm.form = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('FormDeleteController',FormDeleteController);

    FormDeleteController.$inject = ['$uibModalInstance', 'entity', 'Form'];

    function FormDeleteController($uibModalInstance, entity, Form) {
        var vm = this;

        vm.form = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Form.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('form', {
            parent: 'entity',
            url: '/form?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.form.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/form/forms.html',
                    controller: 'FormController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('form');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('form-detail', {
            parent: 'entity',
            url: '/form/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.form.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/form/form-detail.html',
                    controller: 'FormDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('form');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Form', function($stateParams, Form) {
                    return Form.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'form',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('form-detail.edit', {
            parent: 'form-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/form/form-dialog.html',
                    controller: 'FormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xl',
                    resolve: {
                        entity: ['Form', function(Form) {
                            return Form.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('form.new', {
            parent: 'form',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/form/form-dialog.html',
                    controller: 'FormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xl',
                    resolve: {
                        entity: function () {
                            return {
                                processDefinitionKey: null,
                                version: null,
                                taskId: null,
                                form: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('form', null, { reload: 'form' });
                }, function() {
                    $state.go('form');
                });
            }]
        })
        .state('form.edit', {
            parent: 'form',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/form/form-dialog.html',
                    controller: 'FormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xl',
                    resolve: {
                        entity: ['Form', function(Form) {
                            return Form.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('form', null, { reload: 'form' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('form.delete', {
            parent: 'form',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/form/form-delete-dialog.html',
                    controller: 'FormDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Form', function(Form) {
                            return Form.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('form', null, { reload: 'form' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sprintApp')
        .factory('Form', Form);

    Form.$inject = ['$resource'];

    function Form ($resource) {
        var resourceUrl =  'api/forms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('FormController', FormController);

    FormController.$inject = ['$scope', '$state', 'Form', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FormController ($scope, $state, Form, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
//        todo: la paginazione non funziona con la ricerca JS(la lascio commentata per riprenderla eventualmente)
//        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPage = 1000;

        loadAll();

        function loadAll () {
            Form.query({
//                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.forms = data;
//                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('FaqDialogController', FaqDialogController);

    FaqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Faq'];

    function FaqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Faq) {
        var vm = this;

        vm.faq = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.faq.id !== null) {
                Faq.update(vm.faq, onSaveSuccess, onSaveError);
            } else {
                Faq.save(vm.faq, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sprintApp:faqUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('FaqDetailController', FaqDetailController);

    FaqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Faq'];

    function FaqDetailController($scope, $rootScope, $stateParams, previousState, entity, Faq) {
        var vm = this;

        vm.faq = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sprintApp:faqUpdate', function(event, result) {
            vm.faq = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('FaqDeleteController',FaqDeleteController);

    FaqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Faq'];

    function FaqDeleteController($uibModalInstance, entity, Faq) {
        var vm = this;

        vm.faq = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Faq.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('faq', {
            parent: 'entity',
            url: '/faq',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.faq.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/faq/faqs.html',
                    controller: 'FaqController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('faq');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('faq-detail', {
            parent: 'entity',
            url: '/faq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.faq.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/faq/faq-detail.html',
                    controller: 'FaqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('faq');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Faq', function($stateParams, Faq) {
                    return Faq.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'faq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('faq-detail.edit', {
            parent: 'faq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-dialog.html',
                    controller: 'FaqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Faq', function(Faq) {
                            return Faq.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('faq.new', {
            parent: 'faq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-dialog.html',
                    controller: 'FaqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                domanda: null,
                                risposta: null,
                                isReadable: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('faq', null, { reload: 'faq' });
                }, function() {
                    $state.go('faq');
                });
            }]
        })
        .state('faq.edit', {
            parent: 'faq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-dialog.html',
                    controller: 'FaqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Faq', function(Faq) {
                            return Faq.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('faq', null, { reload: 'faq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('faq.delete', {
            parent: 'faq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-delete-dialog.html',
                    controller: 'FaqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Faq', function(Faq) {
                            return Faq.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('faq', null, { reload: 'faq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sprintApp')
        .factory('Faq', Faq);

    Faq.$inject = ['$resource'];

    function Faq ($resource) {
        var resourceUrl =  'api/faqs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('FaqController', FaqController);

    FaqController.$inject = ['$scope', '$state', 'Faq'];

    function FaqController ($scope, $state, Faq) {
        var vm = this;
        
        vm.faqs = [];

        loadAll();

        function loadAll() {
            Faq.query(function(result) {
                vm.faqs = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ExternalMessageDialogController', ExternalMessageDialogController);

    ExternalMessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ExternalMessage'];

    function ExternalMessageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ExternalMessage) {
        var vm = this;

        vm.externalMessage = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.externalMessage.id !== null) {
                ExternalMessage.update(vm.externalMessage, onSaveSuccess, onSaveError);
            } else {
                ExternalMessage.save(vm.externalMessage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sprintApp:externalMessageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.lastSendDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ExternalMessageDetailController', ExternalMessageDetailController);

    ExternalMessageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ExternalMessage'];

    function ExternalMessageDetailController($scope, $rootScope, $stateParams, previousState, entity, ExternalMessage) {
        var vm = this;

        vm.externalMessage = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sprintApp:externalMessageUpdate', function(event, result) {
            vm.externalMessage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ExternalMessageDeleteController',ExternalMessageDeleteController);

    ExternalMessageDeleteController.$inject = ['$uibModalInstance', 'entity', 'ExternalMessage'];

    function ExternalMessageDeleteController($uibModalInstance, entity, ExternalMessage) {
        var vm = this;

        vm.externalMessage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ExternalMessage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('external-message', {
            parent: 'entity',
            url: '/external-message?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.externalMessage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/external-message/external-messages.html',
                    controller: 'ExternalMessageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('externalMessage');
                    $translatePartialLoader.addPart('externalMessageVerb');
                    $translatePartialLoader.addPart('externalMessageStatus');
                    $translatePartialLoader.addPart('externalApplication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('external-message-detail', {
            parent: 'entity',
            url: '/external-message/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.externalMessage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/external-message/external-message-detail.html',
                    controller: 'ExternalMessageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('externalMessage');
                    $translatePartialLoader.addPart('externalMessageVerb');
                    $translatePartialLoader.addPart('externalMessageStatus');
                    $translatePartialLoader.addPart('externalApplication');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ExternalMessage', function($stateParams, ExternalMessage) {
                    return ExternalMessage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'external-message',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('external-message-detail.edit', {
            parent: 'external-message-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-message/external-message-dialog.html',
                    controller: 'ExternalMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExternalMessage', function(ExternalMessage) {
                            return ExternalMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('external-message.new', {
            parent: 'external-message',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-message/external-message-dialog.html',
                    controller: 'ExternalMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                url: null,
                                verb: null,
                                payload: null,
                                status: null,
                                retries: null,
                                lastErrorMessage: null,
                                application: null,
                                creationDate: null,
                                lastSendDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('external-message', null, { reload: 'external-message' });
                }, function() {
                    $state.go('external-message');
                });
            }]
        })
        .state('external-message.edit', {
            parent: 'external-message',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-message/external-message-dialog.html',
                    controller: 'ExternalMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExternalMessage', function(ExternalMessage) {
                            return ExternalMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('external-message', null, { reload: 'external-message' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('external-message.delete', {
            parent: 'external-message',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-message/external-message-delete-dialog.html',
                    controller: 'ExternalMessageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ExternalMessage', function(ExternalMessage) {
                            return ExternalMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('external-message', null, { reload: 'external-message' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sprintApp')
        .factory('ExternalMessage', ExternalMessage);

    ExternalMessage.$inject = ['$resource', 'DateUtils'];

    function ExternalMessage ($resource, DateUtils) {
        var resourceUrl =  'api/external-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.lastSendDate = DateUtils.convertDateTimeFromServer(data.lastSendDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ExternalMessageController', ExternalMessageController);

    ExternalMessageController.$inject = ['$scope', '$state', 'ExternalMessage', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ExternalMessageController ($scope, $state, ExternalMessage, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.searchTerms = "";
        vm.externalMessage = {};
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        $scope.loadAll = function () {
            ExternalMessage.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                application: vm.externalMessage.application  || '',
                status: vm.externalMessage.status || '',
                payload: vm.externalMessage.payload || '',
                lastErrorMessage: vm.externalMessage.lastErrorMessage || '',
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.externalMessages = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        $scope.loadAll();
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('DynamiclistDialogController', DynamiclistDialogController);

    DynamiclistDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dynamiclist'];

    function DynamiclistDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dynamiclist) {
        var vm = this;

        vm.dynamiclist = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dynamiclist.id !== null) {
                Dynamiclist.update(vm.dynamiclist, onSaveSuccess, onSaveError);
            } else {
                Dynamiclist.save(vm.dynamiclist, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sprintApp:dynamiclistUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('DynamiclistDetailController', DynamiclistDetailController);

    DynamiclistDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Dynamiclist'];

    function DynamiclistDetailController($scope, $rootScope, $stateParams, previousState, entity, Dynamiclist) {
        var vm = this;

        vm.dynamiclist = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sprintApp:dynamiclistUpdate', function(event, result) {
            vm.dynamiclist = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('DynamiclistDeleteController',DynamiclistDeleteController);

    DynamiclistDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dynamiclist'];

    function DynamiclistDeleteController($uibModalInstance, entity, Dynamiclist) {
        var vm = this;

        vm.dynamiclist = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dynamiclist.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dynamiclist', {
            parent: 'entity',
            url: '/dynamiclist?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.dynamiclist.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dynamiclist/dynamiclists.html',
                    controller: 'DynamiclistController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dynamiclist');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dynamiclist-detail', {
            parent: 'entity',
            url: '/dynamiclist/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.dynamiclist.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dynamiclist/dynamiclist-detail.html',
                    controller: 'DynamiclistDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dynamiclist');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dynamiclist', function($stateParams, Dynamiclist) {
                    return Dynamiclist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dynamiclist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dynamiclist-detail.edit', {
            parent: 'dynamiclist-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dynamiclist/dynamiclist-dialog.html',
                    controller: 'DynamiclistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dynamiclist', function(Dynamiclist) {
                            return Dynamiclist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dynamiclist.new', {
            parent: 'dynamiclist',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dynamiclist/dynamiclist-dialog.html',
                    controller: 'DynamiclistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                listjson: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dynamiclist', null, { reload: 'dynamiclist' });
                }, function() {
                    $state.go('dynamiclist');
                });
            }]
        })
        .state('dynamiclist.edit', {
            parent: 'dynamiclist',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dynamiclist/dynamiclist-dialog.html',
                    controller: 'DynamiclistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dynamiclist', function(Dynamiclist) {
                            return Dynamiclist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dynamiclist', null, { reload: 'dynamiclist' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dynamiclist.delete', {
            parent: 'dynamiclist',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dynamiclist/dynamiclist-delete-dialog.html',
                    controller: 'DynamiclistDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dynamiclist', function(Dynamiclist) {
                            return Dynamiclist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dynamiclist', null, { reload: 'dynamiclist' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sprintApp')
        .factory('Dynamiclist', Dynamiclist);

    Dynamiclist.$inject = ['$resource'];

    function Dynamiclist ($resource) {
        var resourceUrl =  'api/dynamiclists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('DynamiclistController', DynamiclistController);

    DynamiclistController.$inject = ['$scope', '$state', 'Dynamiclist', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DynamiclistController ($scope, $state, Dynamiclist, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Dynamiclist.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dynamiclists = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('CnrgroupDialogController', CnrgroupDialogController);

    CnrgroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Cnrgroup'];

    function CnrgroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Cnrgroup) {
        var vm = this;

        vm.cnrgroup = entity;
//        vm.clear = clear;
//        vm.save = save;
        vm.cnrgroups = Cnrgroup.query({
              page: 0,
              size: 100,
              sort: 'ASC'
        });

        vm.checked = function checked(group){
            return this.cnrgroup.parents.filter(function(g){
                   	return g.id == group.id;
                   }).length >0;
        }

        vm.selectedParents = angular.copy(vm.cnrgroup.parents);

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.clear = function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.save = function save () {
            var parents = $('.parentsChecbox:checked').toArray(), parentsJson = [];

            parents.forEach(function(parent){
                parentsJson.push(JSON.parse(parent.dataset.value));
            });
            vm.isSaving = true;
//            $scope.parent = {
//                parents: [vm.cnrgroup.parents[1]]
//            };
            if (vm.cnrgroup.id !== null) {
                vm.cnrgroup.parents = parentsJson;
                Cnrgroup.update(vm.cnrgroup, onSaveSuccess, onSaveError);
            } else {
                Cnrgroup.save(vm.cnrgroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sprintApp:cnrgroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('CnrgroupDetailController', CnrgroupDetailController);

    CnrgroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Cnrgroup'];

    function CnrgroupDetailController($scope, $rootScope, $stateParams, previousState, entity, Cnrgroup) {
        var vm = this;

        vm.cnrgroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sprintApp:cnrgroupUpdate', function(event, result) {
            vm.cnrgroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('CnrgroupDeleteController',CnrgroupDeleteController);

    CnrgroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'Cnrgroup'];

    function CnrgroupDeleteController($uibModalInstance, entity, Cnrgroup) {
        var vm = this;

        vm.cnrgroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Cnrgroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cnrgroup', {
            parent: 'entity',
            url: '/cnrgroup?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.cnrgroup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cnrgroup/cnrgroups.html',
                    controller: 'CnrgroupController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cnrgroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cnrgroup-detail', {
            parent: 'entity',
            url: '/cnrgroup/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.cnrgroup.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cnrgroup/cnrgroup-detail.html',
                    controller: 'CnrgroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cnrgroup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Cnrgroup', function($stateParams, Cnrgroup) {
                    return Cnrgroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cnrgroup',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cnrgroup-detail.edit', {
            parent: 'cnrgroup-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cnrgroup/cnrgroup-dialog.html',
                    controller: 'CnrgroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cnrgroup', function(Cnrgroup) {
                            return Cnrgroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cnrgroup.new', {
            parent: 'cnrgroup',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cnrgroup/cnrgroup-dialog.html',
                    controller: 'CnrgroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                displayName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cnrgroup', null, { reload: 'cnrgroup' });
                }, function() {
                    $state.go('cnrgroup');
                });
            }]
        })
        .state('cnrgroup.edit', {
            parent: 'cnrgroup',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cnrgroup/cnrgroup-dialog.html',
                    controller: 'CnrgroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cnrgroup', function(Cnrgroup) {
                            return Cnrgroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cnrgroup', null, { reload: 'cnrgroup' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cnrgroup.delete', {
            parent: 'cnrgroup',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cnrgroup/cnrgroup-delete-dialog.html',
                    controller: 'CnrgroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Cnrgroup', function(Cnrgroup) {
                            return Cnrgroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cnrgroup', null, { reload: 'cnrgroup' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sprintApp')
        .factory('Cnrgroup', Cnrgroup);

    Cnrgroup.$inject = ['$resource'];

    function Cnrgroup ($resource) {
        var resourceUrl =  'api/cnrgroups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('CnrgroupController', CnrgroupController);

    CnrgroupController.$inject = ['$scope', '$state', 'Cnrgroup', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CnrgroupController ($scope, $state, Cnrgroup, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Cnrgroup.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.cnrgroups = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('BlacklistDialogController', BlacklistDialogController);

    BlacklistDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Blacklist'];

    function BlacklistDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Blacklist) {
        var vm = this;

        vm.blacklist = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.blacklist.id !== null) {
                Blacklist.update(vm.blacklist, onSaveSuccess, onSaveError);
            } else {
                Blacklist.save(vm.blacklist, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('flowsApp:blacklistUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('BlacklistDetailController', BlacklistDetailController);

    BlacklistDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Blacklist'];

    function BlacklistDetailController($scope, $rootScope, $stateParams, previousState, entity, Blacklist) {
        var vm = this;

        vm.blacklist = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('flowsApp:blacklistUpdate', function(event, result) {
            vm.blacklist = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('BlacklistDeleteController',BlacklistDeleteController);

    BlacklistDeleteController.$inject = ['$uibModalInstance', 'entity', 'Blacklist'];

    function BlacklistDeleteController($uibModalInstance, entity, Blacklist) {
        var vm = this;

        vm.blacklist = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Blacklist.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('blacklist', {
            parent: 'entity',
            url: '/blacklist?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'flowsApp.blacklist.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/blacklist/blacklists.html',
                    controller: 'BlacklistController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('blacklist');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('blacklist-detail', {
            parent: 'entity',
            url: '/blacklist/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'flowsApp.blacklist.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/blacklist/blacklist-detail.html',
                    controller: 'BlacklistDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('blacklist');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Blacklist', function($stateParams, Blacklist) {
                    return Blacklist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'blacklist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('blacklist-detail.edit', {
            parent: 'blacklist-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blacklist/blacklist-dialog.html',
                    controller: 'BlacklistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Blacklist', function(Blacklist) {
                            return Blacklist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('blacklist.new', {
            parent: 'blacklist',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blacklist/blacklist-dialog.html',
                    controller: 'BlacklistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                email: null,
                                processDefinitionKey: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('blacklist', null, { reload: 'blacklist' });
                }, function() {
                    $state.go('blacklist');
                });
            }]
        })
        .state('blacklist.edit', {
            parent: 'blacklist',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blacklist/blacklist-dialog.html',
                    controller: 'BlacklistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Blacklist', function(Blacklist) {
                            return Blacklist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('blacklist', null, { reload: 'blacklist' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('blacklist.delete', {
            parent: 'blacklist',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blacklist/blacklist-delete-dialog.html',
                    controller: 'BlacklistDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Blacklist', function(Blacklist) {
                            return Blacklist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('blacklist', null, { reload: 'blacklist' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sprintApp')
        .factory('Blacklist', Blacklist);

    Blacklist.$inject = ['$resource'];

    function Blacklist ($resource) {
        var resourceUrl =  'api/blacklists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('BlacklistController', BlacklistController);

    BlacklistController.$inject = ['$scope', '$state', 'Blacklist', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function BlacklistController ($scope, $state, Blacklist, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Blacklist.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.blacklists = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('AvvisoDialogController', AvvisoDialogController);

    AvvisoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Avviso'];

    function AvvisoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Avviso) {
        var vm = this;

        vm.avviso = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.avviso.id !== null) {
                Avviso.update(vm.avviso, onSaveSuccess, onSaveError);
            } else {
                Avviso.save(vm.avviso, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sprintApp:avvisoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('AvvisoDetailController', AvvisoDetailController);

    AvvisoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Avviso'];

    function AvvisoDetailController($scope, $rootScope, $stateParams, previousState, entity, Avviso) {
        var vm = this;

        vm.avviso = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sprintApp:avvisoUpdate', function(event, result) {
            vm.avviso = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('AvvisoDeleteController',AvvisoDeleteController);

    AvvisoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Avviso'];

    function AvvisoDeleteController($uibModalInstance, entity, Avviso) {
        var vm = this;

        vm.avviso = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Avviso.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('avviso', {
            parent: 'entity',
            url: '/avviso?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.avviso.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/avviso/avvisos.html',
                    controller: 'AvvisoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('avviso');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('avviso-detail', {
            parent: 'entity',
            url: '/avviso/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sprintApp.avviso.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/avviso/avviso-detail.html',
                    controller: 'AvvisoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('avviso');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Avviso', function($stateParams, Avviso) {
                    return Avviso.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'avviso',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('avviso-detail.edit', {
            parent: 'avviso-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/avviso/avviso-dialog.html',
                    controller: 'AvvisoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Avviso', function(Avviso) {
                            return Avviso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('avviso.new', {
            parent: 'avviso',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/avviso/avviso-dialog.html',
                    controller: 'AvvisoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                contenuto: null,
                                attivo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('avviso', null, { reload: 'avviso' });
                }, function() {
                    $state.go('avviso');
                });
            }]
        })
        .state('avviso.edit', {
            parent: 'avviso',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/avviso/avviso-dialog.html',
                    controller: 'AvvisoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Avviso', function(Avviso) {
                            return Avviso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('avviso', null, { reload: 'avviso' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('avviso.delete', {
            parent: 'avviso',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/avviso/avviso-delete-dialog.html',
                    controller: 'AvvisoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Avviso', function(Avviso) {
                            return Avviso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('avviso', null, { reload: 'avviso' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sprintApp')
        .factory('Avviso', Avviso);

    Avviso.$inject = ['$resource'];

    function Avviso ($resource) {
        var resourceUrl =  'api/avvisos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('AvvisoController', AvvisoController);

    AvvisoController.$inject = ['$scope', '$state', 'Avviso', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AvvisoController ($scope, $state, Avviso, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Avviso.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.avvisos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
  'use strict';

  angular.module('sprintApp')
  .directive('variables', variablesDirective);

  variablesDirective.$inject = ['dataService', '$sessionStorage', '$log'];

  function variablesDirective(dataService, $sessionStorage, $log) {

    return {
          restrict: 'E',
          scope: {
            variables: '=',
            labelClass: '='
          },
          templateUrl: 'app/components/variables/variables.html'
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('sprintApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sprintApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format 'id,asc' or 'id'
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Risultati da {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} a ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'di {{$ctrl.queryCount}} elementi.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('sprintApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('sprintApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular.module('sprintApp')
        .directive('taskList', taskListDirective);

    taskListDirective.$inject = ['dataService', '$localStorage', '$state', '$log', 'AlertService'];

    function taskListDirective(dataService, $localStorage, $state, $log, AlertService) {

        return {
            restrict: 'E',
            scope: {
                tasks: '=',
                inFirma: '='
            },
            templateUrl: 'app/components/task-list/task-list.html',
            link: function (scope, element, attrs) {

                scope.pooled = [];

                scope.claimTask = function (taskId, take) {
                    var user;
                    dataService.tasks.claim(taskId, take).then(function (data) {
                        $log.debug(data);
                        scope.pooled[taskId] = user !== undefined;
                        scope.$parent.loadAllTasks();
                    }, function (err) {
                        $log.error(err);
                        AlertService.error("Richiesta non riuscita<br>" + err.data.message);
                    });
                };

                scope.inCart = function (id) {
                    return $localStorage.cart && $localStorage.cart.hasOwnProperty(id);
                }

                scope.addToCart = function(task) {
                    $localStorage.cart = $localStorage.cart || {};
                    $localStorage.cart[task.id] = task;
                }

                scope.removeFromCart = function(task) {
                    delete $localStorage.cart[task.id];
                    if (Object.keys($localStorage.cart).length == 0) {
                        delete $localStorage.cart;
                        $state.go('availableTasks')
                    }
                }

            }
        };
    }
})();
(function() {
	'use strict';

	angular.module('sprintApp')
		.directive('taskDetails', taskDetailsDirective);

	taskDetailsDirective.$inject = ['dataService', '$sessionStorage', '$uibModal', '$log'];

	function taskDetailsDirective(dataService, $sessionStorage, $uibModal, $log) {

		return {
			restrict: 'E',
			scope: {
				variables: '=',
				title: '='
			},
			templateUrl: 'app/components/task-details/task-details.html',
			link: function(scope) {

				scope.modalTaskMetadata = function(variables, title) {
					$log.info(variables);
					$uibModal.open({
						templateUrl: 'app/components/task-details/detailModal.html',
						controllerAs: 'vm',
						controller: 'DetailModalController',
						size: 'md',
						resolve: {
							variables: function() {
								//escludo le variabili di tipo "_json"
								return variables.filter(function(variable) { return !variable.name.includes("_json");});
							},
							title: function() {
								return title;
							}
						}
					});
				};
			}
		};
	}
})();
(function() {
    'use strict';

    angular.module('sprintApp')
        .controller('DetailModalController', DetailModalController);

    DetailModalController.$inject = ['$uibModalInstance', 'variables', 'title'];

    function DetailModalController ($uibModalInstance, variables, title) {
        var vm = this;

        vm.cancel = cancel;
        vm.baseName = title;
        vm.variables = variables;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('SwitchUserService', SwitchUserService);

    SwitchUserService.$inject = ['$uibModal'];

    function SwitchUserService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/switchuser/switchuser.html',
                controller: 'SwitchUserController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('switchuser');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('SwitchUserController', SwitchUserController);

    SwitchUserController.$inject = ['$rootScope', '$state', '$timeout', 'dataService', '$uibModalInstance', '$window', 'Principal'];

    function SwitchUserController ($rootScope, $state, $timeout, dataService, $uibModalInstance, $window, Principal) {
        var vm = this;

        vm.impersonationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.switchUser = switchUser;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null
            };
            vm.impersonationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function switchUser (event) {
            event.preventDefault();

            dataService.authentication.impersonate(vm.username).then(function () {
                vm.impersonationError = false;
                $uibModalInstance.close();

                $rootScope.$broadcast('impersonationSuccess');
                Principal.authenticate(null);
                Principal.identity(true).then(function(account) {
                    $state.reload();
                });
            }, function(response) {
                vm.impersonationError = true;
            })
        }
    }
})();

(function() {
    'use strict';

    /**
     * Author: Martin
     *
     *  Uso:
     *  ----
     *
     *
     *  Inserire un entita' form nel db (mettiamo col nome X)
     *
     *  richiamare la form in un altra form con
     *
     *  <subform
     *    multiple=true
     *    subform-name="X"
     *    label="Questa e' una subform"
     *    ng-model="data.nomeDelModel"
     *    autofill />
     *
     *  Con questo meccanismo e' possibile inizializzare il model con qualunque valore arbitrario
     */

    angular.module('sprintApp')
    .directive('subform', subform);

    subform.$inject = ['dataService', '$log'];

    function subform(dataService, $log) {

        return {
            restrict: 'E',
            templateUrl: 'app/components/subform/subform.html',
            scope: {
                ngModel: '=',
                label: '@',
                multiple: '@',
                subformName: '@',
                min: '@?',
                max: '@?',
                autofill: '@?'
            },
            link: function ($scope, element, attrs) {
                $scope.min = $scope.min || 1;
                $scope.max = $scope.max || 999;
                $scope.ngModel = $scope.ngModel || [{}]

                $scope.processDefinitionKey = $scope.processDefinitionKey || $scope.$parent.processDefinitionKey;
                $scope.processVersion = $scope.processVersion || $scope.$parent.processVersion;
                $scope.formUrl = 'api/forms/'+ $scope.processDefinitionKey +"/"+ $scope.processVersion +"/"+ $scope.subformName;

//                if ($scope.json !== undefined)
//                  $scope.ngModel = JSON.parse($scope.json);
                if ('autofill' in attrs) {
                    var jsonName = attrs.ngModel.split('.').pop() + "_json";
                    if ($scope.$parent.data.entity.variabili[jsonName])
                        $scope.ngModel = JSON.parse($scope.$parent.data.entity.variabili[jsonName]);
                }

                $scope.addRow = function() {
                    if ($scope.ngModel.length < $scope.max)
                        $scope.ngModel.push({});
                    return false;
                };
                $scope.removeRow = function() {
                    if ($scope.ngModel.length > $scope.min)
                        $scope.ngModel.pop();
                    return false;
                };
            }
        }
    }
})();
(function() {
  "use strict";

  angular.module("sprintApp").directive("processList", processList);

  processList.$inject = ["$log"];

  function processList($log) {
    return {
      restrict: "E",
      scope: {
        processes: "=",
        paging: "="
      },
      templateUrl: "app/components/processlist/processlist.html",
      link: function($scope) {
        $scope.processes.forEach(function(process) {
          var appo = process.variables;
          process.variables = {};
          appo.map(function(el) {
            process.variables[el.name] = el.value;
          });
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('sprintApp')
  .directive('metadatum', metadatum);

  metadatum.$inject = ['dataService', '$uibModal', '$log'];

  function metadatum(dataService, $uibModal, $log) {

    return {
      restrict: 'E',
      templateUrl: 'app/components/metadatum/metadatum.html',
      scope: {
        label: '@',
        value: '@',
        type: '@?',
        columns: '=?',
        modalColumns: '=?',
        detailsLabel: '@?',
        rows: '=?',
        details: '@'
      },
      link: function ($scope, element, attrs) {

        $scope.type = $scope.type || "text";
        $scope.attrs = attrs;


        if ($scope.type === 'table') {
            $scope.details = attrs.details;
            if ($scope.columns === undefined)
                throw "Per metadati 'table' e' necessario fornire l'attributo 'columns'";


          $scope.$watch('rows', function(newValue) {
            if (newValue != undefined)
              $scope.righe = JSON.parse(newValue);
          });


          $scope.detailsModal = function(row) {
              $uibModal.open({
                  templateUrl: 'app/components/metadatum/detailsMetadatum.modal.html',
                  controller: 'DetailsMetadatumModalController',
                  controllerAs: 'vm',
                  size: 'md',
                  resolve: {
                      row: function() {
                          return row;
                      },
                      columns: function() {
                          return $scope.columns;
                      },
                      modalColumns: function() {
                          return $scope.modalColumns;
                      },
                      detailsLabel: function() {
                          return $scope.detailsLabel;
                      },
                  }
              })
          };
        }
      }
    }
  }
})();
(function() {
    'use strict';

    angular.module('sprintApp')
        .controller('DetailsMetadatumModalController', DetailsMetadatumModalController);

    DetailsMetadatumModalController.$inject = ['$uibModalInstance', 'detailsLabel', 'row', 'columns', 'modalColumns'];

    function DetailsMetadatumModalController ($uibModalInstance, detailsLabel, row, columns, modalColumns) {
        var vm = this;
        vm.row = row;
        vm.columns = modalColumns ? columns.concat(modalColumns) : columns;
        vm.detailsLabel = detailsLabel || 'Esperienze';
    }
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

//todo: serve per fare l'effetto "focus" sul nome dell'utente loggato che ora non c'è più?
        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            vm.authenticationError = false;
            Auth.login({
                username: vm.username.toLowerCase(),
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                if ($state.current.name === 'home')
                    $state.go('home');

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular.module('sprintApp')
        .directive('links', linksDirective);

//    linksDirective.$inject = [];

    function linksDirective() {
        return {
            restrict: 'E',
            scope: {
                links: '='
            },
            templateUrl: 'app/components/links/links.html'
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('sprintApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sprintApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'it',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .constant('paginationConstants', {
            'itemsPerPage': 50
        });
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function () {
  "use strict";

  angular.module("sprintApp").directive("cnrTree", cnrTree);

  cnrTree.$inject = ["dataService", "$sessionStorage", "$log"];

  function cnrTree(dataService, $sessionStorage, $log) {
    return {
      restrict: "E",
      scope: {
        siglaList: "@",
        listName: "@",
        stringList: "@",
        dipartimentiList: "@",
        cdsuo: "@?",
        label: "@",
        ngModel: "=",
        ngModelid: "=",
        searchId: "@"
      },
      templateUrl: "app/components/cnrtree/cnrtree.html",

      link: function link($scope, element, attrs) {
        $scope.treeConfig = {
          version: 1,
          core: {
            themes: {
              name: "default"
            }
          },
          plugins: ["search"]
        };

        $scope.$watch("filter", function (newVal, oldVal, scope) {
          if ($scope.treeInstance) {
            if (newVal === '') {
              $scope.treeInstance.jstree(true).clear_search();
              $scope.treeInstance.jstree(true).close_all();
            } else {
              $scope.treeInstance.jstree(true).search(newVal, true, true);
            }
          }
        })

        $scope.jsonlist = [];
        $scope.ignoreModelChanges = function () {
          return true;
        };

        function listToTree(list) {
          var map = {},
            node,
            roots = [],
            i;
          list = list.filter(function(el) {return el.enabled != 'n'});
          
          for (i = 0; i < list.length; i += 1) {
            map[list[i].id] = i; // initialize the map
            list[i].children = []; // initialize the children
          }
          for (i = 0; i < list.length; i += 1) {
            node = list[i];
            node.text = list[i].descrizione;
            if (node.idPadre !== 1) {
              // if you have dangling branches check that map[node.parentId] exists
              list[map[node.idPadre]].children.push(node);
            } else {
              roots.push(node);
            }
          }
          return roots;
        }

        if ($scope.stringList) {
          dataService.oil.byCategory().then(
            function (response) {
              $scope.jsonlist = listToTree(response.data);
              $scope.$parent.vm.taskVariables = $scope.jsonlist;
              $scope.treeConfig.version++;
            },
            function (response) {
              $log.error(response);
            }
          );
        } else {
          if ($scope.siglaList) {
            dataService.sigladynamiclist.byName($scope.listName).then(
              function (response) {
                var lists = JSON.parse(response.data.listjson);
                //mapping del json di risposta di SIGLA nel json atteso dal componente cnrtree
                $scope.jsonlist = lists["elements"].map(function (el) {
                  return {
                    id: el.codice_anac.split("-")[0],
                    text: el.ds_proc_amm
                  };
                });
                $scope.treeConfig.version++;
              },
              function (response) {
                $log.error(response);
              }
            );
          } else {
            if ($scope.dipartimentiList) {
              dataService.search.dipartimentiList(21).then(
                function (response) {
                  $scope.jsonlist = response.data.results.map(function (el) {
                    return {
                      id: el.value,
                      text: el.label,
                      icon: "glyphicon glyphicon-file"
                    };
                  });
                  $scope.treeConfig.version++;
                },
                function (response) {
                  $log.error(response);
                }
              );
            } else {
              dataService.dynamiclist.byName($scope.listName).then(
                function (response) {
                  var lists = JSON.parse(response.data.listjson);
                  var type =
                    $scope.cdsuo !== undefined && $scope.cdsuo !== ""
                      ? $scope.cdsuo
                      : "default";
                  $scope.jsonlist = lists[type];
                  $scope.treeConfig.version++;
                },
                function (response) {
                  $log.error(response);
                }
              );
            }
          }
        }

        $scope.readyCB = function () {
          if ("autofill" in attrs) {
            if ($scope.ngModelid) {
              $scope.treeInstance.jstree(true).select_node($scope.ngModelid);
            } else {
              var nomeModelId = attrs.ngModelid.split(".").pop();
              var idDaSelezionare =
                $scope.$parent.vm.taskVariables[nomeModelId];
              $scope.treeInstance.jstree(true).select_node(idDaSelezionare);
            }
          }
        };

        $scope.select_node = function (discard, selection) {
          if (selection.node.children.length === 0) {
            $scope.ngModel = selection.node.text;
            $scope.ngModelid = selection.node.id;
          } else {
            $scope.treeInstance.jstree(true).deselect_all({});
          }
        };
      }
    };
  }
})();

(function() {
    'use strict';

    angular.module('sprintApp')
    .directive('back', back);

    back.$inject = ['$window'];

    function back($window) {
        return {
            restrict: "A",
            link: function (scope, elem, attrs) {
                elem.bind("click", function () {
                    $window.history.back();
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular.module('sprintApp')
        .directive('attachments', attachmentsDirective);

    attachmentsDirective.$inject = ['dataService', '$sessionStorage', '$log', '$http', '$uibModal', 'utils', 'Principal', 'AlertService'];

    function attachmentsDirective(dataService, $sessionStorage, $log, $http, $uibModal, utils, Principal, AlertService) {

        return {
            restrict: 'E',
            templateUrl: 'app/components/attachments/attachments.html',
            scope: {
                processInstanceId: '@?',
                attachments: '@?',
                businesskey: '@?',
                taskId: '@?',
                showHistory: '@?',
                canPublish: '=',
                canUpdateAttachments: '='
            },
            link: function($scope, element, attrs) {

                function init() {
                    $scope.showHistory = $scope.showHistory === undefined ? true : $scope.showHistory;
                    $scope.loadAttachments();
                }

                function setResponse(response) {
                    $scope.attachments = utils.parseAttachments(response.data);
                }

                function logError(response) {
                    $log.error(response);
                }


                $scope.loadAttachments = function() {
                    if ($scope.processInstanceId !== undefined) {
                        dataService.processInstances.getAttachments($scope.processInstanceId)
                            .then(setResponse, logError);
                    } else {
                        if ($scope.taskId !== undefined) {
                            dataService.tasks.getAttachments($scope.taskId)
                                .then(setResponse, logError);
                        } else {
                            $log.error("processInstanceId e taskId non possono essere entrambi nulli!");
                        }
                    }

                }


                $scope.downloadFile = function(url, filename, mimetype) {
                    utils.downloadFile(url, filename, mimetype);
                }


                $scope.$watchGroup(['attachments'], function() {
                    if (typeof $scope.attachments === 'string' && $scope.attachments.length > 0)
                        $scope.attachments = JSON.parse($scope.attachments);
                });


                $scope.showFileHistory = function(attachmentName) {
                    $scope.fileHistory = [];
                    dataService.processInstances.attachmentHistory($scope.processInstanceId, attachmentName)
                        .then(function(response) {
                            $scope.fileHistory = response.data;
                            $uibModal.open({
                                templateUrl: 'fileHistoryModal.html',
                                scope: $scope
                            });
                        });
                };

                $scope.showFileActions = function(attachment) {
                    attachment.aggiorna = true;

                    $uibModal.open({
                        templateUrl: 'app/components/attachments/attachmentactions.modal.html',
                        controller: 'AttachmentActionsModalController',
                        controllerAs: 'vm',
                        scope: $scope,
                        resolve: {
                            attachment: function() {
                                return attachment;
                            },
                            processInstanceId: function() {
                                return $scope.processInstanceId;
                            },
                            businesskey: function() {
                                return $scope.businesskey;
                            }
                        }
                    });
                };

                $scope.addFile = function() {
                    $uibModal.open({
                        templateUrl: 'app/components/attachments/addattachment.modal.html',
                        controller: 'AddAttachmentModalController',
                        controllerAs: 'vm',
                        scope: $scope,
                        resolve: {
                            processInstanceId: function() {
                                return $scope.processInstanceId;
                            }
                        }
                    });
                };
                
                $scope.viewPdf = function(attachment) {
                    $scope.pdfTitle = attachment.filename;
            
                    updatePreview(attachment);
            
                    $scope.modalInstance = $uibModal.open({
                      templateUrl: 'myModalContent.html',
                      size: 'lg',
                      scope: $scope
                    });                    
                }
                
                $scope.onError = function(error) {
                    $scope.showPdfError = true;
                    $scope.pdfError = error.message;
                }
                
                function updatePreview(attachment) {
                    $scope.loading = 'loading';
                    $scope.pdfUrl = '';
                    $scope.xmlContent = '';
                    $http.get('/api/attachments/'+ $scope.processInstanceId +'/'+ attachment.name +'/data', {responseType: "arraybuffer"}).then(function(response) {
                        
                        $scope.loading = '';
                        $scope.total = response.data.total;
                        
                        var currentBlob = new Blob([response.data], {type: 'application/pdf'});
                        $scope.pdfUrl = URL.createObjectURL(currentBlob);
                        $scope.showPdfError = false;
                    }, function(err) {
                        $scope.onError(err.data)
                    });
                }

                init();
            }
        }
    }
})();
(function() {
  'use strict';

  angular.module('sprintApp')
  .controller('AttachmentActionsModalController', AttachmentActionsModalController);


  AttachmentActionsModalController.$inject = ['$scope', '$uibModalInstance', 'dataService', 'attachment', 'businesskey', 'processInstanceId', 'Upload', 'AlertService', '$log', 'utils'];

  function AttachmentActionsModalController ($scope, $uibModalInstance, dataService, attachment, businesskey, processInstanceId, Upload, AlertService, $log, utils) {

    var vm = this;

    $scope.attachments = {};
    $scope.attachments[attachment.name] = attachment;
    $scope.data = {};
    $scope.data.processInstanceId = processInstanceId;

    vm.attachment = attachment;

    vm.pubblicatoTrasparenza = vm.attachment.stati.indexOf("PubblicatoTrasparenza") >= 0;
    vm.businesskey = businesskey;
    $scope.pubblicaDocumentoTrasparenza = function(flag) {
      dataService.attachments.pubblicaDocumentoTrasparenza(processInstanceId, attachment.name, flag)
      .then(function() {
        $scope.loadAttachments();
        $uibModalInstance.close();
        AlertService.success("Richiesta completata con successo");
      }, function() {
        console.log("error")
      })
    }
    
    vm.pubblicatoUrp = vm.attachment.stati.indexOf("PubblicatoUrp") >= 0;
    $scope.data = {};
    
    $scope.pubblicaDocumentoUrp = function(flag) {
        dataService.attachments.pubblicaDocumentoUrp(processInstanceId, attachment.name, flag)
        .then(function() {
          $scope.loadAttachments();
          $uibModalInstance.close();
          AlertService.success("Richiesta completata con successo");
        }, function() {
          console.log("error")
        })
      }

    $scope.submitAggiornaDocumento = function(file) {

      utils.prepareForSubmit($scope.data, $scope.attachments);
      var suffix = $scope.data.tipoModifica || "";

      Upload.upload({
        url: 'api/attachments/'+ processInstanceId +'/'+ attachment.name +'/data/'+ suffix,
        data: $scope.data,
      }).then(function (response) {
        $scope.loadAttachments();
        $uibModalInstance.close();
        AlertService.success("Richiesta completata con successo");

      }, function (err) {
        $log.error(err);
        AlertService.error("Richiesta non riuscita<br>"+ err.data.message);
      });
    }

  }
})();
(function() {
  'use strict';

  angular.module('sprintApp')
  .controller('AddAttachmentModalController', AddAttachmentModalController);


  AddAttachmentModalController.$inject = ['$scope', '$uibModalInstance', 'dataService', 'processInstanceId', 'Upload', 'AlertService', '$log', 'utils'];

  function AddAttachmentModalController ($scope, $uibModalInstance, dataService, processInstanceId, Upload, AlertService, $log, utils) {

    var vm = this;
    vm.data = {processInstanceId: processInstanceId};
    $scope.attachments = {};
    $scope.data = {};
    $scope.data.processInstanceId = processInstanceId;

    $scope.submitDocumento = function(file) {

      utils.prepareForSubmit($scope.data, $scope.attachments);

      Upload.upload({
        url: 'api/attachments/'+ processInstanceId +'/data/new',
        data: $scope.data,
      }).then(function (response) {
        $scope.loadAttachments();
        $uibModalInstance.close();
        AlertService.success("Richiesta completata con successo");

      }, function (err) {
        $log.error(err);
        AlertService.error("Richiesta non riuscita<br>"+ err.data.message);
      });
    }
  }
})();
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('sprintApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('sprintApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-sprintApp-error');
                var entityKey = httpResponse.headers('X-sprintApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('sprintApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 15000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: 0,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('sprintApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-sprintApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-sprintApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('sprintApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage', '$cookies', '$location'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage, $cookies, $location) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
//                var Principal = $injector.get('Principal');
//                if (Principal.isAuthenticated()) {
//                    var Auth = $injector.get('Auth');
//                    Auth.authorize(true);
//                }
                 $cookies['KC_REDIRECT'] = '/#' + $location.url();
                 location.href = '/sso/login';            
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token && token.expires_at && token.expires_at > new Date().getTime()) {
                config.headers.Authorization = 'Bearer ' + token.access_token;
            }
            
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('sprintApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "it"');
                $cookies.putObject(name, 'it');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('it');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(true);
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('sprintApp')
        .constant('VERSION', "1.2.5")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        vm.gender = ["F", "M"];


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump,
            getBeans: getBeans
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
        
        function getBeans () {
          return $http.get('management/beans').then(function (response) {
              return response.data;
          });
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;
        vm.refresh();

        JhiMetricsService.getBeans().then(function (promise) {
          vm.beans = promise;
        });
        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('manageprocessdefinitions', {
            parent: 'admin',
            url: '/manageprocessdefinitions',
            data: {
                authorities: ['ROLE_ADMIN'],
//                todo
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/manageprocessdefinitions/manageprocessdefinitions.html',
                    controller: 'ManageProcessDefinitionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                todo: da risolvere (internazionalizzazione?)
//                    $translatePartialLoader.addPart('activeFlows');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ManageProcessDefinitionsController', ManageProcessDefinitionsController);

    ManageProcessDefinitionsController.$inject = ['$scope', 'paginationConstants', 'dataService', 'utils', '$log', 'Upload', 'AlertService'];

    function ManageProcessDefinitionsController($scope, paginationConstants, dataService, utils, $log, Upload, AlertService) {
        var vm = this;

        $scope.data = {};
        $scope.attachments = {};

        load();
        
        $scope.suspend = function(key) {
            dataService.definitions.suspend(key).then(success, error);
        }
        
        $scope.activate = function(key) {
            dataService.definitions.activate(key).then(success, error);
        }

        function success(response) {
            $log.info(response);
            AlertService.success("Richiesta completata con successo");
            $scope.data.procDef = undefined;
            load();
        }
        
        function error(err) {
            $log.error(err);
            AlertService.error("Richiesta non riuscita<br>"+ err.data.message);
        }

        function load() {
            dataService.definitions.all(true).then(function(response) {
               vm.procDefs = response.data.all;
            });
        }
        

        $scope.submitProcessDefinition = function(file) {

            utils.prepareForSubmit($scope.data, $scope.attachments)

            Upload.upload({
                url: 'api/processDefinitions/send',
                data: $scope.data,
            }).then(success, error);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('managemail', {
            parent: 'admin',
            url: '/managemail',
            data: {
                authorities: ['ROLE_ADMIN'],
//                todo
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/managemail/managemail.html',
                    controller: 'ManageMailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                todo: da risolvere (internazionalizzazione?)
//                    $translatePartialLoader.addPart('activeFlows');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
  'use strict';

  angular
  .module('sprintApp')
  .controller('ManageMailController', ManageMailController);

  ManageMailController.$inject = ['$scope', 'paginationConstants', 'dataService', 'utils', '$log', 'Upload'];

  function ManageMailController($scope, paginationConstants, dataService, utils, $log, Upload) {
    var vm = this;

    dataService.mail.isActive().then(function(response) {
      vm.active = response.data;
      $scope.$watch('vm.active', function(newValue) {
        dataService.mail.setActive(newValue);
      });
    });

    dataService.mail.getUsers().then(function(response) {
      vm.users = response.data;
    });

    $scope.setUsers = function() {
      dataService.mail.setUsers(vm.users);
    }




  }
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('sprintApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            vm.fromDatea = fromDate;
            vm.toDatea   = toDate;

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
	'use strict';

	angular
		.module('sprintApp')
		.controller('SettingsController', SettingsController);

	SettingsController.$inject = ['User', 'Principal', 'Auth', 'JhiLanguageService', /* 'User',/* "entity",*/ '$translate'];

	function SettingsController(User, Principal, Auth, JhiLanguageService, /* User,entity,*/ $translate) {
		var vm = this;

		vm.error = null;
		vm.save = save;
		//        vm.settingsAccount = entity;
		vm.settingsAccount = null;
		vm.success = null;
		vm.gender = ["F", "M"];

		//precaricamento informazioni utente
		Principal.identity().then(function(account) {
			User.get({
				login: account.login
			}, function(result) {
				vm.settingsAccount = result;
			});
		});


		function save() {
			User.update(vm.settingsAccount,
				function onSaveSuccess() {
					vm.error = null;
					vm.success = 'OK';
				},
				function onSaveError() {
					vm.success = null;
					vm.error = 'ERROR';
				});
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('sprintApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('sprintApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){'use strict';angular.module('sprintApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Benvenuti</h1><p class="lead">Benvenuti nella Scrivania Digitale CNR</p><hr><div ng-show="vm.avvisi.length > 0"><h2>Avvisi</h2><div class="alert alert-warning" ng-repeat="avviso in vm.avvisi">{{avviso.contenuto}}</div><hr></div><div><div class="alert alert-danger" ng-show="vm.authenticationError" translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><div ng-switch-when="false" ng-if="app == \'cnr\'"><p>Reindirizzamento alla schermata di login in corso. Per autenticarsi usare le credenziali Siper.</p></div><div ng-switch-when="false" ng-if="app !== \'cnr\'">Per autenticarsi usare il menu\' "Utente" usando le credenziali dell\'applicazione.</div><div ng-if="app === \'showcase\'"><hr><p>Questa versione "Showcase" della Scrivania Digitale contiene un semplice flusso di Richiesta Permessi/Ferie per illustrare le funzionalit\xE0 del sistema</p><p>Sono presenti i seguenti utenti:<ul><li>utente1:utente1 che, come dipendente pu\xF2 fare una richiesta di ferie attraverso una form apposita</li><li>utente2:utente2 e utente3:utente3 che, come segreteria, rivedono e inoltrano la richiesta al direttore</li><li>direttore:utente4 che approva la richiesta</li><li>admin:admin che non ha funzioni nel flusso, ma pu\xF2 eseguire azioni speciali nel sistema</li></ul></p><p>In particolare gli utenti del ruolo Segreteria possono entrambi eseguire il compito di inoltrare la richiesta. Se uno di loro decide di prenderlo in carico, l\'altro non potr\xE0 eseguirlo, ma lo potr\xE0 visionare nella scheda "Compiti di ruolo in carico ad altri".</p><p>Quando la richiesta passa al direttore (o all\'utente1 che ha avviato il flusso), il compito \xE8 assegnato direttamente a quell\'utente</p><p>Nella schermata dei dettagli del flusso \xE8 possibile visionare tutti i metadati del flusso (compresi i documenti allegati) e la loro storia, ed esportarne un docuemento di sintesi in formato pdf.</p><p>Nella schermata della ricerca \xE8 possibile ricercare i flussi avviati e terminati, anche per chiavi di ricerca (definite per tipo di flusso).</p><hr><p>In questa versione della Scrivania Digitale le notifiche email sono disabilitate.</p></div><div class="row" ng-switch-when="true" ng-if="app == \'cnr\'"><div class="col-md-12 well"><div><a class="btn btn-primary btn-block" style="margin: 10px" href="https://scrivaniadigitale.cnr.it">Cliccare qui per autenticarsi con la<br>versione precedente della Scrivania Digitale</a></div></div></div></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="phone" translate="global.form.phone">Phone</label><input id="phone" name="phone" class="form-control" ng-model="vm.settingsAccount.phone" placeholder="{{\'global.form.phone.placeholder\' | translate}}" ng-model="vm.settingsAccount.phone"></div><div class="form-group"><label for="gender" translate="global.form.gender">Gender</label><input id="gender" name="gender" class="form-control" ng-model="vm.settingsAccount.gender" placeholder="{{\'global.form.gender.placeholder\' | translate}}" ng-model="vm.settingsAccount.gender"></div><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="phone" translate="global.form.phone">Phone</label><input id="phone" name="phone" class="form-control" ng-model="vm.settingsAccount.phone" placeholder="{{\'global.form.phone.placeholder\' | translate}}" ng-model="vm.settingsAccount.phone"></div><div class="form-group"><label translate="global.form.gender">Gender</label><select class="form-control" name="gender" ng-model="vm.settingsAccount.gender" ng-options="gender as gender for gender in vm.gender track by gender" placeholder="{{\'global.form.gender.placeholder\' | translate}}"></select></div><div class="form-group"><label for="langKey" translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span> {{audit.data | json}}</td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 translate="configuration.title">Configuration</h2><span translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span translate="configuration.table.prefix">Prefix</span></th><th translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 translate="logs.title">Logs</h2><p translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/managemail/managemail.html','<div ng-cloak><div class="row"><div class="col-md-6 col-md-offset-3"><h1>Gestisci Notifiche Email</h1><div class="btn-group"><label class="btn btn-danger" ng-model="vm.active" uib-btn-radio="false">Disattivate</label><label class="btn btn-success" ng-model="vm.active" uib-btn-radio="true">Attivate</label></div><h1>Indirizzi da notificare</h1><h4>Da grandi poteri derivano grandi responsabilita\'</h4><form novalidate class="flows-form" name="mailUsersForm" ng-submit="setUsers()"><div class="form-group"><label>Utenti (separati da virgola, senza spazi)</label><input class="form-control" type="text" name="users" label="Users" ng-model="vm.users"> <button class="btn btn-primary" type="submit" ng-disabled="processDefinitionForm.$invalid">invia <span class="glyphicon glyphicon-arrow-right"></span></button></div></form></div></div><pre ng-if="isDevelopment">\t{{vm | json}} </pre></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" translate="health.table.service">Service Name</th><th class="col-md-2 text-center" translate="health.table.status">Status</th><th class="col-md-2 text-center" translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="health.details.name">Name</th><th class="col-md-6 text-left" translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/manageprocessdefinitions/manageprocessdefinitions.html','<div ng-cloak><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Processi Caricati (ultima versione)</h1><p><ul><li ng-repeat="procDef in vm.procDefs">{{procDef.id}} <span ng-if="procDef.suspended" class="label label-primary">Sospeso</span> <a href ng-if="procDef.suspended" ng-click="activate(procDef.key)"><span class="glyphicon glyphicon-arrow-up" title="Attiva"></span></a> <a href ng-if="!procDef.suspended" ng-click="suspend(procDef.key)"><span class="glyphicon glyphicon-arrow-down" title="Sospendi"></span></a></li></ul></p><hr><h2>Carica o aggiorna Process Definition</h2><h4>Da grandi poteri derivano grandi responsabilita\'</h4><form novalidate class="flows-form" name="processDefinitionForm" ng-submit="submitProcessDefinition(picFile)"><div><fileinput name="procDef" label="Process Definition" multiple="false" cnr-required="true"></div><button class="btn btn-primary" type="submit" ng-disabled="processDefinitionForm.$invalid">invia <span class="glyphicon glyphicon-arrow-right"></span></button></form></div></div><pre>\t{{data | json}} </pre></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="metrics.refresh.button">Refresh</span></button></p><h3 translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b translate="metrics.jvm.memory.title">Memory</b><p><span translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" translate="metrics.updating">Updating...</div><h3 translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table><pre>{{vm.beans | json}}</pre></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label translate="userManagement.gender">Gender</label><select class="form-control" name="langKey" ng-model="vm.user.gender" ng-options="gender as gender for gender in vm.gender track by gender"></select></div><div class="form-group"><label class="control-label" translate="userManagement.phone">Phone</label><input type="text" class="form-control" name="phone" ng-model="vm.user.phone" ng-maxlength="20"><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" ng-model="vm.user.activated"> <span translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/cnrtree/cnrtree.html','<strong>{{label}}</strong> <span class="glyphicon glyphicon-question-sign" ng-show="item.placeholder" data-toggle="tooltip" data-placement="top" title="{{item.placeholder}}"></span><div class="jstree-bootstrap"><div><div ng-show="searchId" style="padding: 10px"><form class="form-inline"><label>Filtra:</label><input class="form-control" type="text" placeholder="Codice" ng-model="filter" ng-model-options="{debounce: 250, allowInvalid: false}"></form></div><div js-tree="treeConfig" ng-model="jsonlist" tree="treeInstance" should-apply="ignoreModelChanges()" tree-events="ready:readyCB;select_node:select_node"></div></div></div>');
$templateCache.put('app/components/attachments/addattachment.modal.html','<div class="modal-header"><h4 class="modal-title">Carica un ulteriore documento</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><h4>Carica Documento</h4><form novalidate class="flows-form" name="aggiornaDocumentoForm" ng-submit="submitDocumento(picFile)"><div><fileinput name="newfile" multiple="false" cnr-required="true" metadati-pubblicazione-urp="false" metadati-pubblicazione-trasparenza="false" metadati-protocollo="true"></div><button class="btn btn-primary" type="submit" ng-disabled="aggiornaDocumentoForm.$invalid">Invia <span class="glyphicon glyphicon-arrow-right"></span></button></form></div></div></div><div class="modal-footer"><button class="btn btn-primary" type="button" ng-click="$dismiss()">Chiudi</button></div>');
$templateCache.put('app/components/attachments/attachmentactions.modal.html','<div class="modal-header"><h4 class="modal-title">Azioni sul file {{vm.attachment.name}}</h4></div><div class="modal-body"><div class="row" ng-if="vm.businesskey.indexOf(\'Acquisti\') == 0"><div class="row" ng-if="canPublish"><div class="col-md-12"><h4>Pubblica Documento in Trasparenza</h4><div class="btn-group"><p>Stato attuale del documento: <span ng-if="vm.attachment.stati.indexOf(\'PubblicatoTrasparenza\') == -1">Non</span> Pubblico in Trasparenza</p><p><button type="button" ng-if="vm.attachment.stati.indexOf(\'PubblicatoTrasparenza\') == -1" class="btn btn-success btn-sm" ng-click="pubblicaDocumentoTrasparenza(true)"><span class="glyphicon glyphicon-eye-open"></span> Pubblica in Trasparenza</button> <button type="button" ng-if="vm.attachment.stati.indexOf(\'PubblicatoTrasparenza\') !== -1" class="btn btn-danger btn-sm" ng-click="pubblicaDocumentoTrasparenza(false)"><span class="glyphicon glyphicon-eye-close"></span> Rimuovi da Trasparenza</button></p></div></div></div><div class="row" ng-if="canPublish"><div class="col-md-12"><h4>Pubblica Documento in Urp</h4><div class="btn-group"><p>Stato attuale del documento: <span ng-if="vm.attachment.stati.indexOf(\'PubblicatoUrp\') == -1">Non</span> Pubblico in Urp</p><p><button type="button" ng-if="vm.attachment.stati.indexOf(\'PubblicatoUrp\') == -1" class="btn btn-success btn-sm" ng-click="pubblicaDocumentoUrp(true)"><span class="glyphicon glyphicon-eye-open"></span> Pubblica in Urp</button> <button type="button" ng-if="vm.attachment.stati.indexOf(\'PubblicatoUrp\') !== -1" class="btn btn-danger btn-sm" ng-click="pubblicaDocumentoUrp(false)"><span class="glyphicon glyphicon-eye-close"></span> Rimuovi da Urp</button></p></div></div></div></div><hr><div class="row" ng-if="canUpdateAttachments"><div class="col-md-12" ng-if="vm.attachment.stati.indexOf(\'Protocollato\') == -1"><h4>Aggiorna Documento</h4><form novalidate class="flows-form" name="aggiornaDocumentoForm" ng-submit="submitAggiornaDocumento(picFile)"><div><fileinput name="{{vm.attachment.name}}" multiple="false" metadati-protocollo="true" mostra-modifica="false" cnr-required="true"></div><button class="btn btn-primary" type="submit" ng-disabled="aggiornaDocumentoForm.$invalid">invia <span class="glyphicon glyphicon-arrow-right"></span></button></form></div><div class="col-md-12" ng-if="vm.attachment.stati.indexOf(\'Protocollato\') != -1"><h4>Aggiorna Documento Protocollato</h4><div class="col-lg-20 col-lg-offset-0 bg-info cnr-descrizione-task">I documenti protocollati non possono essere sostituiti allo stesso modo dei documenti non protocollati. Selezionare se inserire una RETTIFICA a un documento protocollato, o una SOSTITUZIONE di un nuovo file con un nuovo protocollo</div><div class="form-group text-center"><label for="tipoModifica">Tipo Modifica</label><select id="tipoModifica" style="width: auto" ng-model="data.tipoModifica"><option value="sostituzione">Sostituzione</option><option value="rettifica">Rettifica</option></select></div><div class="row" ng-if="data.tipoModifica == \'sostituzione\'"><div class="col-md-12"><form novalidate class="flows-form" name="aggiornaSostituzioneForm" ng-submit="submitAggiornaDocumento(picFile)"><div><fileinput name="{{vm.attachment.name}}_sostituzione" label="{{vm.attachment.label}}" multiple="false" cnr-required="true" metadati-protocollo="true" protocollo="true" metadati-pubblicazione="false" pubblicazione-trasparenza="vm.attachment.pubblicazioneTrasparenza" pubblicazione-urp="vm.attachment.pubblicazioneUrp" pubblicazione-disabilitato="true" slider-protocollo-disabilitato="true"></div><div class="form-group"><label for="motivoSostituzione">Motivo sostituzione</label><input type="text" id="motivoSostituzione" ng-model="data.motivoSostituzione" class="form-control" required></div><button class="btn btn-primary" type="submit" ng-disabled="aggiornaSostituzioneForm.$invalid">invia <span class="glyphicon glyphicon-arrow-right"></span></button></form></div></div><div class="row" ng-if="data.tipoModifica == \'rettifica\'"><div class="col-md-12"><form novalidate class="flows-form" name="rettificaForm" ng-submit="submitAggiornaDocumento(picFile)"><div><fileinput name="{{vm.attachment.name}}_rettifica" label="Rettifica {{vm.attachment.label}}" multiple="false" cnr-required="true" metadati-protocollo="true" protocollo="true" metadati-pubblicazione="false" pubblicazione-trasparenza="vm.attachment.pubblicazioneTrasparenza" pubblicazione-urp="vm.attachment.pubblicazioneUrp" pubblicazione-disabilitato="true" slider-protocollo-disabilitato="true"></div><button class="btn btn-primary" type="submit" ng-disabled="rettificaForm.$invalid">invia <span class="glyphicon glyphicon-arrow-right"></span></button></form></div></div></div></div></div><div class="modal-footer"><button class="btn btn-primary" type="button" ng-click="$dismiss()"><span class="glyphicon glyphicon-remove"></span> Chiudi</button></div>');
$templateCache.put('app/components/attachments/attachments.html','<ul class="list-unstyled"><li ng-repeat="attachment in attachments track by $index"><strong>{{ attachment.label || attachment.name}}:</strong> <a href ng-click="downloadFile(\'/api/attachments/\'+ processInstanceId +\'/\'+ attachment.name +\'/data\', attachment.filename, attachment.mimetype)">{{attachment.filename}} </a><a href ng-if="attachment.mimetype === \'application/pdf\'" ng-click="viewPdf(attachment)"><span class="glyphicon glyphicon-search" title="Visualizza"></span></a> <a href ng-if="showHistory === true" ng-click="showFileHistory(attachment.name)"><span class="glyphicon glyphicon-time" title="Cronologia"></span></a> <a href ng-if="canPublish || canUpdateAttachments" ng-click="showFileActions(attachment)"><span class="glyphicon glyphicon-cog" title="Azioni"></span></a> <span class="label label-primary" ng-if="attachment.pubblicazioneUrp">Pubblicabile Urp</span> <span class="label label-primary" ng-if="attachment.pubblicazioneTrasparenza">Pubblicabile in Trasparenza</span> <span class="label label-primary" ng-if="attachment.protocollo">Protocollo ({{attachment.numeroProtocollo}})</span> <span ng-repeat="stato in attachment.stati"><span class="label label-primary label-{{stato}}">{{stato}} <span ng-if="stato == \'Protocollato\'">({{attachment.numeroProtocollo}})</span></span></span><p has-authority="ROLE_ADMIN">{{ attachment | json }}</p></li></ul><button class="btn btn-xs btn-primary" ng-if="canUpdateAttachments" ng-click="addFile()"><span class="glyphicon glyphicon-plus-sign"></span> Carica un ulteriore documento</button><script type="text/ng-template" id="fileHistoryModal.html"><div class="modal-header">\n        <h4 class="modal-title">Storia del file {{name}}</h4>\n    </div>\n    <div class="modal-body">\n\n        <ul>\n            <li ng-repeat="file in fileHistory">\n                <strong>{{file.time | dataora}}:</strong> <br>\n                L\'utente <strong>{{file.username}}</strong> <br>\n                <span ng-if="file.metadati.azione">ha compiuto l\'azione <strong>{{file.metadati.azione}}</strong><br></span>\n                <span ng-if="file.metadati.azione == \'SostituzioneProtocollo\'">con motivo <strong>{{file.metadati.motivoSostituzione}}</strong><br></span>\n                sul file <a href ng-click="downloadFile(file.url, file.filename, file.mimetype)">{{file.filename}}</a>\n                <span ng-repeat="state in file.metadati.stati">\n                    <span class="label label-primary label-{{state}}">{{state}}\n                        <span ng-if="stato == \'Protocollato\'"> ({{file.numeroProtocollo}})</span>\n                    </span>\n                </span> <br>\n                <span ng-if="file.taskName">nell\'ambito del task <strong>{{file.taskName}}</strong></span>\n            </li>\n        </ul>\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-primary" type="button" ng-click="$dismiss()">Chiudi</button>\n    </div></script><script type="text/ng-template" id="myModalContent.html"><div class="modal-header">\n        <h3 class="modal-title" id="modal-title">Visualizzazione del file {{pdfTitle}}</h3>\n    </div>\n    <div class="modal-body" id="modal-body" ng-show="!loading">\n\n        <div>\n            <ng-pdf template-url="app/components/attachments/pdfviewer.html" scale="page-fit"></ng-pdf>\n        </div>\n\n    </div>\n    <div class="modal-body" id="modal-body-loading" ng-show="loading">\n        <div class="text-center"><h3>Caricamento</h3></div>\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-primary" type="button" ng-click="modalInstance.close()">OK</button>\n    </div></script>');
$templateCache.put('app/components/attachments/pdfviewer.html','<nav ng-class="getNavStyle(fit)"><div class="btn-toolbar" role="toolbar"></div><div class="btn-group" role="group" aria-label="pages"><button class="btn btn-primary" ng-click="goPrevious()"><span class="glyphicon glyphicon-chevron-left"></span></button> <button class="btn btn-primary" ng-click="goNext()"><span class="glyphicon glyphicon-chevron-right"></span></button></div><div class="btn-group" role="group" aria-label="zoom"><button class="btn btn-primary" ng-click="zoomIn()"><span class="glyphicon glyphicon-zoom-in"></span></button> <button class="btn btn-primary" ng-click="fit()"><span>100%</span></button> <button class="btn btn-primary" ng-click="zoomOut()"><span class="glyphicon glyphicon-zoom-out"></span></button></div></nav><hr><div class="alert alert-danger" ng-if="showPdfError"><p>Errore nel caricamento del file relativo alla risorsa</p><p>{{pdfError}}</p></div>{{loading}}');
$templateCache.put('app/components/links/links.html','<div ng-show="links.length > 0"><hr><ul class="list-unstyled"><h4>Link ad altri workflow</h4><br><li ng-repeat="link in links"><strong><a ng-href="#/details?processInstanceId={{link[\'processInstanceId\']}}">{{link[\'titolo\']}}</a></strong></li></ul></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2" ng-if="app === \'cnr\'"><p>Sessione scaduta, reindirizzamento alla pagina di autenticazione in corso</p></div><div class="col-md-8 col-md-offset-2" ng-if="app !== \'cnr\'"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" translate="global.form.username">Login</label><input type="text" class="form-control" id="username" style="text-transform: lowercase" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" translate="login.form.password">Password</label><input type="password" class="form-control" id="password" style="text-transform: lowercase" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><button type="submit" class="btn btn-primary" translate="login.form.button">Sign in</button></form><p></p></div></div></div>');
$templateCache.put('app/components/metadatum/detailsMetadatum.modal.html','<div class="modal-header"><h4>{{vm.detailsLabel}}</h4><div class="task-history"><div ng-repeat="column in vm.columns"><h5 ng-if="!column.table"><b>{{column.label}}:</b> {{vm.row[column.field]}}</h5><div ng-if="column.table" class="well"><h5><b>{{column.label}}</b></h5><table class="table table-striped table-bordered table-condensed table-hover"><thead><tr><th ng-repeat="innerColumn in column.table">{{innerColumn.label}}</th></tr></thead><tbody><tr ng-repeat="innerRow in vm.row[column.field]"><td ng-repeat="innerColumn in column.table">{{ innerRow[innerColumn.field] }}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/components/metadatum/metadatum.html','<li ng-if="value || rows"><span ng-switch="type"><span ng-switch-when="table"><strong>{{label}}</strong><table class="table table-striped table-bordered table-condensed table-hover"><thead><tr><th ng-repeat="column in columns | inTable">{{column.label}}</th><!--aggiungo una colonna per i dettagli--><div ng-show="details"><th>Dettagli</th></div></tr></thead><tbody><tr ng-repeat="row in righe"><td ng-repeat="column in columns | inTable">{{ row[column.field] }}</td><!--aggiungo il bottone per i dettagli--><div ng-show="details"><td><button class="btn btn-info btn-xs" ng-click="detailsModal(row)" title="dettagli tabella"><i class="glyphicon glyphicon-info-sign"></i></button></td></div></tr></tbody></table></span><span ng-switch-when="wysiwyg"><strong>{{label}}:</strong><div ng-bind-html="value"></div></span><span ng-switch-default><strong>{{label}}:</strong> {{value}}</span></span></li>');
$templateCache.put('app/components/process-list/process-list.html','<div ng-show="processes" class="margin-bottom-helper tasks"><div class="row vertical-align-center well" ng-repeat="process in processes"><div class="col-md-10 col-sm-10"><a ng-href="#/details?processInstanceId={{process.id}}" title="dettagli del flusso {{process.id}}"><small class="label" ng-class="{\'label-info\' : process.endTime, \'label-primary\' : !process.endTime}">{{process.businessKey}}</small><br></a><div><ul class="list-unstyled"><li><h4>Titolo: {{process.name | get: \'titolo\'}}</h4></li><li><h4>Descrizione: {{process.name | get: \'descrizione\'}}</h4></li><li><h4>Stato: {{process.name | get: \'stato\'}}</h4></li><li>Avviato il <strong>{{process.startTime | dataora}}</strong> da <strong>{{process.name | get: \'initiator\'}}</strong></li><ng-include src="\'api/views/\' + process.processDefinitionId.split(\':\')[0] + \'/\' + process.processDefinitionId.split(\':\')[1] + \'/search\'"></ul></div></div><div class="col-md-2 col-sm-2 text-right vertical-align-center"><div class="btn-group" role="group" aria-label="Left Align"><a class="btn btn-default btn-sm" ng-href="#/details?processInstanceId={{process.id}}"><span class="glyphicon glyphicon-hand-right" aria-hidden="true"></span> dettagli</a></div></div></div></div><div class="loading-spiner-holder" style="text-align: center" data-loading><div class="loading-spiner spinner-loader"></div></div><div ng-show="paging" style="text-align: center"><paginator paging="paging"></paginator></div><span ng-show="processes.length == 0">nessun Flusso</span>');
$templateCache.put('app/components/processlist/processlist.html','<div ng-show="processes" class="margin-bottom-helper tasks"><div class="row vertical-align-center well" ng-repeat="process in processes"><div class="col-md-10 col-sm-10"><a ng-href="#/details?processInstanceId={{process.id}}" title="dettagli del flusso {{process.id}}"><small class="label" ng-class="{\'label-info\' : process.endTime, \'label-primary\' : !process.endTime}">{{process.businessKey}}</small><br></a><div><ul class="list-unstyled"><li><h4>Titolo: {{process.name | get: \'titolo\'}}</h4></li><li><h4>Descrizione: {{process.name | get: \'descrizione\'}}</h4></li><li><h4>Stato: {{process.name | get: \'stato\'}}</h4></li><li>Avviato il <strong>{{process.startTime | dataora}}</strong> da <strong>{{process.name | get: \'initiator\'}}</strong></li><ng-include src="\'api/views/\' + process.processDefinitionId.split(\':\')[0] + \'/\' + process.processDefinitionId.split(\':\')[1] + \'/search\'"></ul></div></div><div class="col-md-2 col-sm-2 text-right vertical-align-center"><div class="btn-group" role="group" aria-label="Left Align"><a class="btn btn-default btn-sm" ng-href="#/details?processInstanceId={{process.id}}"><span class="glyphicon glyphicon-hand-right" aria-hidden="true"></span> dettagli</a></div></div></div></div><div class="loading-spiner-holder" style="text-align: center" data-loading><div class="loading-spiner spinner-loader"></div></div><div ng-show="paging" style="text-align: center"><paginator paging="paging"></paginator></div><span ng-show="processes.length == 0">nessun Flusso</span>');
$templateCache.put('app/components/subform/subform.html','<fieldset><legend>{{label}}<span class="glyphicon glyphicon-question-sign" ng-show="item.placeholder" data-toggle="tooltip" data-placement="top" title="{{item.placeholder}}"></span> <span class="pull-right" ng-if="multiple === \'true\'"><button type="button" class="btn btn-success btn-xs" ng-click="addRow()" ng-disabled="ngModel.length >= max"><span class="glyphicon glyphicon-plus"></span></button> <button type="button" class="btn btn-danger btn-xs" ng-click="removeRow()" ng-disabled="ngModel.length <= min"><span class="glyphicon glyphicon-minus"></span></button></span></legend><div class="well" ng-repeat="row in ngModel track by $index"><ng-include src="formUrl"></div></fieldset><hr>');
$templateCache.put('app/components/switchuser/switchuser.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="login.title">Impersona utente</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Impersona utente</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.impersonationError" translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.switchUser($event)"><div class="form-group"><label for="username" translate="global.form.username">Login</label><input type="text" class="form-control" id="username" ng-model="vm.username"></div><button type="submit" class="btn btn-primary">Impersona</button></form></div></div></div>');
$templateCache.put('app/components/task-details/detailModal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><b>{{vm.baseName}}</b></h4></div><div class="modal-body pad"><div ng-show="vm.variables"><div ng-repeat="variable in vm.variables"><b>{{variable.name}}:</b> {{variable.value}}</div></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/components/task-details/task-details.html','<button class="btn btn-info btn-xs" ng-click="modalTaskMetadata(variables, title)" title="dettagli"><i class="glyphicon glyphicon-info-sign"></i></button>');
$templateCache.put('app/components/task-list/task-list.html','<div class="row vertical-align-center well" ng-class="{\'row-slim\': !advanced}" ng-repeat="task in tasks"><div class="col-xs-8"><ul class="list-unstyled"><li><small class="label" ng-class="{\'label-info\' : process.endTime, \'label-primary\' : !process.endTime}">{{task.variabili.key}}</small></li><li><strong>{{task.variabili.titolo}}</strong><br></li><li><strong>Flusso avviato da</strong> <em>{{task.variabili.initiator}}</em> <strong>il</strong> <em>{{task.variabili.startDate | data}}</em></li><li><span ng-bind-html="task.priority | priority"></span></li><li><div ng-show="task.variabili.titolo"><strong>Descrizione:</strong> {{task.variabili.descrizione}}<br></div></li><li><div ng-show="task.name"><strong>Stato:</strong> {{task.name}}<br></div></li><li><div ng-show="task.variabili.sceltaUtente"><strong>Scelta utente:</strong> {{task.variabili.sceltaUtente}}<br></div></li><li><div ng-show="task.assignee"><strong>In carico a:</strong> {{task.assignee}}<br></div></li><li><div ng-show="advanced"><ng-include src="task.searchView"></div></li></ul></div><div class="col-xs-4 pull-right"><div class="btn-group-vertical btn-block" role="group"><a class="btn btn-primary" ng-class="{\'btn-xs\': !advanced}" ui-sref="details({processInstanceId: task.processInstanceId, taskId: task.id})"><span class="glyphicon glyphicon-th-list"></span> Dettagli Flusso </a><a class="btn btn-default" ng-class="{\'btn-xs\': !advanced}" ng-if="!inFirma && task.assignee === null" ng-click="claimTask(task.id, true)"><span class="glyphicon glyphicon-hand-up" aria-hidden="true"></span> Prendi in carico </a><a class="btn btn-default" ng-class="{\'btn-xs\': !advanced}" ng-if="!inFirma && task.assignee !== null && task.variabili.isReleasable" ng-click="claimTask(task.id, false)"><span class="glyphicon glyphicon-hand-down" aria-hidden="true"></span> Restituisci al ruolo </a><!-- TODO: Rimuovere il check tipo missione dopo febbraio 2025 --> <a class="btn btn-default" ng-class="{\'btn-xs\': !advanced}" ng-if="task.category == \'firma\' && !inCart(task.id) && task.variabili.tipologiaMissione !== \'rimborso\'" ng-click="addToCart(task)"><span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> Aggiungi al Carrello Firma </a><a class="btn btn-default" ng-class="{\'btn-xs\': !advanced}" ng-if="inCart(task.id)" ng-click="removeFromCart(task)"><span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> Rimuovi dal Carrello</a></div></div></div><div class="loading-spiner-holder" style="text-align: center" data-loading><div class="loading-spiner spinner-loader"></div></div><span ng-show="tasks.length == 0">Nessun Compito</span>');
$templateCache.put('app/components/variables/variables.html','<div ng-repeat="variable in variables"><div><div ng-switch on="variable.name"><div ng-switch-when="title"><strong>Titolo:</strong> {{variable.value}}</div><div ng-switch-when="startDate"><strong>Avviato il </strong>{{variable.value | data}}</div><div ng-switch-when="initiator"><strong>Aviato da </strong>{{variable.value}}</div><div ng-switch-when="taskId"><strong>Id del compito: </strong>{{variable.value}}</div><div ng-switch-default><strong>{{variable.name}}:</strong> {{variable.value}}</div></div></div></div>');
$templateCache.put('app/entities/avviso/avviso-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.avviso.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="sprintApp.avviso.delete.question" translate-values="{id: \'{{vm.avviso.id}}\'}">Are you sure you want to delete this Avviso?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/avviso/avviso-detail.html','<div><h2><span translate="sprintApp.avviso.detail.title">Avviso</span> {{vm.avviso.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="sprintApp.avviso.contenuto">Contenuto</span></dt><dd><span>{{vm.avviso.contenuto}}</span></dd><dt><span translate="sprintApp.avviso.attivo">Attivo</span></dt><dd><span>{{vm.avviso.attivo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="avviso-detail.edit({id:vm.avviso.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/avviso/avviso-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAvvisoLabel" translate="sprintApp.avviso.home.createOrEditLabel">Create or edit a Avviso</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.avviso.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.avviso.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="sprintApp.avviso.contenuto" for="field_contenuto">Contenuto</label><input type="text" class="form-control" name="contenuto" id="field_contenuto" ng-model="vm.avviso.contenuto" required><div ng-show="editForm.contenuto.$invalid"><p class="help-block" ng-show="editForm.contenuto.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.avviso.attivo" for="field_attivo">Attivo</label><input type="checkbox" class="form-control" name="attivo" id="field_attivo" ng-model="vm.avviso.attivo"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/avviso/avvisos.html','<div><h2 translate="sprintApp.avviso.home.title">Avvisos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="avviso.new"><span class="glyphicon glyphicon-plus"></span> <span translate="sprintApp.avviso.home.createLabel">Create new Avviso</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contenuto"><span translate="sprintApp.avviso.contenuto">Contenuto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="attivo"><span translate="sprintApp.avviso.attivo">Attivo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="avviso in vm.avvisos track by avviso.id"><td><a ui-sref="avviso-detail({id:avviso.id})">{{avviso.id}}</a></td><td>{{avviso.contenuto}}</td><td>{{avviso.attivo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="avviso-detail({id:avviso.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="avviso.edit({id:avviso.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="avviso.delete({id:avviso.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/blacklist/blacklist-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.blacklist.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="flowsApp.blacklist.delete.question" translate-values="{id: \'{{vm.blacklist.id}}\'}">Are you sure you want to delete this Blacklist?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/blacklist/blacklist-detail.html','<div><h2><span translate="flowsApp.blacklist.detail.title">Blacklist</span> {{vm.blacklist.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="flowsApp.blacklist.email">Email</span></dt><dd><span>{{vm.blacklist.email}}</span></dd><dt><span translate="flowsApp.blacklist.processDefinitionKey">Process Definition Key</span></dt><dd><span>{{vm.blacklist.processDefinitionKey}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="blacklist-detail.edit({id:vm.blacklist.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/blacklist/blacklist-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlacklistLabel" translate="flowsApp.blacklist.home.createOrEditLabel">Create or edit a Blacklist</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.blacklist.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.blacklist.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="flowsApp.blacklist.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.blacklist.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="flowsApp.blacklist.processDefinitionKey" for="field_processDefinitionKey">Process Definition Key</label><input type="text" class="form-control" name="processDefinitionKey" id="field_processDefinitionKey" ng-model="vm.blacklist.processDefinitionKey" required><div ng-show="editForm.processDefinitionKey.$invalid"><p class="help-block" ng-show="editForm.processDefinitionKey.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/blacklist/blacklists.html','<div><h2 translate="flowsApp.blacklist.home.title">Blacklists</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="blacklist.new"><span class="glyphicon glyphicon-plus"></span> <span translate="flowsApp.blacklist.home.createLabel">Create new Blacklist</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span translate="flowsApp.blacklist.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="processDefinitionKey"><span translate="flowsApp.blacklist.processDefinitionKey">Process Definition Key</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="blacklist in vm.blacklists track by blacklist.id"><td><a ui-sref="blacklist-detail({id:blacklist.id})">{{blacklist.id}}</a></td><td>{{blacklist.email}}</td><td>{{blacklist.processDefinitionKey}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="blacklist-detail({id:blacklist.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="blacklist.edit({id:blacklist.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="blacklist.delete({id:blacklist.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/cnrgroup/cnrgroup-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cnrgroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="sprintApp.cnrgroup.delete.question" translate-values="{id: \'{{vm.cnrgroup.id}}\'}">Are you sure you want to delete this Cnrgroup?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/cnrgroup/cnrgroup-detail.html','<div><h2><span translate="sprintApp.cnrgroup.detail.title">Cnrgroup</span> {{vm.cnrgroup.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="sprintApp.cnrgroup.name">Name</span></dt><dd><span>{{vm.cnrgroup.name}}</span></dd><dt><span translate="sprintApp.cnrgroup.displayName">Display Name</span></dt><dd><span>{{vm.cnrgroup.displayName}}</span></dd><dt><span translate="sprintApp.cnrgroup.parents">Parents</span></dt><dd><span ng-repeat="parents in vm.cnrgroup.parents"><a ui-sref="cnrgroup-detail({id: parents.id})">{{parents.name}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="cnrgroup-detail.edit({id:vm.cnrgroup.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/cnrgroup/cnrgroup-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCnrgroupLabel" translate="sprintApp.cnrgroup.home.createOrEditLabel">Create or edit a Cnrgroup</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cnrgroup.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cnrgroup.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="sprintApp.cnrgroup.name" for="field_name">Name---</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.cnrgroup.name" required ng-pattern="/^[a-zA-Z0-9#]*[a-zA-Z0-9@-]*[a-zA-Z0-9]*$/" ng-trim="false"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.pattern" translate="entity.validation.pattern" translate-value-pattern="/^[a-zA-Z0-9#]*[a-zA-Z0-9@-_]*[a-zA-Z0-9]*$/" ng-trim="false">This field should follow pattern "/^[a-zA-Z0-9#]*[a-zA-Z0-9@-_]*[a-zA-Z0-9]*$/".</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.cnrgroup.displayName" for="field_displayName">Display Name</label><input type="text" class="form-control" name="displayName" id="field_displayName" ng-model="vm.cnrgroup.displayName" required><div ng-show="editForm.displayName.$invalid"><p class="help-block" ng-show="editForm.displayName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" id="parents"><label translate="sprintApp.cnrgroup.parents" for="field_parents">Parents</label><br><!--<input type="text" class="form-control" name="displayName" id="field_parent"--><!--ng-model="vm.newParent"--><!--required />--><!--buono--><label ng-repeat="group in vm.cnrgroups"><input type="checkbox" class="parentsChecbox" data-value="{{group}}" ng-checked="vm.checked(group)"> {{group.displayName}}-- {{group.id}}</label></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cnrgroup/cnrgroups.html','<div><h2 translate="sprintApp.cnrgroup.home.title">Cnrgroups</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="cnrgroup.new"><span class="glyphicon glyphicon-plus"></span> <span translate="sprintApp.cnrgroup.home.createLabel">Create new Cnrgroup</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span translate="sprintApp.cnrgroup.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="displayName"><span translate="sprintApp.cnrgroup.displayName">Display Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="cnrgroup in vm.cnrgroups track by cnrgroup.id"><td><a ui-sref="cnrgroup-detail({id:cnrgroup.id})">{{cnrgroup.id}}</a></td><td>{{cnrgroup.name}}</td><td>{{cnrgroup.displayName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cnrgroup-detail({id:cnrgroup.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="cnrgroup.edit({id:cnrgroup.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="cnrgroup.delete({id:cnrgroup.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/dynamiclist/dynamiclist-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dynamiclist.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="sprintApp.dynamiclist.delete.question" translate-values="{id: \'{{vm.dynamiclist.id}}\'}">Are you sure you want to delete this Dynamiclist?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dynamiclist/dynamiclist-detail.html','<div><h2><span translate="sprintApp.dynamiclist.detail.title">Dynamiclist</span> {{vm.dynamiclist.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="sprintApp.dynamiclist.name">Name</span></dt><dd><span>{{vm.dynamiclist.name}}</span></dd><dt><span translate="sprintApp.dynamiclist.listjson">Listjson</span></dt><dd><span>{{vm.dynamiclist.listjson}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dynamiclist-detail.edit({id:vm.dynamiclist.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dynamiclist/dynamiclist-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDynamiclistLabel" translate="sprintApp.dynamiclist.home.createOrEditLabel">Create or edit a Dynamiclist</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.dynamiclist.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dynamiclist.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="sprintApp.dynamiclist.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.dynamiclist.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.dynamiclist.listjson" for="field_listjson">Listjson</label><input type="text" class="form-control" name="listjson" id="field_listjson" ng-model="vm.dynamiclist.listjson" required><div ng-show="editForm.listjson.$invalid"><p class="help-block" ng-show="editForm.listjson.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dynamiclist/dynamiclists.html','<div><h2 translate="sprintApp.dynamiclist.home.title">Dynamiclists</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dynamiclist.new"><span class="glyphicon glyphicon-plus"></span> <span translate="sprintApp.dynamiclist.home.createLabel">Create new Dynamiclist</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span translate="sprintApp.dynamiclist.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="listjson"><span translate="sprintApp.dynamiclist.listjson">Listjson</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="dynamiclist in vm.dynamiclists track by dynamiclist.id"><td><a ui-sref="dynamiclist-detail({id:dynamiclist.id})">{{dynamiclist.id}}</a></td><td>{{dynamiclist.name}}</td><td>{{dynamiclist.listjson}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dynamiclist-detail({id:dynamiclist.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="dynamiclist.edit({id:dynamiclist.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dynamiclist.delete({id:dynamiclist.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/external-message/external-message-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.externalMessage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="sprintApp.externalMessage.delete.question" translate-values="{id: \'{{vm.externalMessage.id}}\'}">Are you sure you want to delete this External Message?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/external-message/external-message-detail.html','<div><h2><span translate="sprintApp.externalMessage.detail.title">External Message</span> {{vm.externalMessage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="sprintApp.externalMessage.url">Url</span></dt><dd><span>{{vm.externalMessage.url}}</span></dd><dt><span translate="sprintApp.externalMessage.verb">Verb</span></dt><dd><span translate="{{\'sprintApp.ExternalMessageVerb.\' + vm.externalMessage.verb}}">{{vm.externalMessage.verb}}</span></dd><dt><span translate="sprintApp.externalMessage.payload">Payload</span></dt><dd><span>{{vm.externalMessage.payload}}</span></dd><dt><span translate="sprintApp.externalMessage.status">Status</span></dt><dd><span translate="{{\'sprintApp.ExternalMessageStatus.\' + vm.externalMessage.status}}">{{vm.externalMessage.status}}</span></dd><dt><span translate="sprintApp.externalMessage.retries">Retries</span></dt><dd><span>{{vm.externalMessage.retries}}</span></dd><dt><span translate="sprintApp.externalMessage.lastErrorMessage">Last Error Message</span></dt><dd><span>{{vm.externalMessage.lastErrorMessage}}</span></dd><dt><span translate="sprintApp.externalMessage.application">Application</span></dt><dd><span translate="{{\'sprintApp.ExternalApplication.\' + vm.externalMessage.application}}">{{vm.externalMessage.application}}</span></dd><dt><span translate="sprintApp.externalMessage.creationDate">Creation Date</span></dt><dd><span>{{vm.externalMessage.creationDate | date:\'medium\'}}</span></dd><dt><span translate="sprintApp.externalMessage.lastSendDate">Last Send Date</span></dt><dd><span>{{vm.externalMessage.lastSendDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="external-message-detail.edit({id:vm.externalMessage.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/external-message/external-message-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myExternalMessageLabel" translate="sprintApp.externalMessage.home.createOrEditLabel">Create or edit a External Message</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.externalMessage.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.externalMessage.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.url" for="field_url">Url</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.externalMessage.url" required><div ng-show="editForm.url.$invalid"><p class="help-block" ng-show="editForm.url.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.verb" for="field_verb">Verb</label><select class="form-control" name="verb" ng-model="vm.externalMessage.verb" id="field_verb" required><option value="POST" translate="sprintApp.ExternalMessageVerb.POST">POST</option><option value="GET" translate="sprintApp.ExternalMessageVerb.GET">GET</option><option value="PUT" translate="sprintApp.ExternalMessageVerb.PUT">PUT</option><option value="PATCH" translate="sprintApp.ExternalMessageVerb.PATCH">PATCH</option><option value="DELETE" translate="sprintApp.ExternalMessageVerb.DELETE">DELETE</option></select><div ng-show="editForm.verb.$invalid"><p class="help-block" ng-show="editForm.verb.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.payload" for="field_payload">Payload</label><input type="text" class="form-control" name="payload" id="field_payload" ng-model="vm.externalMessage.payload" required><div ng-show="editForm.payload.$invalid"><p class="help-block" ng-show="editForm.payload.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.externalMessage.status" id="field_status" required><option value="NEW" translate="sprintApp.ExternalMessageStatus.NEW">NEW</option><option value="SENT" translate="sprintApp.ExternalMessageStatus.SENT">SENT</option><option value="DELETED" translate="sprintApp.ExternalMessageStatus.DELETED">DELETED</option><option value="ERROR" translate="sprintApp.ExternalMessageStatus.ERROR">ERROR</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.retries" for="field_retries">Retries</label><input type="number" class="form-control" name="retries" id="field_retries" ng-model="vm.externalMessage.retries" required><div ng-show="editForm.retries.$invalid"><p class="help-block" ng-show="editForm.retries.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.retries.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.lastErrorMessage" for="field_lastErrorMessage">Last Error Message</label><input type="text" class="form-control" name="lastErrorMessage" id="field_lastErrorMessage" ng-model="vm.externalMessage.lastErrorMessage"></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.application" for="field_application">Application</label><select class="form-control" name="application" ng-model="vm.externalMessage.application" id="field_application" required><option value="ABIL" translate="sprintApp.ExternalApplication.ABIL">ABIL</option><option value="SIGLA" translate="sprintApp.ExternalApplication.SIGLA">SIGLA</option><option value="ACE" translate="sprintApp.ExternalApplication.ACE">ACE</option><option value="MISSIONI" translate="sprintApp.ExternalApplication.MISSIONI">MISSIONI</option><option value="ATTESTATI" translate="sprintApp.ExternalApplication.ATTESTATI">ATTESTATI</option><option value="GENERIC" translate="sprintApp.ExternalApplication.GENERIC">GENERIC</option><option value="STM" translate="sprintApp.ExternalApplication.STM">STM</option><option value="LABCON" translate="sprintApp.ExternalApplication.LABCON">LABCON</option><option value="SIPER" translate="sprintApp.ExternalApplication.SIPER">SIPER</option></select><div ng-show="editForm.application.$invalid"><p class="help-block" ng-show="editForm.application.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.creationDate" for="field_creationDate">Creation Date</label><div class="input-group"><input id="field_creationDate" type="text" class="form-control" name="creationDate" datetime-picker="{{dateformat}}" ng-model="vm.externalMessage.creationDate" is-open="vm.datePickerOpenStatus.creationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.lastSendDate" for="field_lastSendDate">Last Send Date</label><div class="input-group"><input id="field_lastSendDate" type="text" class="form-control" name="lastSendDate" datetime-picker="{{dateformat}}" ng-model="vm.externalMessage.lastSendDate" is-open="vm.datePickerOpenStatus.lastSendDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastSendDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/external-message/external-messages.html','<div><h2 translate="sprintApp.externalMessage.home.title">External Messages</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="external-message.new"><span class="glyphicon glyphicon-plus"></span> <span translate="sprintApp.externalMessage.home.createLabel">Create new External Message</span></button></div></div></div><br><div class="table-responsive"><div class="bg-info"><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.payload" for="field_payload">Payload</label><input type="text" class="form-control" name="payload" id="field_payload" ng-model="vm.externalMessage.payload"></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.externalMessage.status" id="field_status"><option value="NEW" translate="sprintApp.ExternalMessageStatus.NEW">NEW</option><option value="SENT" translate="sprintApp.ExternalMessageStatus.SENT">SENT</option><option value="DELETED" translate="sprintApp.ExternalMessageStatus.DELETED">DELETED</option><option value="ERROR" translate="sprintApp.ExternalMessageStatus.ERROR">ERROR</option></select></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.lastErrorMessage" for="field_lastErrorMessage">Last Error Message</label><input type="text" class="form-control" name="lastErrorMessage" id="field_lastErrorMessage" ng-model="vm.externalMessage.lastErrorMessage"></div><div class="form-group"><label class="control-label" translate="sprintApp.externalMessage.application" for="field_application">Application</label><select class="form-control" name="application" ng-model="vm.externalMessage.application" id="field_application"><option value="ABIL" translate="sprintApp.ExternalApplication.ABIL">ABIL</option><option value="SIPER" translate="sprintApp.ExternalApplication.SIPER">SIPER</option><option value="SIGLA" translate="sprintApp.ExternalApplication.SIGLA">SIGLA</option><option value="ACE" translate="sprintApp.ExternalApplication.ACE">ACE</option><option value="MISSIONI" translate="sprintApp.ExternalApplication.MISSIONI">MISSIONI</option><option value="ATTESTATI" translate="sprintApp.ExternalApplication.ATTESTATI">ATTESTATI</option><option value="STM" translate="sprintApp.ExternalApplication.STM">SHORT-TERM-MOBILITY</option><option value="LABCON" translate="sprintApp.ExternalApplication.LABCON">LABCON</option><option value="GENERIC" translate="sprintApp.ExternalApplication.GENERIC">GENERIC</option></select></div><button ng-click="loadAll()" class="btn btn-primary"><span class="glyphicon glyphicon-filter"></span> Filtra</button></div><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th id="id" jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th id="url" jh-sort-by="url"><span translate="sprintApp.externalMessage.url">Url</span> <span class="glyphicon glyphicon-sort"></span></th><th id="verb" jh-sort-by="verb"><span translate="sprintApp.externalMessage.verb">Verb</span> <span class="glyphicon glyphicon-sort"></span></th><th id="payload" jh-sort-by="payload"><span translate="sprintApp.externalMessage.payload">Payload</span> <span class="glyphicon glyphicon-sort"></span></th><th id="status" jh-sort-by="status"><span translate="sprintApp.externalMessage.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th id="retries" jh-sort-by="retries"><span translate="sprintApp.externalMessage.retries">Retries</span> <span class="glyphicon glyphicon-sort"></span></th><th id="lastErrorMessage" jh-sort-by="lastErrorMessage"><span translate="sprintApp.externalMessage.lastErrorMessage">Last Error Message</span> <span class="glyphicon glyphicon-sort"></span></th><th id="application" jh-sort-by="application"><span translate="sprintApp.externalMessage.application">Application</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationDate"><span translate="sprintApp.externalMessage.creationDate">Creation Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastSendDate"><span translate="sprintApp.externalMessage.lastSendDate">Last Send Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="externalMessage in vm.externalMessages track by externalMessage.id"><td><a ui-sref="external-message-detail({id:externalMessage.id})">{{externalMessage.id}}</a></td><td>{{externalMessage.url}}</td><td translate="{{\'sprintApp.ExternalMessageVerb.\' + externalMessage.verb}}">{{externalMessage.verb}}</td><td class="ellipsis">{{externalMessage.payload}}</td><td translate="{{\'sprintApp.ExternalMessageStatus.\' + externalMessage.status}}">{{externalMessage.status}}</td><td>{{externalMessage.retries}}</td><td class="ellipsis">{{externalMessage.lastErrorMessage}}</td><td translate="{{\'sprintApp.ExternalApplication.\' + externalMessage.application}}">{{externalMessage.application}}</td><td>{{externalMessage.creationDate | date:\'medium\'}}</td><td>{{externalMessage.lastSendDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="external-message-detail({id:externalMessage.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="external-message.edit({id:externalMessage.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="external-message.delete({id:externalMessage.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/faq/faq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.faq.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="sprintApp.faq.delete.question" translate-values="{id: \'{{vm.faq.id}}\'}">Are you sure you want to delete this Faq?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/faq/faq-detail.html','<div><h2><span translate="sprintApp.faq.detail.title">Faq</span> {{vm.faq.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="sprintApp.faq.domanda">Domanda</span></dt><dd><span>{{vm.faq.domanda}}</span></dd><dt><span translate="sprintApp.faq.risposta">Risposta</span></dt><dd><span>{{vm.faq.risposta}}</span></dd><dt><span translate="sprintApp.faq.isReadable">Is Readable</span></dt><dd><span>{{vm.faq.isReadable}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="faq-detail.edit({id:vm.faq.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/faq/faq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFaqLabel" translate="sprintApp.faq.home.createOrEditLabel">Create or edit a Faq</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.faq.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.faq.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="sprintApp.faq.domanda" for="field_domanda">Domanda</label><input type="text" class="form-control" name="domanda" id="field_domanda" ng-model="vm.faq.domanda" required><div ng-show="editForm.domanda.$invalid"><p class="help-block" ng-show="editForm.domanda.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.faq.risposta" for="field_risposta">Risposta</label><input type="text" class="form-control" name="risposta" id="field_risposta" ng-model="vm.faq.risposta" required><div ng-show="editForm.risposta.$invalid"><p class="help-block" ng-show="editForm.risposta.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.faq.isReadable" for="field_isReadable">Is Readable</label><input type="checkbox" class="form-control" name="isReadable" id="field_isReadable" ng-model="vm.faq.isReadable"><div ng-show="editForm.isReadable.$invalid"><p class="help-block" ng-show="editForm.isReadable.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/faq/faqs.html','<div><h2 translate="sprintApp.faq.home.title">Faqs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="faq.new"><span class="glyphicon glyphicon-plus"></span> <span translate="sprintApp.faq.home.createLabel">Create new Faq</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span translate="sprintApp.faq.domanda">Domanda</span></th><th><span translate="sprintApp.faq.risposta">Risposta</span></th><th><span translate="sprintApp.faq.isReadable">Is Readable</span></th><th></th></tr></thead><tbody><tr ng-repeat="faq in vm.faqs track by faq.id"><td><a ui-sref="faq-detail({id:faq.id})">{{faq.id}}</a></td><td>{{faq.domanda}}</td><td>{{faq.risposta}}</td><td>{{faq.isReadable}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="faq-detail({id:faq.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="faq.edit({id:faq.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="faq.delete({id:faq.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/membership/membership-delete-dialog.html','<form name="deleteForm" ng-submit="confirmDelete(membership.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><p translate="sprintApp.membership.delete.question" translate-values="{id: \'{{membership.id}}\'}">Are you sure you want to delete this Membership?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/membership/membership-detail.html','<div><h2><span translate="sprintApp.membership.detail.title">Membership</span> {{membership.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="sprintApp.membership.grouprole">Grouprole</span></td><td><span class="form-control-static">{{membership.grouprole}}</span></td></tr><tr><td><span translate="sprintApp.membership.cnrgroup">cnrgroup</span></td><td>{{membership.cnrgroup.displayName}}</td></tr><tr><td><span translate="sprintApp.membership.user">user</span></td><td>{{membership.user.login}}</td></tr></tbody></table></div><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/membership/membership-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myMembershipLabel" translate="sprintApp.membership.home.createOrEditLabel">Create or edit a Membership</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><div class="form-group"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="membership.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="sprintApp.membership.grouprole" for="field_grouprole">Grouprole</label><select class="form-control" id="field_grouprole" name="grouprole" ng-model="membership.grouprole"><option value="coordinator">Coordinator</option><option value="member">Member</option></select><div ng-show="editForm.grouprole.$invalid"><p class="help-block" ng-show="editForm.grouprole.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div id="field_cnrgroup" class="form-group"><label translate="sprintApp.membership.cnrgroup" for="field_cnrgroup">cnrgroup</label><typeaheadinput id="field_cnrgroup" type="flowsGroups" id="group" ng-model="membership.cnrgroup" ng-required="true"></typeaheadinput></div><div id="username" class="form-group"><label class="control-label" translate="sprintApp.membership.user" for="username">Username</label><typeaheadinput id="field_username" type="flowsUsers" id="rup" ng-model="membership.username" label-model="$parent.vm.data.rup_label" ng-required="true"></typeaheadinput></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/membership/memberships.html','<div><h2>IN QUESTA PAGINA APPAIONO SOLO LE MEMBERSHIP DIRETTE (le tuple della tabella)</h2><jh-alert></jh-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="membership.new"><span class="glyphicon glyphicon-plus"></span> <span translate="sprintApp.membership.home.createLabel">Create new Membership</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="predicate" ascending="reverse" callback="loadAll()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="grouprole"><span translate="sprintApp.membership.grouprole">Grouprole</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cnrgroup.displayName"><span translate="sprintApp.membership.cnrgroup">cnrgroup</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.login"><span translate="sprintApp.membership.user">user</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="membership in memberships track by membership.id"><td><a ui-sref="membership.detail({id:membership.id})">{{membership.id}}</a></td><td>{{membership.grouprole}}</td><td>{{membership.cnrgroup.displayName}}</td><td>{{membership.user.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="membership.detail({id:membership.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="membership.delete({id:membership.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><uib-pager total-items="totalItems" ng-model="page" ng-change="loadAll()"></uib-pager></div>');
$templateCache.put('app/entities/notification-rule/notification-rule-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.notificationRule.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="sprintApp.notificationRule.delete.question" translate-values="{id: \'{{vm.notificationRule.id}}\'}">Are you sure you want to delete this Notification Rule?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/notification-rule/notification-rule-detail.html','<div><h2><span translate="sprintApp.notificationRule.detail.title">Notification Rule</span> {{vm.notificationRule.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="sprintApp.notificationRule.processId">Process Id</span></dt><dd><span>{{vm.notificationRule.processId}}</span></dd><dt><span translate="sprintApp.notificationRule.taskName">Task Name</span></dt><dd><span>{{vm.notificationRule.taskName}}</span></dd><dt><span translate="sprintApp.notificationRule.recipients">Recipients</span></dt><dd><span>{{vm.notificationRule.recipients}}</span></dd><dt><span translate="sprintApp.notificationRule.eventType">Event Type</span></dt><dd><span>{{vm.notificationRule.eventType}}</span></dd><dt><span translate="sprintApp.notificationRule.persona">Persona</span></dt><dd><span>{{vm.notificationRule.persona}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="notification-rule-detail.edit({id:vm.notificationRule.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/notification-rule/notification-rule-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNotificationRuleLabel" translate="sprintApp.notificationRule.home.createOrEditLabel">Create or edit a Notification Rule</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.notificationRule.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.notificationRule.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="sprintApp.notificationRule.processId" for="field_processId">Process Id</label><input type="text" class="form-control" name="processId" id="field_processId" ng-model="vm.notificationRule.processId" required><div ng-show="editForm.processId.$invalid"><p class="help-block" ng-show="editForm.processId.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.notificationRule.taskName" for="field_taskName">Task Name</label><input type="text" class="form-control" name="taskName" id="field_taskName" ng-model="vm.notificationRule.taskName" required><div ng-show="editForm.taskName.$invalid"><p class="help-block" ng-show="editForm.taskName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.notificationRule.recipients" for="field_recipients">Recipients</label><input type="text" class="form-control" name="recipients" id="field_recipients" ng-model="vm.notificationRule.recipients" required><div ng-show="editForm.recipients.$invalid"><p class="help-block" ng-show="editForm.recipients.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.notificationRule.eventType" for="field_eventType">Event Type</label><input type="text" class="form-control" name="eventType" id="field_eventType" ng-model="vm.notificationRule.eventType" required><div ng-show="editForm.eventType.$invalid"><p class="help-block" ng-show="editForm.eventType.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.notificationRule.persona" for="field_persona">Persona</label><input type="checkbox" class="form-control" name="persona" id="field_persona" ng-model="vm.notificationRule.persona"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/notification-rule/notification-rules.html','<div><h2 translate="sprintApp.notificationRule.home.title">Notification Rules</h2><jhi-alert></jhi-alert><div class="alert alert-info text-center"><p>Gli eventi attualmente gestiti sono: TASK_CREATED, TASK_ASSIGNED, TASK_COMPLETED, SEQUENCEFLOW_TAKEN, PROCESS_STARTED, PROCESS_COMPLETED, PROCESS_CANCELLED</p><p>Per i tipi TASK_* indicare anche il nome del task (per gli altri mettere \'none\')</p></div><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="notification-rule.new"><span class="glyphicon glyphicon-plus"></span> <span translate="sprintApp.notificationRule.home.createLabel">Create new Notification Rule</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="processId"><span translate="sprintApp.notificationRule.processId">Process Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="taskName"><span translate="sprintApp.notificationRule.taskName">Task Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="recipients"><span translate="sprintApp.notificationRule.recipients">Recipients</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="eventType"><span translate="sprintApp.notificationRule.eventType">Event Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="persona"><span translate="sprintApp.notificationRule.persona">Persona</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="notificationRule in vm.notificationRules track by notificationRule.id"><td><a ui-sref="notification-rule-detail({id:notificationRule.id})">{{notificationRule.id}}</a></td><td>{{notificationRule.processId}}</td><td>{{notificationRule.taskName}}</td><td>{{notificationRule.recipients}}</td><td>{{notificationRule.eventType}}</td><td>{{notificationRule.persona}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="notification-rule-detail({id:notificationRule.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="notification-rule.edit({id:notificationRule.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="notification-rule.delete({id:notificationRule.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/form/form-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.form.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="sprintApp.form.delete.question" translate-values="{id: \'{{vm.form.id}}\'}">Are you sure you want to delete this Form?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/form/form-detail.html','<div><h2><span translate="sprintApp.form.detail.title">Form</span> {{vm.form.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="sprintApp.form.processDefinitionKey">Process Definition Key</span></dt><dd><span>{{vm.form.processDefinitionKey}}</span></dd><dt><span translate="sprintApp.form.version">Version</span></dt><dd><span>{{vm.form.version}}</span></dd><dt><span translate="sprintApp.form.taskId">Task Id</span></dt><dd><span>{{vm.form.taskId}}</span></dd><dt><span translate="sprintApp.form.form">Form</span></dt><dd><span>{{vm.form.form}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="form-detail.edit({id:vm.form.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/form/form-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFormLabel" translate="sprintApp.form.home.createOrEditLabel">Create or edit a Form</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.form.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.form.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="sprintApp.form.processDefinitionKey" for="field_processDefinitionKey">Process Definition Key</label><input type="text" class="form-control" name="processDefinitionKey" id="field_processDefinitionKey" ng-model="vm.form.processDefinitionKey" required><div ng-show="editForm.processDefinitionKey.$invalid"><p class="help-block" ng-show="editForm.processDefinitionKey.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.form.version" for="field_version">Version</label><input type="text" class="form-control" name="version" id="field_version" ng-model="vm.form.version" required><div ng-show="editForm.version.$invalid"><p class="help-block" ng-show="editForm.version.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.form.taskId" for="field_taskId">Task Id</label><input type="text" class="form-control" name="taskId" id="field_taskId" ng-model="vm.form.taskId" required><div ng-show="editForm.taskId.$invalid"><p class="help-block" ng-show="editForm.taskId.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.form.form" for="field_form">Form</label><button type="button" class="btn btn-xs btn-success" ng-click="vm.runTidy()"><span class="glyphicon glyphicon-indent-left"></span></button> <button type="button" class="btn btn-xs btn-success" ng-click="vm.reloadHtml()"><span class="glyphicon glyphicon-refresh"></span></button><!--             <textarea rows="10" class="form-control" name="form" id="field_form" --><!--                     ng-model="vm.form.form" --><!--                     required /> --><div ui-ace="vm.aceOpts" ng-model="vm.form.form" style="height: 350px"></div><div ng-show="editForm.form.$invalid"><p class="help-block" ng-show="editForm.form.$error.required" translate="entity.validation.required">This field is required.</p></div></div><hr><div class="row"><div class="col-md-6 col-md-offset-3"><div compile="vm.preview"></div><pre>{{data | json}}</pre></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/form/forms.html','<div><h2 translate="sprintApp.form.home.title">Forms</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="form.new"><span class="glyphicon glyphicon-plus"></span> <span translate="sprintApp.form.home.createLabel">Create new Form</span></button></div></div></div><br><div class="table-responsive"><div class="bg-info"><label>(paginazione DISABILITATA)</label><br><label>Search Any: <input ng-model="search.$"></label><br><label>Search TaskId: <input ng-model="search.taskId"></label><br><label>Search processDefinitionKey: <input ng-model="search.processDefinitionKey"></label></div><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="processDefinitionKey"><span translate="sprintApp.form.processDefinitionKey">Process Definition Key</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="version"><span translate="sprintApp.form.version">Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="taskId"><span translate="sprintApp.form.taskId">Task Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="form"><span translate="sprintApp.form.form">Form</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="form in vm.forms | filter:search:strict | orderBy:id"><td><a ui-sref="form-detail({id:form.id})">{{form.id}}</a></td><td>{{form.processDefinitionKey}}</td><td>{{form.version}}</td><td>{{form.taskId}}</td><td>{{form.form}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="form-detail({id:form.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="form.edit({id:form.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="form.delete({id:form.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><!--    <div class="text-center">--><!--        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>--><!--        <uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>--><!--    </div>--></div>');
$templateCache.put('app/entities/relationship/relationship-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.relationship.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="sprintApp.relationship.delete.question" translate-values="{id: \'{{vm.relationship.id}}\'}">Are you sure you want to delete this Relationship?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/relationship/relationship-detail.html','<div><h2><span translate="sprintApp.relationship.detail.title">Relationship</span> {{vm.relationship.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="sprintApp.relationship.groupName">Group Name</span></dt><dd><span>{{vm.relationship.groupName}}</span></dd><dt><span translate="sprintApp.relationship.groupRelationship">Group Relationship</span></dt><dd><span>{{vm.relationship.groupRelationship}}</span></dd><dt><span translate="sprintApp.relationship.groupRole">Group Role</span></dt><dd><span>{{vm.relationship.groupRole}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="relationship-detail.edit({id:vm.relationship.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/relationship/relationship-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRelationshipLabel" translate="sprintApp.relationship.home.createOrEditLabel">Create or edit a Relationship</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.relationship.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.relationship.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="sprintApp.relationship.groupName" for="field_groupName">Group Name</label><input type="text" class="form-control" name="groupName" id="field_groupName" ng-model="vm.relationship.groupName" required><div ng-show="editForm.groupName.$invalid"><p class="help-block" ng-show="editForm.groupName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.relationship.groupRelationship" for="field_groupRelationship">Group Relationship</label><input type="text" class="form-control" name="groupRelationship" id="field_groupRelationship" ng-model="vm.relationship.groupRelationship" required><div ng-show="editForm.groupRelationship.$invalid"><p class="help-block" ng-show="editForm.groupRelationship.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.relationship.groupRole" for="field_groupRole">Group Role</label><input type="text" class="form-control" name="groupRole" id="field_groupRole" ng-model="vm.relationship.groupRole"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/relationship/relationships.html','<div><h2 translate="sprintApp.relationship.home.title">Relationships</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="relationship.new"><span class="glyphicon glyphicon-plus"></span> <span translate="sprintApp.relationship.home.createLabel">Create new Relationship</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="groupName"><span translate="sprintApp.relationship.groupName">Group Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="groupRelationship"><span translate="sprintApp.relationship.groupRelationship">Group Relationship</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="groupRole"><span translate="sprintApp.relationship.groupRole">Group Role</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="relationship in vm.relationships track by relationship.id"><td><a ui-sref="relationship-detail({id:relationship.id})">{{relationship.id}}</a></td><td>{{relationship.groupName}}</td><td>{{relationship.groupRelationship}}</td><td>{{relationship.groupRole}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="relationship-detail({id:relationship.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="relationship.edit({id:relationship.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="relationship.delete({id:relationship.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/view/view-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.view.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="sprintApp.view.delete.question" translate-values="{id: \'{{vm.view.id}}\'}">Are you sure you want to delete this View?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/view/view-detail.html','<div><h2><span translate="sprintApp.view.detail.title">View</span> {{vm.view.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="sprintApp.view.processId">Process Id</span></dt><dd><span>{{vm.view.processId}}</span></dd><dt><span translate="sprintApp.view.type">Type</span></dt><dd><span>{{vm.view.type}}</span></dd><dt><span translate="sprintApp.view.view">View</span></dt><dd><span>{{vm.view.view}}</span></dd><dt><span translate="sprintApp.view.version">Version</span></dt><dd><span>{{vm.view.version}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="view-detail.edit({id:vm.view.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/view/view-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myViewLabel" translate="sprintApp.view.home.createOrEditLabel">Create or edit a View</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.view.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.view.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="sprintApp.view.processId" for="field_processId">Process Id</label><input type="text" class="form-control" name="processId" id="field_processId" ng-model="vm.view.processId" required><div ng-show="editForm.processId.$invalid"><p class="help-block" ng-show="editForm.processId.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.view.type" for="field_type">Type</label><input type="text" class="form-control" name="type" id="field_type" ng-model="vm.view.type" required><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.view.view" for="field_view">View</label><input type="text" class="form-control" name="view" id="field_view" ng-model="vm.view.view" required><div ng-show="editForm.view.$invalid"><p class="help-block" ng-show="editForm.view.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.view.version" for="field_version">Version</label><input type="text" class="form-control" name="version" id="field_version" ng-model="vm.view.version"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/view/views.html','<div><h2 translate="sprintApp.view.home.title">Views</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="view.new"><span class="glyphicon glyphicon-plus"></span> <span translate="sprintApp.view.home.createLabel">Create new View</span></button></div></div></div><br><div class="table-responsive"><div class="bg-info"><label>(paginazione DISABILITATA)</label><br><label>Search Any: <input ng-model="search.$"></label><br><label>Search processId: <input ng-model="search.processId"></label><br><label>Search type: <input ng-model="search.type"></label></div><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="processId"><span translate="sprintApp.view.processId">Process Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span translate="sprintApp.view.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="view"><span translate="sprintApp.view.view">View</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="version"><span translate="sprintApp.view.version">Version</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="view in vm.views | filter:search:strict | orderBy:id"><td><a ui-sref="view-detail({id:view.id})">{{view.id}}</a></td><td>{{view.processId}}</td><td>{{view.type}}</td><td>{{view.view}}</td><td>{{view.version}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="view-detail({id:view.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="view.edit({id:view.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="view.delete({id:view.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/inputs/date/date.html','<p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="ngModel" is-open="isOpen" current-text="Oggi" close-text="Chiudi" clear-text="Svuota" alt-input-formats="altInputFormats" ng-required="ngRequired" ng-readonly="true" ng-click="open()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p>');
$templateCache.put('app/inputs/fileinput/fileinput.html','<div><fieldset><legend ng-if="legend">{{legend}} <span class="glyphicon glyphicon-question-sign" ng-show="item.placeholder" data-toggle="tooltip" data-placement="top" title="{{item.placeholder}}"></span> <span class="pull-right" ng-if="multiple"><button type="button" class="btn btn-success btn-xs" ng-click="addRow()" ng-disabled="ngModel.length >= max"><span class="glyphicon glyphicon-plus"></span></button> <button type="button" class="btn btn-danger btn-xs" ng-click="removeRow()" ng-disabled="ngModel.length <= min"><span class="glyphicon glyphicon-minus"></span></button></span></legend><div class="well" ng-if="rows.length == 0">Usare il bottone <button type="button" class="btn btn-success btn-xs" ng-click="addRow()" ng-disabled="ngModel.length >= max"><span class="glyphicon glyphicon-plus"></span></button> per aggiungere eventuali altri allegati.</div><div ng-if="nota" class="bg-warning cnr-descrizione-task">{{nota}}</div><div class="well" ng-repeat="row in rows track by $index" ng-init="initRow(row, $index);"><div ng-if="$parent.attachments[row.rowname].aggiorna != true"><h3>{{$parent.attachments[row.rowname].label}}</h3><a href ng-click="downloadFile(\'/api/attachments/task/\'+ taskId +\'/\'+ $parent.attachments[row.rowname].name +\'/data\', $parent.attachments[row.rowname].filename, $parent.attachments[row.rowname].mimetype)">{{$parent.attachments[row.rowname].filename}}</a><div class="row form-group"><div class="col-md-12"><button class="btn btn-primary btn-xs" ng-click="$parent.attachments[row.rowname].aggiorna = true"><span class="glyphicon glyphicon-edit"></span> Modifica</button></div></div></div><div ng-if="$parent.attachments[row.rowname].aggiorna"><div class="form-group" ng-if="label === undefined"><label>Tipo Documento</label><input type="text" class="form-control" ng-model="$parent.attachments[row.rowname].label" ng-readonly="modificaLabel" required></div><div class="form-group" ng-if="label !== undefined" ng-init="$parent.attachments[row.rowname].label = $parent.attachments[row.rowname].label || label"><h3>{{label}}</h3><div ng-if="nota" class="bg-warning cnr-descrizione-file">{{nota}}</div></div><div class="row form-group" ng-show="row.modifica && mostraModifica && !soloMetadati"><div class="col-md-12"><button class="btn btn-primary btn-xs" ng-click="$parent.attachments[row.rowname].aggiorna = false"><span class="glyphicon glyphicon-remove-sign"></span> Annulla Modifica</button></div></div><div class="row form-group" ng-if="metadatiPubblicazione || metadatiPubblicazioneUrp"><div class="col-md-5">Pubblicazione in URP</div><div class="col-md-7"><toggle-switch class="switch-success btn-group btn-group-justified" ng-model="$parent.attachments[row.rowname].pubblicazioneUrp" off-label="Non pubblicare" on-label="Pubblica" is-disabled="pubblicazioneDisabilitato || pubblicazioneUrpDisabilitato"></toggle-switch></div></div><div class="row form-group" ng-if="metadatiPubblicazione || metadatiPubblicazioneTrasparenza"><div class="col-md-5">Pubblicazione in Trasparenza</div><div class="col-md-7"><toggle-switch class="switch-success btn-group btn-group-justified" ng-model="$parent.attachments[row.rowname].pubblicazioneTrasparenza" off-label="Non pubblicare" on-label="Pubblica" is-disabled="pubblicazioneDisabilitato || pubblicazioneTrasparenzaDisabilitato"></toggle-switch></div></div><div ng-if="metadatiProtocollo"><div class="row form-group"><div class="col-md-5">Protocollo</div><div class="col-md-7"><toggle-switch class="btn-group btn-group-justified" ng-model="$parent.attachments[row.rowname].protocollo" off-label="Non Protocollato" on-label="Protocollato" ng-click="onClickProtocollo(row);" is-disabled="protocolloDisabilitato || sliderProtocolloDisabilitato"></toggle-switch></div></div><div class="row form-group"><div class="col-xs-5" ng-if="$parent.attachments[row.rowname].protocollo"><label>Data protocollo</label><input type="date" class="form-control" ng-model="$parent.attachments[row.rowname].dataProtocollo" ng-readonly="protocolloDisabilitato" required></div><div class="col-xs-7" ng-if="$parent.attachments[row.rowname].protocollo"><label>Numero protocollo</label><input type="text" class="form-control" ng-model="$parent.attachments[row.rowname].numeroProtocollo" ng-readonly="protocolloDisabilitato" required></div></div></div><a href ng-click="downloadFile(\'/api/attachments/task/\'+ taskId +\'/\'+ $parent.attachments[row.rowname].name +\'/data\', $parent.attachments[row.rowname].filename, $parent.attachments[row.rowname].mimetype)">{{$parent.attachments[row.rowname].filename}}</a><div class="row form-group" ng-if="!soloMetadati"><div class="col-md-12"><button class="btn btn-sm" ng-class="{\'btn-success\': $parent.attachments[row.rowname].data, \'btn-info\': !$parent.attachments[row.rowname].data}" ng-model="$parent.attachments[row.rowname].data" ngf-select name="$parent.attachments[row.rowname].data" accept="{{accept}}" ngf-multiple="false" ng-required="cnrRequired || (multiple && !row.modifica)"><span ng-show="!$parent.attachments[row.rowname].data" class="glyphicon glyphicon-upload"></span> <span ng-show="$parent.attachments[row.rowname].data" class="glyphicon glyphicon-repeat"></span> <span ng-show="!$parent.attachments[row.rowname].data">Seleziona File</span> <span ng-show="$parent.attachments[row.rowname].data">Cambia File</span></button> <span ng-show="$parent.attachments[row.rowname].data">{{$parent.attachments[row.rowname].data.name}} <a href ng-click="$parent.attachments[row.rowname].data = undefined"><span class="glyphicon glyphicon-remove" title="Rimuovi"></span></a></span></div></div></div></div></fieldset></div><hr ng-if="multiple">');
$templateCache.put('app/inputs/textlookup/textlookup.html','<input type="text" class="form-control" id="id" ng-required="ngRequired" ng-value="value" ng-readonly="ngReadonly">');
$templateCache.put('app/inputs/selectlookup/selectlookup.html','<select class="form-control" id="cdsuo" required="true" ng-model="ngModel"><option ng-repeat="record in records" value="{{record.value}}">{{record.label}}</option></select>');
$templateCache.put('app/inputs/typeaheadinput/typeaheadinput.html','<style>.custom-popup-wrapper {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 1000;\n    display: none;\n    background-color: #fff;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n  }\n\n  .custom-popup-wrapper > .message {\n    padding: 10px 20px;\n    border-bottom: 1px solid #ddd;\n    color: darkorange;\n  }\n\n  .custom-popup-wrapper > .dropdown-menu {\n    position: static;\n    float: none;\n    display: block;\n    min-width: 160px;\n    background-color: transparent;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n  }</style><input type="text" ng-model="localModel" ng-required="ngRequired" placeholder="Inizia a digitare per avviare la ricerca" uib-typeahead="record as record.label for record in loadRecords($viewValue)" typeahead-wait-ms="250" typeahead-loading="loadingLocations" typeahead-no-results="noResults" typeahead-editable="false" typeahead-min-length="3" typeahead-popup-template-url="app/inputs/typeaheadinput/typeaheadinput.popup.html" class="form-control">');
$templateCache.put('app/inputs/typeaheadinput/typeaheadinput.popup.html','<div class="custom-popup-wrapper" ng-style="{top: position().top+\'px\', left: position().left+\'px\'}" style="display: block" ng-show="isOpen() && !moveInProgress" aria-hidden="{{!isOpen()}}"><p class="message" ng-if="$parent.hasMore">Troppi risultati! Restringere la ricerca.</p><ul class="dropdown-menu" role="listbox"><li class="uib-typeahead-match" ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index)" role="option" id="{{::match.id}}"><div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div></li></ul></div>');
$templateCache.put('app/inputs/wysiwyg/wysiwyg.html','<trix-editor style="min-height: 300px" class="trix-content" ng-required="ngRequired"></trix-editor>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div class="alert alert-danger" translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default navbar-top" role="navigation"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button><div ng-show="app == \'cnr\'"><a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo_CNR_esteso40.png"> <span style="vertical-align: bottom;font-size: 1.2em;color: #012c54">Scrivania Digitale CNR</span><!-- <span class="navbar-version">v{{VERSION}}</span> --></a></div><div ng-show="app == \'oiv\'"><a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/oiv-flows-banner.png"><!--<span>Scrivania Digitale OIV</span> &lt;!&ndash; <span class="navbar-version">v{{VERSION}}</span> &ndash;&gt;--></a></div></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" translate="global.menu.home">Home</span></a></li><li ui-sref-active="active" has-authority="ROLE_USER"><a ui-sref="availableTasks" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm">I miei compiti</span></a></li><!--nelle Process Definition in wfDefsBootable c\'\xE8 anche "ALL"--><li ui-sref-active="active" ng-switch-when="true" ng-show="wfDefsBootable.length > 1" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="definitions-menu"><span><span class="glyphicon glyphicon-transfer"></span> <span class="hidden-sm">Avvia Flusso </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ng-repeat="wfDef in wfDefsBootable | filter: { name: \'!ALL\' }"><a ui-sref="task({processDefinitionId: wfDef.id, taskName: \'start\', taskId: undefined})" ng-click="vm.collapseNavbar()">{{wfDef.name}}</a></li></ul></li><li ui-sref-active="active" ng-switch-when="true" ng-show="wfDefsStatistics.length >= 1" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="statistic-menu"><span><span class="glyphicon glyphicon-stats"></span> <span class="hidden-sm">Statistiche </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ng-repeat="wfDef in wfDefsStatistics track by $index"><a ui-sref="statistics({processDefinition: wfDef.id})" ng-click="vm.collapseNavbar()">{{wfDef.name}}</a></li></ul></li><!--        NON VISUALIZZIAMO PIU\' I COMPITI COMPLETATI\n            <li ui-sref-active="active" has-authority="ROLE_USER">\n                <a ui-sref="task-completed" ng-click="vm.collapseNavbar()">\n                    <span class=" glyphicon glyphicon-ok"></span>\n                    <span class="hidden-sm">Compiti Completati</span>\n                </a>\n            </li>--><!--NASCONDIAMO LA PAGINA "Flussi avviati da me" E SE LA DOVESSERO RICHIEDERE LA RIMETTIAMO (FUNZIONA)--><!--<li ui-sref-active="active" has-authority="ROLE_USER">--><!--<a ui-sref="myProcessInstances" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-pushpin"></span>--><!--<span class="hidden-sm">Flussi avviati da me</span>--><!--</a>--><!--</li>--><li ui-sref-active="active" has-authority="ROLE_USER"><a ui-sref="search" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-search"></span> <span class="hidden-sm">Ricerca</span></a></li><li ui-sref-active="active" ng-if="vm.$localStorage.cart" has-authority="ROLE_USER"><a ui-sref="cart" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-shopping-cart"></span> <span class="hidden-sm">Carrello Firma ({{vm.$localStorage.cart | numkeys}})</span></a></li><li ui-sref-active="active" ng-show="isResponsabileStruttura"><a href="https://ace.cnr.it/anagrafica/ruolopersona" target="_blank" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-education"></span> <span class="hidden-sm">Gestione Ruoli</span></a></li><li ui-sref-active="active" has-authority="ROLE_USER"><a ui-sref="helpdesk" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-sm">Helpdesk</span></a></li><li ng-if="app == \'oiv\'" ui-sref-active="active" has-authority="ROLE_USER"><a ui-sref="user-memberships" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">Membership Utente</span></a></li><li ng-if="app == \'cnr\'" ui-sref-active="active" has-authority="ROLE_USER"><a ui-sref="manualistica" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span> <span class="hidden-sm">Manualistica&Faq</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="cnrauthority" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.cnrauthority">Cnrauthority</span></a></li><li ui-sref-active="active"><a ui-sref="form" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.form">Form</span></a></li><li ui-sref-active="active"><a ui-sref="cnrgroup" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.cnrgroup">Cnrgroup</span></a></li><li ui-sref-active="active"><a ui-sref="dynamiclist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.dynamiclist">Dynamiclist</span></a></li><li ui-sref-active="active"><a ui-sref="view" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.view">View</span></a></li><li ui-sref-active="active"><a ui-sref="notification-rule" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.notificationRule">Notification Rule</span></a></li><li ui-sref-active="active"><a ui-sref="membership" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.membership">Membership</span></a></li><li ui-sref-active="active"><a ui-sref="relationship" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.relationship">Relationship</span></a></li><li ui-sref-active="active"><a ui-sref="avviso" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.avviso">Avviso</span></a></li><li ui-sref-active="active"><a ui-sref="external-message" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.externalMessage">External Message</span></a></li><li ui-sref-active="active"><a ui-sref="faq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.faq">Faq</span></a></li><li ui-sref-active="active"><a ui-sref="blacklist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.blacklist">Blacklist</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-any-authority="ROLE_ADMIN, ROLE_amministratori-supporto-tecnico@0000" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()" has-authority="ROLE_ADMIN" ng-hide="(app != \'showcase\' || app != \'oiv\')"><span class="glyphicon glyphicon-user"></span>&nbsp; <span translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide="inProduction"><a href="/h2-console" target="_tab" ng-click="vm.collapseNavbar()" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-hdd"></span>&nbsp; <span translate="global.menu.admin.database">Database</span></a></li><li ui-sref-active="active"><a ui-sref="manageprocessdefinitions" ng-click="vm.collapseNavbar()" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Gestisci Process Definition</span></a></li><li ui-sref-active="active"><a ui-sref="managemail" ng-click="vm.collapseNavbar()" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-envelope"></span>&nbsp; <span>Gestisci Notifiche Email</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li><a href="" ng-click="vm.switchUser()" id="switchuser" has-any-authority="ROLE_ADMIN, ROLE_amministratori-supporto-tecnico@0000"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span>Impersona Utente</span></a></li></ul></li><!--             <li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"> --><!--                 <a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"> --><!--                     <span> --><!--                         <span class="glyphicon glyphicon-user"></span> --><!--                         <span class="hidden-sm" translate="global.menu.account.main"> --><!--                             Account --><!--                         </span> --><!--                         <b class="caret"></b> --><!--                     </span> --><!--                 </a> --><!--                 <ul class="dropdown-menu" uib-dropdown-menu> --><!--                     <li ui-sref-active="active" ng-if="app == \'oiv\'" ng-switch-when="true"> --><!--                         <a ui-sref="settings" ng-click="vm.collapseNavbar()"> --><!--                             <span class="glyphicon glyphicon-wrench"></span>&nbsp; --><!--                             <span translate="global.menu.account.settings">Settings</span> --><!--                         </a> --><!--                     </li> --><!--                     <li ui-sref-active="active" ng-if="(app == \'oiv\')||(app == \'cnr\')"> --><!--                         <a ui-sref="password" ng-click="vm.collapseNavbar()"> --><!--                             <span class="glyphicon glyphicon-lock"></span>&nbsp; --><!--                             <span translate="global.menu.account.password">Password</span> --><!--                         </a> --><!--                     </li> --><!--                     <li ui-sref-active="active" ng-switch-when="true"> --><!--                         <a href="" ng-click="vm.logout()" id="logout"> --><!--                             <span class="glyphicon glyphicon-log-out"></span>&nbsp; --><!--                             <span translate="global.menu.account.logout">Sign out</span> --><!--                         </a> --><!--                     </li> --><!--                     <li ui-sref-active="active" ng-switch-when="false"> --><!--                         <a href="" ng-click="vm.login()" id="login"> --><!--                             <span class="glyphicon glyphicon-log-in"></span>&nbsp; --><!--                             <span translate="global.menu.account.login">Sign in</span> --><!--                         </a> --><!--                     </li> --><!--                 </ul> --><!--             </li> --><!--             <li ng-switch-when="true" has-authority="ROLE_PREVIOUS_ADMINISTRATOR"> --><!--                 <a ui-sref="availableTasks" ng-click="vm.cancelSwitchUser()"> --><!--                     <span class="label label-warning" > --><!--                         <span class="glyphicon glyphicon-user"></span> --><!--                         Impersonating: {{vm.account.login}} --><!--                     </span> --><!--                 </a> --><!--             </li> --><li><a href="#" id="menu-apps"><span class="glyphicon glyphicon-th"></span></a></li><li><a href="#" id="menu-user"><span class="glyphicon glyphicon-user"></span> {{vm.account.login}}</a></li></ul></div></nav>');
$templateCache.put('app/pages/availableTasks/availableTasks.html','<div ng-cloak><div class="row form-group"><div class="col-md-12"><uib-tabset active="indextab" justified="true" type="pills"><uib-tab index="0" classes="mine" select="setActiveContent(\'myTasks\')"><uib-tab-heading><h3><em class="glyphicon glyphicon-inbox"></em> Compiti assegnati a me: {{vm.myTasks.total}}</h3></uib-tab-heading></uib-tab><uib-tab index="1" classes="available" select="setActiveContent(\'availables\')"><uib-tab-heading><h3><em class="glyphicon glyphicon-user"></em> Compiti di ruolo<br>da prendere in carico: {{vm.availableTasks.total}}</h3></uib-tab-heading></uib-tab><uib-tab index="2" classes="others" select="setActiveContent(\'taskAssignedInMyGroups\')"><uib-tab-heading><h3><em class="glyphicon glyphicon-tasks"></em> Compiti di ruolo presi<br>in carico da altri: {{vm.taskAssignedInMyGroups.total}}</h3></uib-tab-heading></uib-tab></uib-tabset></div></div><div class="row"><div class="col-md-12"><div class="progress"><uib-progress animate="true"><uib-bar class="progress-bar-striped" value="100* vm.myTasks.total/(vm.availableTasks.total+ vm.myTasks.total + vm.taskAssignedInMyGroups.total)" type="success"><span>{{vm.myTasks.total}}</span></uib-bar><uib-bar class="progress-bar-striped" value="100* vm.availableTasks.total/(vm.availableTasks.total+ vm.myTasks.total + vm.taskAssignedInMyGroups.total)" type="primary"><span>{{vm.availableTasks.total}}</span></uib-bar><uib-bar class="progress-bar-striped" value="100* vm.taskAssignedInMyGroups.total/(vm.availableTasks.total+ vm.myTasks.total + vm.taskAssignedInMyGroups.total)" type="info"><span>{{vm.taskAssignedInMyGroups.total}}</span></uib-bar></uib-progress></div></div><div class="col-sm-3"><div><h4>Ordinamento temporale</h4><div><button class="btn btn-default btn-block margin-top-20" ng-click="vm.order ===  \'ASC\' ?  vm.order=\'DESC\' : vm.order = \'ASC\'"><span class="glyphicon glyphicon-sort"></span> {{vm.order === \'ASC\' ? \'Crescente\' : \'Descrescente\'}}</button></div></div><br><br><h4>Tipologie</h4><div id="tipologieDiv"><div><div class="dropdown md-menu-origin"><ui-select ng-model="vm.processDefinitionKey" title="Tipologie" on-select="loadAllTasks()"><ui-select-match placeholder="Seleziona la tipologia di flusso" allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="processDefinition.key as processDefinition in wfDefsAll"><span ng-bind-html="processDefinition.name"></span></ui-select-choices></ui-select></div></div></div><br><div><ng-include id="searchFields" src="formUrl"></ng-include></div><br><div><button ng-click="showProcessInstances()" class="btn btn-primary">Filtra</button> <button ng-click="resetSearcParams()" class="btn btn-default">Reset</button></div></div><div class="col-sm-9"><div ng-show="vm.activeContent == \'myTasks\'"><h3><span class="label label-success"><em class="glyphicon glyphicon-inbox"></em> Lista dei compiti assegnati a me</span></h3><!--paginazione myTasks--> <button class="btn btn-success pull-right" ng-show="vm.myTotalItems > 0" ng-click="addAllToCart(\'mine\')"><span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> Aggiungi al carrello tutti i flussi di questa ricerca</button><div class="text-center" ng-show="vm.myTotalItems > 0"><jhi-item-count page="vm.myPage" total="vm.myQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.myTotalItems" ng-model="vm.myPage" ng-change="vm.transition(vm.myPage)"></uib-pagination></div><task-list tasks="vm.myTasks.data" action-buttons="true" completed="false"></task-list><!--paginazione myTasks--><div class="text-center" ng-show="vm.myTotalItems > 0"><jhi-item-count page="vm.myPage" total="vm.myQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.myTotalItems" ng-model="vm.myPage" ng-change="vm.transition(vm.myPage)"></uib-pagination></div></div><div ng-show="vm.activeContent == \'availables\'"><h3><span class="label label-primary"><em class="glyphicon glyphicon-user"></em> Lista dei compiti di ruolo da prendere in carico</span></h3><!--paginazione availabletasks--> <button class="btn btn-success pull-right" ng-show="vm.availableTotalItems > 0" ng-click="addAllToCart(\'available\')"><span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> Aggiungi al carrello tutti i flussi di questa ricerca</button><div class="text-center" ng-show="vm.availableTotalItems > 0"><jhi-item-count page="vm.availablePage" total="vm.availableQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.availableTotalItems" ng-model="vm.availablePage" ng-change="vm.transition(vm.availablePage)"></uib-pagination></div><task-list tasks="vm.availableTasks.data" action-buttons="true" completed="false"></task-list><!--paginazione availabletasks--><div class="text-center" ng-show="vm.availableTotalItems > 0"><jhi-item-count page="vm.availablePage" total="vm.availableQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.availableTotalItems" ng-model="vm.availablePage" ng-change="vm.transition(vm.availablePage)"></uib-pagination></div></div><div ng-show="vm.activeContent == \'taskAssignedInMyGroups\'"><h3><span class="label label-info"><em class="glyphicon glyphicon-user"></em> Lista dei compiti di ruolo presi in carico da altri</span></h3><!--paginazione TaskAssignedInMyGroups--><div class="text-center" ng-show="vm.TAIMGTotalItems > 0"><jhi-item-count page="vm.TAIMGPage" total="vm.TAIMGQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.TAIMGTotalItems" ng-model="vm.TAIMGPage" ng-change="vm.transition(vm.TAIMGPage)"></uib-pagination></div><task-list tasks="vm.taskAssignedInMyGroups.data" completed="false"></task-list><!--paginazione TaskAssignedInMyGroups--><div class="text-center" ng-show="vm.TAIMGTotalItems > 0"><jhi-item-count page="vm.TAIMGPage" total="vm.TAIMGQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.TAIMGTotalItems" ng-model="vm.TAIMGPage" ng-change="vm.transition(vm.TAIMGPage)"></uib-pagination></div></div></div></div><pre ng-if="isDevelopment">{{vm | json}}</pre><pre ng-if="isDevelopment">{{tasks | json}}</pre></div>');
$templateCache.put('app/pages/cart/cart.html','<div class="row"><div class="col-md-8"><task-list tasks="$localStorage.cart" in-firma="true" completed="false"></task-list></div><div class="col-md-4"><div class="col-md-12 text-center"><h2>Azioni</h2></div><button class="btn btn-block btn-success" ng-click="openSignModal()"><span class="glyphicon glyphicon-pencil"></span> Firma tutti</button><hr><button class="btn btn-block btn-danger" ng-click="removeAll()"><span class="glyphicon glyphicon-trash"></span> Svuota carrello e ritorna a \'I miei compiti\'</button></div></div><pre ng-if="isDevelopment">{{$localStorage.cart | json}}</pre>');
$templateCache.put('app/pages/cart/signmany.modal.html','<div class="modal-header"><h4>Firma Multipla</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><form novalidate name="signManyForm"><div class="form-group"><label for="username">Username</label><input type="text" ng-model="vm.username" id="username" class="form-control" required></div><div class="form-group"><label for="password">Password</label><input type="text" ng-model="vm.password" id="password" ng-attr-type="{{ showPassword ? \'text\' : \'password\' }}" class="form-control" required></div><div class="form-group"><label for="otp">OTP</label><input type="text" ng-model="vm.otp" id="otp" ng-attr-type="{{ showPassword ? \'text\' : \'password\' }} " class="form-control" required></div><div class="row"><div class="col-md-12"><div class="alert" ng-class="vm.messageClass" ng-show="vm.message"><span ng-bind-html="vm.message"></span> <button type="button" class="close" ng-click="vm.message = undefined">\xD7</button></div></div></div><button class="btn btn-primary" ng-click="vm.signMany()" ng-disabled="signManyForm.$invalid || vm.submitDisabled"><span class="glyphicon glyphicon-pencil"></span> Firma</button></form></div></div></div>');
$templateCache.put('app/pages/details/deleteProcess.modal.html','<div class="modal-header"><h4>Cancellazione Flusso</h4><div class="form-group"><label for="user">Commento per cancellazione Flusso:</label><input ng-model="vm.deleteReason" id="deleteReason" class="form-control" aria-invalid="true" ng-required="true" type="text"></div><button class="btn btn-warning" ng-click="deleteProcess(vm.deleteReason)"><span class="glyphicon glyphicon-hand-right"></span> Cancella Flusso</button></div>');
$templateCache.put('app/pages/details/details.html','<div class="col-md-12" ng-cloak><div class="row"><div class="col-md-8"><h3>{{vm.data.entity.businessKey}} <span ng-class="{\'label-info\': vm.data.entity.endTime != null , \'label-primary\': vm.data.entity.endTime == null}" class="label">{{vm.data.entity.endTime == null ? \'attivo\' : \'completato\'}}</span></h3><div ng-show="vm.data.entity.endTime == null" class="btn-toolbar"><div class="btn-group" ng-show="isResponsabile"><button class="btn btn-warning btn-xs" ng-click="reassign(vm.taskId, processInstanceId)"><span class="glyphicon glyphicon-hand-right"></span> Riassegna Compito</button></div><div class="btn-group" ng-show="isResponsabile"><button class="btn btn-danger btn-xs" ng-click="deleteProcessInstance(processInstanceId)"><span class="glyphicon glyphicon-remove-circle"></span> Elimina Flusso</button><hr></div></div><div class="btn-group" ng-show="isRevocabile"><button class="btn btn-danger btn-xs" ng-click="avviaFlussoRevoca()"><span class="glyphicon glyphicon-remove-circle"></span> Revoca</button><hr></div><div ng-show="vm.data.linkedProcesses"><b>Flussi collegati: </b><span ng-repeat="linkedProcess in vm.data.linkedProcesses"><b><a ng-href="#/details?processInstanceId={{linkedProcess.id}}">{{linkedProcess.key}} ({{linkedProcess.titolo}})</a></b></span></div><hr><div><h5><b>Titolo: </b>{{vm.data.entity.name | get: \'titolo\'}}</h5></div><div><b>Descrizione: </b>{{vm.data.entity.name | get: \'descrizione\'}}</div><div><b>Avviato da: </b>{{vm.data.entity.name | get: \'initiator\'}} il {{vm.data.entity.variabili.startDate | data}}</div><div ng-hide="!vm.data.entity.variabili.completed"><b>completato il:</b>{{vm.data.entity.variabili.endDate | data}}</div><div ng-show="vm.data.entity.endTime == null"><b>Stato: </b>{{vm.data.entity.name | get: \'stato\'}}</div><div ng-show="vm.data.entity.endTime != null"><b>Stato Finale: </b>{{vm.data.entity.name | get: \'stato\'}}</div><div ng-show="vm.data.entity.deleteReason != null"><b>Motivazione Eliminazione: </b>{{vm.data.entity.deleteReason}}</div><!--ruolo/utente assegnatario del task in esecuzione--><div ng-show="vm.data.groupCandidate"><b>Ruolo Assegnatario: </b>{{vm.data.groupCandidate}}</div><div ng-show="vm.activeTask.assignee"><b>Utente Assegnatario: </b>{{vm.activeTask.assignee}}</div><ul class="list-unstyled"><ng-include src="vm.detailsView"></ul><hr><div class="col-md-offset-9" role="group" ng-show="vm.showGerarchia"><button ng-click="exportCsv()" class="btn btn-info"><span class="glyphicon glyphicon-export"></span> Genera File Graduatoria.xls</button></div><h3>Documenti</h3><attachments process-instance-id="{{processInstanceId}}" attachments="{{vm.data.attachments}}" businesskey="{{vm.data.businessKey}}" can-publish="canPublish" can-update-attachments="canUpdateAttachments"><div has-authority="ROLE_ADMIN"><h4>Tutte le variabili</h4><ul><li ng-repeat="metadatum in vm.data.entity.variables">{{metadatum.name}}: {{metadatum.value}} <a href ng-click="editVariable(metadatum.name, metadatum.value)"><span class="glyphicon glyphicon-pencil"></span></a></li></ul></div><div has-authority="ROLE_ADMIN"><h4>Identity Links</h4><span ng-repeat="(taskId, link) in vm.data.identityLinks"><div ng-show="link.assignee || link.candidateUsers || link.candidateGroup">TaskId - <strong>{{ taskId }}:</strong> (Assignee: {{link.assignee || null}}, Candidate Users: {{link.candidateUsers}}, Candidate Groups: {{link.candidateGroups}})</div><span ng-repeat="actualLink in link.links"><strong>{{ actualLink.type }}:</strong> {{ actualLink.user || actualLink.group || actualLink.groupId || actualLink.userId}}<br></span></span></div></div><div class="col-md-4"><div class="row"><div class="col-sm-6 col-md-12"><a ng-click="openDiagramModal(vm.diagramUrl)"><img class="img-bordered" ng-src="{{vm.diagramUrl}}" title="{{vm.data.entity.processDefinitionKey}}" style="max-width: 100%"></a><hr></div><div class="col-sm-6 col-md-12"><button class="btn btn-default btn-block" ng-click="history(processInstanceId, vm.data.startEvent, vm.initiator)"><span class="glyphicon glyphicon-time"></span> Visualizza Cronologia</button> <button class="btn btn-primary btn-block" ng-click="exportSummary(\'/api/summaryPdf?processInstanceId=\' + processInstanceId, \'Summary_\' + vm.data.entity.variabili.titolo + \'.pdf\')">Export Summary</button></div></div></div></div><hr><div class="row"><div class="col-md-4 col-md-offset-4"><div class="btn-group btn-group-justified" role="group"><a class="btn btn-primary" back><span class="glyphicon glyphicon-arrow-left"></span> Ritorna</a> <a class="btn btn-primary" ng-disabled="button.disabled" ng-if="vm.taskId && (vm.activeTask.assignee ? vm.activeTask.assignee == vm.username : true)" ui-sref="task({processDefinitionId: vm.data.entity.processDefinitionId, taskId: vm.taskId})"><span class="glyphicon glyphicon-cog"></span> Azioni <span class="glyphicon glyphicon-arrow-right"></span></a></div></div><div class="col-md-3 col-md-offset-1"><div class="btn-group btn-group-justified" role="group"><a class="btn btn-primary" ng-if="vm.taskId && vm.activeTask.category == \'firma\' && !inCart(vm.activeTask.id)" ng-click="addToCart(vm.activeTask)"><span class="glyphicon glyphicon-shopping-cart"></span> Aggiungi al Carrello Firma </a><a class="btn btn-primary" ng-if="inCart(vm.activeTask.id)" ng-click="removeFromCart(vm.activeTask)"><span class="glyphicon glyphicon-shopping-cart"></span> Rimuovi dal Carrello Firma</a></div></div></div><div class="row dev"><hr><div class="col-md-12"><pre ng-if="isDevelopment">{{vm | json}}</pre></div></div></div>');
$templateCache.put('app/pages/details/editvariable.modal.html','<div class="modal-header"><h4 class="modal-title">Modifica Variabile {{vm.variableName}} (id flusso {{vm.processInstanceId}})</h4><p>Da grandi poteri derivano grandi responsabilita\'</p></div><div class="modal-body"><div class="msg msg-danger" ng-if="vm.error">Si e\' verificato un errore</div><div class="form-group"><label for="valoreVariabile">{{vm.variableName}}</label><input ng-model="vm.currentValue" id="valoreVariabile" class="form-control" aria-invalid="true" type="text"></div><button class="btn btn-danger" type="button" ng-click="vm.setVariable()">Modifica</button></div><div class="modal-footer"><button class="btn btn-primary" type="button" ng-click="$dismiss()">Chiudi</button></div>');
$templateCache.put('app/pages/details/history.modal.html','<div class="modal-header"><h4>Cronologia</h4><!--startTask non rientra tra i task "normali"--><div class="task-history" id="startEvent"><div ng-repeat="variable in vm.startTask | orderBy:\'-name\'"><div ng-switch="variable.name"><div ng-switch-when="titolo"><h5><task-details variables="vm.startTask" title="variable.value"></task-details><b>Flusso {{variable.value}}</b><br><br></h5></div><div ng-switch-when="startDate"><b>Avviato il </b>{{variable.value | dataora}}<br></div></div></div><div><b>Dall\'utente </b>{{vm.initiator}}<br></div></div><div class="task-history" ng-repeat="task in vm.tasks | orderBy:\'historyTask.startTime\'"><h5><task-details variables="task.historyTask.variables" title="task.historyTask.name"></task-details><b>{{task.historyTask.name}}</b></h5><!--identitylink (ruolo/utente assegnatario, esecutore del task--><div ng-repeat="identityLink in task.historyIdentityLink"><div ng-switch="identityLink.type"><div ng-switch-when="candidate"><span ng-show="identityLink.userId !== null"><b>Utente Assegnatario:</b> {{identityLink.userId}}</span><br><span ng-show="identityLink.groupId !== null"><b>Ruolo Assegnatario:</b> {{identityLink.groupId}}</span><br></div><div ng-switch-when="esecutore"><span ng-show="identityLink.userId !== null"><b>Eseguito dall\'Utente:</b> {{identityLink.userId}}</span><br></div></div></div><b>Data di assegnazione:</b> {{task.historyTask.startTime | dataora}}<br><div ng-hide="task.historyTask.endTime === null"><b>Con data di completamento:</b> {{task.historyTask.endTime | dataora}}</div><!--scelta utente--><div ng-repeat="variable in task.historyTask.variables"><div ng-if="variable.scope == \'local\' && variable.name == \'sceltaUtente\'"><span ng-show="variable.value !== null"><b>Con Scelta Utente:</b> {{variable.value}}</span><br></div></div></div></div>');
$templateCache.put('app/pages/details/reassign.modal.html','<div class="modal-header"><h4>Riassegnazione del Compito</h4><div class="form-group"><label for="user">Selezionare l\'utente a cui assegnare il compito:</label><typeaheadinput type="users" id="rup" ng-model="vm.user" label-model="vm.user_label" ng-required="true"></typeaheadinput></div><button class="btn btn-warning" ng-click="reassignTask(vm.user)"><span class="glyphicon glyphicon-hand-right"></span> Assegna Compito</button></div>');
$templateCache.put('app/pages/details/revoca.modal.html','<div class="modal-header"><h4 class="modal-title">Avviare flusso di revoca?</h4><p></p></div><div class="modal-body"><div class="msg msg-danger" ng-if="vm.error">Si e\' verificato un errore</div><div class="form-group">Sar\xE0 avviato un flusso per la revoca del flusso visualizzato.<br>Procedere con la Revoca?</div><button class="btn btn-danger" type="button" ng-click="vm.revoca()">Revoca</button></div><div class="modal-footer"><button class="btn btn-primary" type="button" ng-click="$dismiss()">Chiudi</button></div>');
$templateCache.put('app/pages/helpdesk/helpdesk.html','<div ng-cloak><div class="row" ng-hide="idHelpdesk"><div class="col-md-10 col-md-offset-1"><div class="title"><p class="lead" translate="helpdesk.title">HELPDESK</p></div><div class="alert alert-info alert-dismissible" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"></button><div translate="helpdesk.form.avviso"></div></div></div></div><div class="row"><div class="col-md-8 col-md-offset-2"><form novalidate class="flows-form" name="helpdeskForm" ng-submit="submitHelpdesk()"><cnr-tree string-list="categorie" label="Tipologia Segnalazione Helpdesk" ng-model="$parent.vm.hdDataModel" ng-modelid="id" required autofill></cnr-tree><div class="form-group" ng-hide="idHelpdesk"><label for="emailObject" translate="helpdesk.form.oggetto">Object</label><input type="text" class="form-control" id="emailObject" ng-required="true" ng-model="helpdeskModel.titolo" placeholder="{{\'helpdesk.form.oggetto\' | translate}}"></div><div class="form-group" ng-hide="idHelpdesk"><label for="emailMessage" translate="helpdesk.form.messaggio">Message</label><textarea class="form-control" id="emailMessage" ng-model="helpdeskModel.descrizione" placeholder="{{\'helpdesk.form.messaggio\' | translate}}" rows="5" ng-required="true"></textarea></div><div class="form-group" ng-hide="idHelpdesk"><form novalidate class="flows-form" name="fileForm" ng-submit="submitHelpdesk()"><div><fileinput name="allegato" label="Allegato Segnalazione" multiple="false" cnr-required="false"></div><button class="btn btn-primary" type="submit" translate="helpdesk.form.invia">Send<span class="glyphicon glyphicon-arrow-right"></span></button></form></div></form></div></div></div>');
$templateCache.put('app/pages/manualistica/manualistica.html','<div class="row"><div class="row"><div class="col-md-3 padding-top"><br><h4>Tipologie</h4><div id="tipologieDiv"><div><div class="dropdown md-menu-origin"><ui-select ng-model="vm.processDefinitionKey" title="Tipologie" on-select="searchFaq()"><ui-select-match placeholder="Seleziona la tipologia di flusso" allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="processDefinition.key as processDefinition in wfDefsAll"><span ng-bind-html="processDefinition.name"></span></ui-select-choices></ui-select></div></div></div></div><div id="resultDiv" class="col-md-9" ng-cloak><h2 style="color:#069">Manualistica</h2><ul><!--<li><a href="https://doc-cnr.si.cnr.it/rest/content?nodeRef=e6765d0c-eca5-4503-93ca-b5dde27ea68a">Manuale utente Flusso Acquisti</a></li>--><li ng-repeat="manuale in vm.manuali"><a ng-click="downloadManuale(manuale)">{{manuale}}</a></li><li><a href="https://e-learning.formazione.cnr.it/course/view.php?id=5">Video Tutorial</a></li></ul><br><hr width="700px;" color="#069" size="10"><br><h2 style="color: #069">Faq</h2><br><h4>Per vedere ANCHE le Faq specifiche di ogni tipologia di flusso, selezionarlo dal men\xF9 laterale</h4><br><h3 style="color:#069">Scrivania Digitale</h3><br><ul><li ng-repeat="faq in vm.faqs"><b>{{faq.domanda}}</b><br><em>{{faq.risposta}}</em></li></ul><br><h3 style="color:#069">{{vm.myProcessDefinitionKey}}</h3><br><ul><li ng-repeat="specificFaq in vm.specificFaqs"><b>{{specificFaq.domanda}}</b><br><em>{{specificFaq.risposta}}</em></li></ul></div></div></div>');
$templateCache.put('app/pages/search/search.html','<div ng-cloak><div class="row form-group"><div class="col-md-12"><ul class="nav nav-pills nav-justified"><li role="presentation" ng-class="vm.searchParams.active == true ? \'active\' : \'\'"><a class="pointer" ng-click="vm.searchParams.active = true; vm.searchParams.page = 1; search()" data-toggle="tab"><h3><em class="glyphicon glyphicon-edit"></em> Flussi attivi</h3></a></li><li role="presentation" ng-class="vm.searchParams.active == true ? \'\': \'active-info\'"><a class="pointer" ng-click="vm.searchParams.active = false; vm.searchParams.page = 1; search()" data-toggle="tab"><h3><em class="glyphicon glyphicon-check"></em> Flussi terminati</h3></a></li></ul></div></div><div class="row"><div class="col-md-3 padding-top"><div><h4>Ordinamento temporale</h4><div><button class="btn btn-default btn-block margin-top-20" ng-click="vm.searchParams.order ===  \'ASC\' ?  vm.searchParams.order  = \'DESC\' : vm.searchParams.order  = \'ASC\'; search()"><span class="glyphicon glyphicon-sort"></span> {{vm.searchParams.order === \'ASC\' ? \'Crescente\' : \'Descrescente\'}}</button></div></div><br><h4>Tipologie</h4><div id="tipologieDiv"><div><div class="dropdown md-menu-origin"><ui-select ng-model="vm.searchParams.processDefinitionKey" title="Tipologie" on-select="search()"><ui-select-match placeholder="Seleziona la tipologia di flusso" allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="processDefinition.key as processDefinition in wfDefsAll"><span ng-bind-html="processDefinition.name"></span></ui-select-choices></ui-select></div><br><div><ng-include id="searchFields" src="formUrl" onload="reload"></ng-include></div></div></div><br><br><button ng-click="vm.searchParams.page = 1; search()" class="btn btn-primary"><span class="glyphicon glyphicon-filter"></span> Filtra</button> <button ng-click="exportCsv()" class="btn btn-info"><span class="glyphicon glyphicon-export"></span> Esporta Csv</button></div><div id="resultDiv" class="col-md-9" ng-cloak><h3>Flussi {{vm.searchParams.active ? \'attivi\' : \'terminati\'}}</h3><!--Paginazione --><div class="row" ng-show="vm.totalItems > 0"><div class="text-center col-md-12"><jhi-item-count page="vm.searchParams.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.searchParams.page" ng-change="search()"></uib-pagination></div></div><div class="row"><div ng-show="vm.loading" class="text-center col-md-12"><div ng-show="vm.loading" class="sprint-loader sprint-loader-mini"></div>Loading...</div><div ng-hide="vm.loading" class="col-md-12"><process-list processes="vm.results" paging="paging"></process-list></div></div><!--Paginazione --><div class="row"><div class="text-center col-md-12" ng-show="vm.totalItems > 0"><jhi-item-count page="vm.searchParams.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.searchParams.page" ng-change="search()"></uib-pagination></div></div></div></div></div><pre ng-if="isDevelopment"> {{vm | json}} </pre>');
$templateCache.put('app/pages/statistics/statistics.html','<div ng-cloak><div class="row"><div class="col-md-3"><label>Statistiche dal</label><div class="form-group"><input type="date" ng-model="vm.exportParams.startDateGreat" class="ng-pristine ng-untouched ng-valid ng-empty" aria-invalid="false"></div><label>al</label><div class="form-group"><input type="date" ng-model="vm.exportParams.startDateLess" class="ng-pristine ng-untouched ng-valid ng-empty" aria-invalid="false"></div><div class="form-group"><label>Struttura</label><select ng-model="vm.exportParams.struttura"><option ng-repeat="struttura in strutture" value="{{struttura.value}}">{{struttura.label}}</option></select></div><button ng-click="exportFile(true, vm.processDefinition.key, vm.exportParams.startDateGreat, vm.exportParams.startDateLess, \'statistiche_\' + vm.processDefinition.key + \'.pdf\')" class="btn btn-primary" translate="statistics.home.exportPdfLabel"></button> <button ng-click="exportFile(false, vm.processDefinition.key, vm.exportParams.startDateGreat, vm.exportParams.startDateLess, \'statistiche_\' + vm.processDefinition.key + \'.xls\')" class="btn btn-primary" translate="statistics.home.exportCsvLabel"></button></div><div class="col-md-9"><h2 translate="statistics.home.title"></h2><h2>{{vm.processDefinition}}</h2><pre ng-if="isDevelopment">{{vm | json\t}}</pre></div></div></div>');
$templateCache.put('app/pages/myProcessInstances/myProcessInstances.html','<div ng-cloak><div class="row form-group"><div class="col-md-12"><uib-tabset active="0" justified="true" type="pills"><uib-tab index="0" select="setActiveContent(\'active\')"><uib-tab-heading><h3><i class="glyphicon glyphicon-edit"></i> Flussi attivi: {{vm.myProcessInstancesActive.length}}</h3></uib-tab-heading></uib-tab><uib-tab classes="available" index="1" select="setActiveContent(\'terminated\')"><uib-tab-heading><h3><i class="glyphicon glyphicon-check"></i> Flussi terminati: {{vm.myProcessInstancesTerminated.length}}</h3></uib-tab-heading></uib-tab></uib-tabset></div></div><div class="row"><div class="col-md-12"><div class="progress"><uib-progress animate="false"><uib-bar class="progress-bar-striped" value="100* vm.myProcessInstancesActive.length/(vm.myProcessInstancesTerminated.length+ vm.myProcessInstancesActive.length)" type="primary"><span>{{vm.myProcessInstancesActive.length}}</span></uib-bar><uib-bar class="progress-bar-striped" value="100* vm.myProcessInstancesTerminated.length/(vm.myProcessInstancesTerminated.length + vm.myProcessInstancesActive.length)" type="info"><span>{{vm.myProcessInstancesTerminated.length}}</span></uib-bar></uib-progress></div></div><div class="col-md-3"><div><h4>Ordinamento temporale</h4><div><button class="btn btn-default btn-block margin-top-20" ng-click="vm.searchParams.order ===  \'ASC\' ?  vm.searchParams.order=\'DESC\' : vm.searchParams.order = \'ASC\'"><span class="glyphicon glyphicon-sort"></span> {{vm.order === \'ASC\' ? \'Crescente\' : \'Descrescente\'}}</button></div></div><h4>Tipologie</h4><div id="tipologieDiv"><div><div class="dropdown md-menu-origin"><ui-select ng-model="vm.processDefinitionKey" title="Tipologie" on-select="loadMyProcessInstances()"><ui-select-match placeholder="Seleziona la tipologia di flusso" allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="processDefinition.key as processDefinition in wfDefsBootable"><span ng-bind-html="processDefinition.name"></span></ui-select-choices></ui-select></div></div></div><br><div><ng-include id="searchFields" src="formUrl" onload="removeUserDiv()"></ng-include></div><button ng-click="loadMyProcessInstances()" class="btn btn-primary"><span class="glyphicon glyphicon-filter"></span> Filtra</button></div><div class="col-md-9" ng-show="activeContent == \'active\'"><h3><span class="label label-primary"><i class="glyphicon-inbox"></i> Flussi avviati da me ed ancora ATTIVI</span></h3><process-list processes="vm.myProcessInstancesActive" paging="paging"></process-list><!--paginazione Flussi Attivi--><div class="text-center"><jhi-item-count page="vm.pageActive" total="vm.queryCountActive" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItemsActive" ng-model="vm.pageActive" ng-change="vm.transition()"></uib-pagination></div></div><div class="col-md-9" ng-show="activeContent == \'terminated\'"><h3><span class="label label-info" ng-class="label - info"><i class="glyphicon glyphicon-user"></i> Flussi avviati da me e TERMINATI</span></h3><process-list processes="vm.myProcessInstancesTerminated" paging="paging"></process-list><!--paginazione Flussi Terminati--><div class="text-center"><jhi-item-count page="vm.pageTerminated" total="vm.queryCountTerminated" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItemsTerminated" ng-model="vm.pageTerminated" ng-change="vm.transition()"></uib-pagination></div></div></div><pre ng-if="isDevelopment">{{tasks | json}}</pre><pre ng-if="isDevelopment">{{vm | json}}</pre></div>');
$templateCache.put('app/pages/task/task.html','<div ng-cloak><!-- intestazione --><div class="row text-center" ng-if="vm.taskId"><h3>{{vm.definition.name}}</h3><p class="text-muted">{{vm.definition.description}}</p><div class="col-xs-8"><ul class="list-unstyled"><li><h3><strong>{{vm.taskVariables.key}} [{{data.entity.name}}]</strong></h3></li><li class="text-left">Titolo: <strong>{{vm.taskVariables.titolo}}</strong></li><li class="text-left">Descrizione: <strong>{{vm.taskVariables.descrizione}}</strong></li><li class="text-left">Avviato il <strong>{{vm.taskVariables.startDate | data}}</strong> da <strong>{{vm.taskVariables.initiator}}</strong></li></ul></div><div class="col-xs-4">DIAGRAMMA<br><a ng-click="openDiagramModal(vm.diagramUrl)"><img class="img-bordered" ng-src="{{vm.diagramUrl}}" title="{{vm.definition.name}}" style="max-width: 100%; max-height: 100px"></a></div></div><div class="row text-center" ng-if="!vm.taskId"><!-- intestazione --><h3>{{vm.definition.name}}</h3><p class="text-muted">{{vm.definition.description}}</p><img class="img-bordered" ng-src="{{vm.diagramUrl}}" title="{{vm.definition.name}}" style="max-width: 100%"></div><hr><div class="row"><button ng-click="createDraft($state.params.taskId)" class="btn btn-info"><span class="glyphicon glyphicon glyphicon-floppy-save"></span>Salva Bozza</button><div class="col-md-6 col-md-offset-3"><!--      <form novalidate class="flows-form" name="taskForm" ng-submit="submitTask(picFile)">--><form novalidate class="flows-form" name="taskForm" ng-submit="preSubmitTask(picFile)"><!--      <form novalidate class="flows-form" name="taskForm">--> <input type="hidden" name="taskId" value="{{vm.data.taskId}}"> <input type="hidden" name="processDefinitionId" value="{{data.processDefinitionId}}"><ng-include src="vm.formUrl" onload="autofill()"></ng-include><div class="row"><div class="col-md-12"><div class="btn-group btn-group-justified" role="group"><div class="btn-group" role="group"><button class="btn btn-primary" type="button" back><span class="glyphicon glyphicon-arrow-left"></span>Ritorna</button></div><div class="btn-group" role="group"><button class="btn btn-primary" type="submit" ng-disabled="button.disabled" ng-class="{\'btn-warning\': taskForm.$invalid}">{{ vm.taskId ? "Invia" : "Avvia Flusso"}} <span class="glyphicon glyphicon-arrow-right"></span></button></div></div></div></div></form></div></div><hr><!--   <pre ng-if="!isDevelopment">{{taskForm | json}}</pre> --><pre ng-if="isDevelopment">{{attachments | json}}</pre><pre ng-if="isDevelopment">{{data | json}}</pre><pre ng-if="isDevelopment">{{vm | json}}</pre><pre ng-if="isDevelopment">{{taskForm | json}}</pre></div><!--modale di conferma della scelta in caso di valutazione-scientifica(accordi-internazionali-domande)--><script type="text/ng-template" id="confirmModal.html"><div id="confirmModal">\n    <div class="modal-header">\n      <h4 class="modal-title">Si \xE8 sicuri di voler procedere?</h4>\n    </div>\n    <div class="modal-body">\n      L\'azione, una volta eseguita, non potr\xE0 essere annullata ed il Flusso proseguir\xE0 il suo iter. \n    </div>\n    <div class="modal-footer">\n      <button class="btn btn-default" type="button" ng-click="$dismiss()">Annulla\n        <span class="glyphicon glyphicon-remove"></span>\n      </button>\n      <button data-dismiss="modal" class="btn btn-primary" ng-click="submitTask(picFile); $dismiss()">Invia\n        <span class="glyphicon glyphicon-arrow-right"></span>\n      </button>\n    </div>\n  </div></script>');
$templateCache.put('app/pages/taskCompleted/taskCompleted.html','<div ng-cloak><div class="row"><div class="col-md-3"><div><h4>Ordinamento temporale</h4><div><button class="btn btn-default btn-block margin-top-20" ng-click="vm.order ===  \'ASC\' ?  vm.order=\'DESC\' : vm.order = \'ASC\'"><span class="glyphicon glyphicon-sort"></span> {{vm.order === \'ASC\' ? \'Crescente\' : \'Descrescente\'}}</button></div></div><h4>Tipologie</h4><div id="tipologieDiv"><div><div class="dropdown md-menu-origin"><ui-select ng-model="vm.processDefinitionKey" title="Tipologie" on-select="loadTaskCompleted()"><ui-select-match placeholder="Seleziona la tipologia di flusso" allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="processDefinition.key as processDefinition in wfDefsAll"><span ng-bind-html="processDefinition.name"></span></ui-select-choices></ui-select></div></div></div><br><div><ng-include id="searchFields" src="formUrl"></ng-include></div><br><div><button ng-click="loadTaskCompleted()" class="btn btn-primary">Filtra</button></div></div><div class="col-md-9"><h4>Attivita completate</h4><div ng-repeat="availableFilter in availableFilters"><div class="btn-group btn-group-justified" role="group"><div class="btn-group" role="group" ng-repeat="option in availableFilter.values"><button class="btn btn-default btn-sm" ng-class="{active: completedFilterSelected === option.key}" ng-click="filter(option.key)"><span class="glyphicon glyphicon-calendar"></span> {{option.label}}</button></div></div></div><task-list tasks="vm.taskCompletedForMe" completed="true"></task-list><!--paginazione--><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition(current)"></uib-pagination></div><pre ng-if="isDevelopment">{{vm.taskCompletedForMe | json}}</pre></div></div></div>');
$templateCache.put('app/pages/userMemberships/groupMemberships.html','<div><h2>User Memberships del gruppo {{vm.displayName}}</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="user-membership-new({groupname:vm.groupname, displayName: vm.displayName})"><span class="glyphicon glyphicon-plus"></span> <span translate="sprintApp.userMembership.home.createLabel">Create new User Membership</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="username"><span translate="sprintApp.membership.user">Username</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="grouprole"><span translate="sprintApp.membership.grouprole">Grouprole</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="membership in vm.memberships"><td>{{membership.user.login}}</td><td>{{membership.grouprole}}</td><td class="text-right"><div ng-if="membership.id && vm.modify" class="btn-group flex-btn-group-container"><button ui-sref="userMembershipDelete({id:membership.id, groupname: membership.cnrgroup.name, displayName: membership.cnrgroup.displayName})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/pages/userMemberships/user-membership-new.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMembershipLabel" translate="sprintApp.membership.home.createLabel">Create a Membership</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.membership.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.membership.id" readonly="readonly"></div><div class="form-group"><div id="field_username" class="form-group"><label class="control-label" translate="sprintApp.membership.user" for="field_username">Username</label><typeaheadinput id="field_username" type="flowsUsers" id="rup" ng-model="vm.membership.username" label-model="$parent.vm.data.rup_label" ng-required="true"></typeaheadinput></div></div><div class="form-group"><label class="control-label" translate="sprintApp.membership.groupname" for="field_groupname">Groupname</label><input type="text" class="form-control" name="groupname" id="field_groupname" ng-model="vm.membership.groupname" readonly="readonly" required><div ng-show="editForm.groupname.$invalid"><p class="help-block" ng-show="editForm.groupname.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="sprintApp.membership.grouprole" for="field_grouprole">Grouprole</label><select type="radio" ng-model="vm.membership.grouprole" id="field_grouprole" class="form-control" required><!--todo: abilitare in futuro?--><!--<option value="coordinator">Coordinator</option>--><option value="member">Member</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/pages/userMemberships/userMembership-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.membership.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="sprintApp.membership.delete.question" translate-values="{user: \'{{vm.membership.user.login}}\',\n                              displayName: \'{{vm.membership.cnrgroup.displayName}}\',\n                              grouprole: \'{{vm.membership.grouprole}}\' }">Are you sure you want to delete this Membership?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/pages/userMemberships/userMemberships.html','<div><h2 translate="sprintApp.userMembership.home.title">User Memberships</h2><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="gFroupname"><span translate="sprintApp.membership.groupname">Username</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="grouprole"><span translate="sprintApp.membership.grouprole">Grouprole</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="membership in vm.memberships"><td>{{membership.cnrgroup.displayName}}</td><td>{{membership.grouprole}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><!--IMPORTANTE: Se ho l\'id allora la membership \xE8 nella tabella del Db e posso fare le CRUD (altrimenti \xE8 "derivata" dalle relationship--> <button type="submit" ui-sref="group-memberships({groupname:membership.cnrgroup.name, displayName:membership.cnrgroup.displayName})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button><div ng-if="membership.grouprole == \'coordinator\'"><button type="submit" ui-sref="group-memberships-edit({groupname:membership.cnrgroup.name, displayName:membership.cnrgroup.displayName})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button></div></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();